/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
    [_ in K]?: never;
};
export type Incremental<T> =
    | T
    | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    BigInteger: { input: any; output: any };
    /**
     * The `DateTime` scalar type represents a DateTime
     * value as specified by
     * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
     */
    DateTime: { input: string; output: string };
    /**
     * Allows use of a JSON String for input / output from the GraphQL schema.
     *
     * Use of this type is *not recommended* as you lose the benefits of having a defined, static
     * schema (one of the key benefits of GraphQL).
     */
    JSONString: { input: string; output: string };
    /**
     * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
     * in fields, resolvers and input.
     */
    UUID: { input: string; output: string };
};

export type ActivateSubscription = {
    __typename?: 'ActivateSubscription';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type AirConfig = {
    __typename?: 'AirConfig';
    alarmValue?: Maybe<Scalars['Float']['output']>;
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: Maybe<Scalars['Int']['output']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: Maybe<Scalars['Float']['output']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    /** Particle type */
    particleType?: Maybe<ParticleType>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: Maybe<Scalars['Float']['output']>;
    sensorPk?: Maybe<Scalars['Int']['output']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: Maybe<Scalars['Float']['output']>;
    /** swarm type */
    swarmType?: Maybe<SwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: Maybe<Timezone>;
};

export type AirGeneralPartialConfigCreateInput = {
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: InputMaybe<Scalars['Int']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: InputMaybe<Scalars['Float']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    /** Particle type */
    particleType?: InputMaybe<ParticleType>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: InputMaybe<Scalars['Float']['input']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: InputMaybe<Scalars['Float']['input']>;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: InputMaybe<Timezone>;
};

export type AirGeneralPartialConfigCreatePayload = {
    __typename?: 'AirGeneralPartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AirGeneralPartialConfigUpdateInput = {
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: InputMaybe<Scalars['Int']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: InputMaybe<Scalars['Float']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    /** Particle type */
    particleType?: InputMaybe<ParticleType>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: InputMaybe<Scalars['Float']['input']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: InputMaybe<Scalars['Float']['input']>;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: InputMaybe<Timezone>;
};

export type AirGeneralPartialConfigUpdatePayload = {
    __typename?: 'AirGeneralPartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An object that holds all configurations for an air measuring point. */
export type AirMeasuringPoint = MeasuringPointInterface & {
    __typename?: 'AirMeasuringPoint';
    archived?: Maybe<Scalars['Boolean']['output']>;
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: Maybe<Scalars['Int']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    coordinates?: Maybe<CoordinatesType>;
    /** Unique name of your SWARM Air. This name is placed on the front of the SWARM Air */
    deviceName?: Maybe<Scalars['String']['output']>;
    directShare: Scalars['Boolean']['output'];
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: Maybe<Scalars['Float']['output']>;
    /** Location */
    location?: Maybe<Scalars['String']['output']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    notificationConfig?: Maybe<NotificationConfigObject>;
    /** overridden fields */
    overriddenFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Particle type */
    particleType?: Maybe<ParticleType>;
    pastSensors?: Maybe<Array<Maybe<PastSensorType>>>;
    permission?: Maybe<Permission>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: Maybe<Scalars['Float']['output']>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: Maybe<Scalars['String']['output']>;
    /** Project */
    project?: Maybe<Scalars['ID']['output']>;
    sensor?: Maybe<Sensor>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: Maybe<Scalars['Float']['output']>;
    status: MeasuringPointStatus;
    swarmType: SwarmType;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: Maybe<Timezone>;
};

export type AirMeasuringPointCreateFromExistingMeasuringPointInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing air_measuring_point */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type AirMeasuringPointCreateFromExistingMeasuringPointPayload = {
    __typename?: 'AirMeasuringPointCreateFromExistingMeasuringPointPayload';
    /** The mutated object. */
    airMeasuringPoint?: Maybe<AirMeasuringPoint>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type AirMeasuringPointCreateFromExistingProjectInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing air_project */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type AirMeasuringPointCreateFromExistingProjectPayload = {
    __typename?: 'AirMeasuringPointCreateFromExistingProjectPayload';
    /** The mutated object. */
    airMeasuringPoint?: Maybe<AirMeasuringPoint>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type AirMeasuringPointCreateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: InputMaybe<Scalars['Int']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Unique name of your SWARM Air. This name is placed on the front of the SWARM Air */
    deviceName?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: InputMaybe<Scalars['Float']['input']>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** overridden fields */
    overriddenFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Particle type */
    particleType?: InputMaybe<ParticleType>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: InputMaybe<Scalars['Float']['input']>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Project */
    project?: InputMaybe<Scalars['ID']['input']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<MeasuringPointSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: InputMaybe<Timezone>;
};

export type AirMeasuringPointCreatePayload = {
    __typename?: 'AirMeasuringPointCreatePayload';
    /** The mutated object. */
    airMeasuringPoint?: Maybe<AirMeasuringPoint>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AirMeasuringPointDeleteInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type AirMeasuringPointDeletePayload = {
    __typename?: 'AirMeasuringPointDeletePayload';
    /** The mutated object. */
    airMeasuringPoint?: Maybe<AirMeasuringPoint>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AirMeasuringPointUpdateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: InputMaybe<Scalars['Int']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Unique name of your SWARM Air. This name is placed on the front of the SWARM Air */
    deviceName?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: InputMaybe<Scalars['Float']['input']>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** overridden fields */
    overriddenFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Particle type */
    particleType?: InputMaybe<ParticleType>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: InputMaybe<Scalars['Float']['input']>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Project */
    project?: InputMaybe<Scalars['ID']['input']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<MeasuringPointSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: InputMaybe<Timezone>;
};

export type AirMeasuringPointUpdatePayload = {
    __typename?: 'AirMeasuringPointUpdatePayload';
    /** The mutated object. */
    airMeasuringPoint?: Maybe<AirMeasuringPoint>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AirNotificationPartialConfigCreateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type AirNotificationPartialConfigCreatePayload = {
    __typename?: 'AirNotificationPartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AirNotificationPartialConfigUpdateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type AirNotificationPartialConfigUpdatePayload = {
    __typename?: 'AirNotificationPartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An object that holds all configurations for an air project. */
export type AirProject = ProjectInterface & {
    __typename?: 'AirProject';
    archived?: Maybe<Scalars['Boolean']['output']>;
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: Maybe<Scalars['Int']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: Maybe<Scalars['Float']['output']>;
    /** Location */
    location?: Maybe<Scalars['String']['output']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    name: Scalars['String']['output'];
    notificationConfig?: Maybe<NotificationConfigObject>;
    /** Particle type */
    particleType?: Maybe<ParticleType>;
    permission?: Maybe<Permission>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: Maybe<Scalars['Float']['output']>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: Maybe<Scalars['String']['output']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: Maybe<Scalars['Float']['output']>;
    swarmType: SwarmType;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: Maybe<Timezone>;
};

export type AirProjectCreateFromExistingMeasuringPointInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing air_measuring_point */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type AirProjectCreateFromExistingMeasuringPointPayload = {
    __typename?: 'AirProjectCreateFromExistingMeasuringPointPayload';
    /** The mutated object. */
    airProject?: Maybe<AirProject>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type AirProjectCreateFromExistingProjectInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing air_project */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type AirProjectCreateFromExistingProjectPayload = {
    __typename?: 'AirProjectCreateFromExistingProjectPayload';
    /** The mutated object. */
    airProject?: Maybe<AirProject>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type AirProjectCreateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: InputMaybe<Scalars['Int']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: InputMaybe<Scalars['Float']['input']>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** Particle type */
    particleType?: InputMaybe<ParticleType>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: InputMaybe<Scalars['Float']['input']>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<ProjectSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: InputMaybe<Timezone>;
};

export type AirProjectCreatePayload = {
    __typename?: 'AirProjectCreatePayload';
    /** The mutated object. */
    airProject?: Maybe<AirProject>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AirProjectDeleteInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type AirProjectDeletePayload = {
    __typename?: 'AirProjectDeletePayload';
    /** The mutated object. */
    airProject?: Maybe<AirProject>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AirProjectUpdateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Auto zero interval (seconds). At least 3600 seconds and at most 14400 seconds */
    autoZeroInterval?: InputMaybe<Scalars['Int']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** K-factor. At least 0.001  and at most 10.0  */
    kFactor?: InputMaybe<Scalars['Float']['input']>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** Particle type */
    particleType?: InputMaybe<ParticleType>;
    /** PM2.5 Calculation factor. At least 0.01  and at most 1.0  */
    pm2p5Factor?: InputMaybe<Scalars['Float']['input']>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** RH threshold (percent). At least 0.0 percent and at most 100.0 percent */
    setPointRh?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<ProjectSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Air? */
    timezone?: InputMaybe<Timezone>;
};

export type AirProjectUpdatePayload = {
    __typename?: 'AirProjectUpdatePayload';
    /** The mutated object. */
    airProject?: Maybe<AirProject>;
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type AlarmExceedanceAxis = {
    __typename?: 'AlarmExceedanceAxis';
    fdom?: Maybe<Scalars['Float']['output']>;
    vtop?: Maybe<Scalars['Float']['output']>;
};

export type AlarmExceedanceEntry = {
    __typename?: 'AlarmExceedanceEntry';
    timestamp: Scalars['BigInteger']['output'];
    vector?: Maybe<AlarmExceedanceAxis>;
    x?: Maybe<AlarmExceedanceAxis>;
    y?: Maybe<AlarmExceedanceAxis>;
    z?: Maybe<AlarmExceedanceAxis>;
};

export type AlarmExceedances = {
    __typename?: 'AlarmExceedances';
    alarms: Array<Maybe<AlarmSummaryEntry>>;
    entries: Array<Maybe<AlarmExceedanceEntry>>;
    isFlatLine: Scalars['Boolean']['output'];
    limitReached: Scalars['Boolean']['output'];
    limitReachedValue?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum AlarmInterval {
    Interval_1Hour = 'interval_1_hour',
    Interval_4Hours = 'interval_4_hours',
    Interval_8Hours = 'interval_8_hours',
    Interval_10Minutes = 'interval_10_minutes',
    Interval_15Minutes = 'interval_15_minutes',
    Interval_24Hours = 'interval_24_hours',
    Interval_30Minutes = 'interval_30_minutes',
}

export type AlarmLine = {
    __typename?: 'AlarmLine';
    error: Scalars['Boolean']['output'];
    isFlatLine: Scalars['Boolean']['output'];
    line?: Maybe<Array<Maybe<AlarmPoint>>>;
    validOverride: Scalars['Boolean']['output'];
};

export type AlarmPoint = {
    __typename?: 'AlarmPoint';
    freq?: Maybe<Scalars['Float']['output']>;
    vkar?: Maybe<Scalars['Float']['output']>;
};

export type AlarmSchedule = {
    __typename?: 'AlarmSchedule';
    concentrationAlarms?: Maybe<Array<Maybe<ConcentrationAlarm>>>;
    endDay?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['Int']['output']>;
    leqAlarms?: Maybe<Array<Maybe<LeqAlarm>>>;
    maxAlarms?: Maybe<Array<Maybe<MaxAlarm>>>;
    startDay?: Maybe<Scalars['Int']['output']>;
    startTime?: Maybe<Scalars['Int']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type AlarmScheduleInput = {
    concentrationAlarms?: InputMaybe<Array<InputMaybe<ConcentrationAlarmInput>>>;
    endDay?: InputMaybe<Scalars['Int']['input']>;
    endTime?: InputMaybe<Scalars['Int']['input']>;
    leqAlarms?: InputMaybe<Array<InputMaybe<LeqAlarmInput>>>;
    maxAlarms?: InputMaybe<Array<InputMaybe<MaxAlarmInput>>>;
    startDay?: InputMaybe<Scalars['Int']['input']>;
    startTime?: InputMaybe<Scalars['Int']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type AlarmSummaryEntry = {
    __typename?: 'AlarmSummaryEntry';
    counts: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    triggerMm: Scalars['Float']['output'];
    triggerPct: Scalars['Float']['output'];
};

export type AppendAttributeImages = {
    __typename?: 'AppendAttributeImages';
    attributeEntry?: Maybe<AttributeEntryInterface>;
};

export type Atop = {
    __typename?: 'Atop';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    vector?: Maybe<Scalars['Float']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

export type AttributeAsset = {
    __typename?: 'AttributeAsset';
    caption: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    sortOrder?: Maybe<Scalars['Int']['output']>;
    url: Scalars['String']['output'];
};

export type AttributeEntryInterface = {
    definitionId: Scalars['ID']['output'];
    isSystem: Scalars['Boolean']['output'];
    key: Scalars['String']['output'];
    label: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    valueType: AttributeValueType;
};

export enum AttributeValueType {
    Image = 'IMAGE',
    ImageList = 'IMAGE_LIST',
    Text = 'TEXT',
}

export enum AttributesEntityType {
    MeasuringPoint = 'MEASURING_POINT',
    Project = 'PROJECT',
    User = 'USER',
}

export type BucketInterface = {
    timespan?: Maybe<TimeSpan>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum BuildingLevel {
    Osmre_1983 = 'OSMRE_1983',
    UsbmRi8507Drywall = 'USBM_RI8507_drywall',
    UsbmRi8507Plaster = 'USBM_RI8507_plaster',
    BuildingClass1 = 'buildingClass1',
    BuildingClass2 = 'buildingClass2',
    BuildingClass3 = 'buildingClass3',
    BuildingClass4 = 'buildingClass4',
    BuildingClass5 = 'buildingClass5',
    DinFoundation = 'dinFoundation',
    FloorSlabs = 'floorSlabs',
    Foundation = 'foundation',
    FreshConcrete = 'freshConcrete',
    GuidelineValues = 'guidelineValues',
    HeavyStructures = 'heavyStructures',
    HighestFloor = 'highestFloor',
    IndustrialAndOfficeBuildings = 'industrialAndOfficeBuildings',
    LowerLevel = 'lowerLevel',
    Pipeline = 'pipeline',
    ResidentialBuildings = 'residentialBuildings',
    SelfDefined = 'selfDefined',
    SensitiveBuildings = 'sensitiveBuildings',
    Structure = 'structure',
    UndergroundCavities = 'undergroundCavities',
    Unspecified = 'unspecified',
}

/** An enumeration. */
export enum BuildingState {
    Normal = 'normal',
    Sensitive = 'sensitive',
}

/** An enumeration. */
export enum Category {
    Cat1 = 'CAT1',
    Cat2 = 'CAT2',
    Cat3 = 'CAT3',
}

export type ConcentrationAlarm = {
    __typename?: 'ConcentrationAlarm';
    alarmLevel?: Maybe<Scalars['Float']['output']>;
    interval?: Maybe<AlarmInterval>;
    key?: Maybe<Scalars['String']['output']>;
    particleType?: Maybe<ParticleType>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ConcentrationAlarmInput = {
    alarmLevel?: InputMaybe<Scalars['Float']['input']>;
    interval?: InputMaybe<AlarmInterval>;
    key?: InputMaybe<Scalars['String']['input']>;
    particleType?: InputMaybe<ParticleType>;
    title?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum ConcreteSettingLevel {
    LessThan2hours = 'lessThan2hours',
    LessThan10MPa = 'lessThan10MPa',
    MoreThan15MPa = 'moreThan15MPa',
    Rc10MPaTo15MPa = 'rc10MPaTo15MPa',
}

/** An enumeration. */
export enum ConstructionType {
    DesignClass1 = 'designClass1',
    DesignClass2 = 'designClass2',
    DesignClass3 = 'designClass3',
    PlatformAndCatenaryPost = 'platformAndCatenaryPost',
    ResistantConstruction = 'resistantConstruction',
    SensitiveConstruction = 'sensitiveConstruction',
    StructureType1 = 'structureType1',
    StructureType2 = 'structureType2',
    StructureType3 = 'structureType3',
    VerySensitiveConstruction = 'verySensitiveConstruction',
}

export type ContactType = Node & {
    __typename?: 'ContactType';
    createdAt: Scalars['DateTime']['output'];
    email: Scalars['String']['output'];
    emailVerificationStatus: VerificationStatus;
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    phoneNumber: Scalars['String']['output'];
    phoneVerificationStatus: VerificationStatus;
};

export type ContactTypeConnection = {
    __typename?: 'ContactTypeConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<ContactTypeEdge>>;
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    /** The total count of objects in this query. */
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ContactType` and its cursor. */
export type ContactTypeEdge = {
    __typename?: 'ContactTypeEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<ContactType>;
};

export type ConversionBlocker = {
    __typename?: 'ConversionBlocker';
    code: Scalars['String']['output'];
    item: Scalars['String']['output'];
    message: Scalars['String']['output'];
};

export type ConversionItem = {
    __typename?: 'ConversionItem';
    dependencies: Array<Maybe<Scalars['String']['output']>>;
    entityId: Scalars['ID']['output'];
    entityType: Scalars['String']['output'];
    name: Scalars['String']['output'];
};

export type ConvertPersonalAccountToOrganization = {
    __typename?: 'ConvertPersonalAccountToOrganization';
    organization: Organization;
};

export type CoordinatesType = {
    __typename?: 'CoordinatesType';
    latitude: Scalars['Float']['output'];
    longitude: Scalars['Float']['output'];
};

export type CreateAttributeDefinition = {
    __typename?: 'CreateAttributeDefinition';
    attributeEntry?: Maybe<AttributeEntryInterface>;
};

export type CreateContactInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactPayload = {
    __typename?: 'CreateContactPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** The mutated object. */
    contact?: Maybe<ContactType>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type CreateGraphReport = {
    __typename?: 'CreateGraphReport';
    graphReport?: Maybe<GraphReportType>;
};

export type CreateMeasuringPointComment = {
    __typename?: 'CreateMeasuringPointComment';
    measuringPointComment?: Maybe<MeasuringPointCommentType>;
};

export type CreateOrganization = {
    __typename?: 'CreateOrganization';
    organization: Organization;
};

export type CreateReportTemplate = {
    __typename?: 'CreateReportTemplate';
    reportTemplate?: Maybe<ReportTemplateType>;
};

export type CustomAlarmCreateMutationInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    points: Array<InputMaybe<CustomAlarmPointInput>>;
};

export type CustomAlarmCreateMutationPayload = {
    __typename?: 'CustomAlarmCreateMutationPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** The mutated object. */
    customAlarm?: Maybe<CustomAlarmType>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type CustomAlarmDeleteMutationInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type CustomAlarmDeleteMutationPayload = {
    __typename?: 'CustomAlarmDeleteMutationPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** The mutated object. */
    customAlarm?: Maybe<CustomAlarmType>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type CustomAlarmPointInput = {
    freq?: InputMaybe<Scalars['Float']['input']>;
    vkar?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomAlarmType = Node & {
    __typename?: 'CustomAlarmType';
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    pk?: Maybe<Scalars['ID']['output']>;
    points?: Maybe<Array<Maybe<AlarmPoint>>>;
};

export type CustomAlarmTypeConnection = {
    __typename?: 'CustomAlarmTypeConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<CustomAlarmTypeEdge>>;
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    /** The total count of objects in this query. */
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomAlarmType` and its cursor. */
export type CustomAlarmTypeEdge = {
    __typename?: 'CustomAlarmTypeEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<CustomAlarmType>;
};

export type CustomAlarmUpdateMutationInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    points: Array<InputMaybe<CustomAlarmPointInput>>;
};

export type CustomAlarmUpdateMutationPayload = {
    __typename?: 'CustomAlarmUpdateMutationPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** The mutated object. */
    customAlarm?: Maybe<CustomAlarmType>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type DailyValue = {
    __typename?: 'DailyValue';
    date?: Maybe<Scalars['String']['output']>;
    lXEq?: Maybe<Scalars['Float']['output']>;
    timeSpan?: Maybe<TimeSpan>;
};

export type DailyValueSettings = {
    __typename?: 'DailyValueSettings';
    timeSettings?: Maybe<DailyValueTimeSettings>;
    triggers?: Maybe<Array<Maybe<DailyValueTrigger>>>;
};

export type DailyValueSettingsInput = {
    timeSettings?: InputMaybe<DailyValueTimeSettingsInput>;
    triggers?: InputMaybe<Array<InputMaybe<DailyValueTriggerInput>>>;
};

export type DailyValueTimeSettings = {
    __typename?: 'DailyValueTimeSettings';
    end: Scalars['String']['output'];
    start: Scalars['String']['output'];
};

export type DailyValueTimeSettingsInput = {
    end: Scalars['String']['input'];
    start: Scalars['String']['input'];
};

export type DailyValueTrigger = {
    __typename?: 'DailyValueTrigger';
    days: Scalars['Int']['output'];
    trigger: Scalars['Int']['output'];
};

export type DailyValueTriggerInput = {
    days: Scalars['Int']['input'];
    trigger: Scalars['Int']['input'];
};

export type DailyValues = {
    __typename?: 'DailyValues';
    settings?: Maybe<DailyValueSettings>;
    timeSpan?: Maybe<TimeSpan>;
    values?: Maybe<Array<Maybe<DailyValue>>>;
};

/** An enumeration. */
export enum DataTab {
    Atop = 'ATOP',
    DailyValues = 'DAILY_VALUES',
    Fdom = 'FDOM',
    Flow = 'FLOW',
    Lden = 'LDEN',
    Lxeq = 'LXEQ',
    Lxn = 'LXN',
    Lxpeak = 'LXPEAK',
    Lxtmax = 'LXTMAX',
    Pm2P5 = 'PM2P5',
    Pm10 = 'PM10',
    Rh = 'RH',
    Temp = 'TEMP',
    Vdv = 'VDV',
    Veff = 'VEFF',
    Vtop = 'VTOP',
}

export enum DataType {
    Atop = 'ATOP',
    DailyValues = 'DAILY_VALUES',
    Fdom = 'FDOM',
    Flow = 'FLOW',
    Lden = 'LDEN',
    Lxeq = 'LXEQ',
    Lxn = 'LXN',
    Lxpeak = 'LXPEAK',
    Lxtmax = 'LXTMAX',
    Pm2P5 = 'PM2P5',
    Pm10 = 'PM10',
    Rh = 'RH',
    Temp = 'TEMP',
    Vdv = 'VDV',
    Veff = 'VEFF',
    Vtop = 'VTOP',
}

export type DataWarningDeviceType = {
    __typename?: 'DataWarningDeviceType';
    deviceName: Scalars['String']['output'];
    isLimit: Scalars['Boolean']['output'];
    measuringPointId: Scalars['ID']['output'];
    usagePercentage: Scalars['Float']['output'];
};

export type DataWarningGroupType = {
    __typename?: 'DataWarningGroupType';
    count: Scalars['Int']['output'];
    devices: Array<DataWarningDeviceType>;
};

export type DeleteAttributeAsset = {
    __typename?: 'DeleteAttributeAsset';
    attributeEntry?: Maybe<AttributeEntryInterface>;
};

export type DeleteContactInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type DeleteContactPayload = {
    __typename?: 'DeleteContactPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** The mutated object. */
    contact?: Maybe<ContactType>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type DeleteMeasuringPointComment = {
    __typename?: 'DeleteMeasuringPointComment';
    measuringPointComment?: Maybe<MeasuringPointCommentType>;
};

export type DeleteReportTemplate = {
    __typename?: 'DeleteReportTemplate';
    inUse?: Maybe<ReportTemplateInUse>;
    reportTemplate?: Maybe<ReportTemplateType>;
};

export type DetachSensorFromMeasuringPoint = {
    __typename?: 'DetachSensorFromMeasuringPoint';
    measuringPoint?: Maybe<MeasuringPointInterface>;
};

/** An enumeration. */
export enum DownloadCategory {
    DataExport = 'DATA_EXPORT',
    Report = 'REPORT',
}

export type DuplicateReportTemplate = {
    __typename?: 'DuplicateReportTemplate';
    reportTemplate?: Maybe<ReportTemplateType>;
};

export type Dust = {
    __typename?: 'Dust';
    config?: Maybe<SwarmConfig>;
    containsPm2p51m?: Maybe<Scalars['Boolean']['output']>;
    containsPm2p515m?: Maybe<Scalars['Boolean']['output']>;
    containsPm2p560m?: Maybe<Scalars['Boolean']['output']>;
    containsPm2p51440m?: Maybe<Scalars['Boolean']['output']>;
    containsPm101m?: Maybe<Scalars['Boolean']['output']>;
    containsPm1015m?: Maybe<Scalars['Boolean']['output']>;
    containsPm1060m?: Maybe<Scalars['Boolean']['output']>;
    containsPm101440m?: Maybe<Scalars['Boolean']['output']>;
    pm2p51m?: Maybe<Scalars['Float']['output']>;
    pm2p515m?: Maybe<Scalars['Float']['output']>;
    pm2p560m?: Maybe<Scalars['Float']['output']>;
    pm2p51440m?: Maybe<Scalars['Float']['output']>;
    pm101m?: Maybe<Scalars['Float']['output']>;
    pm1015m?: Maybe<Scalars['Float']['output']>;
    pm1060m?: Maybe<Scalars['Float']['output']>;
    pm101440m?: Maybe<Scalars['Float']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
};

export type DustMeta = {
    __typename?: 'DustMeta';
    config?: Maybe<SwarmConfig>;
    flow?: Maybe<Scalars['Float']['output']>;
    relativeHumidity?: Maybe<Scalars['Float']['output']>;
    temperature?: Maybe<Scalars['Float']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
};

export enum DustType {
    Pm2P5_1Minute = 'PM2P5_1_MINUTE',
    Pm2P5_15Minute = 'PM2P5_15_MINUTE',
    Pm2P5_60Minute = 'PM2P5_60_MINUTE',
    Pm2P5_1440Minute = 'PM2P5_1440_MINUTE',
    Pm10_1Minute = 'PM10_1_MINUTE',
    Pm10_15Minute = 'PM10_15_MINUTE',
    Pm10_60Minute = 'PM10_60_MINUTE',
    Pm10_1440Minute = 'PM10_1440_MINUTE',
}

export enum EntityType {
    CustomAlarm = 'CUSTOM_ALARM',
    MeasuringPoint = 'MEASURING_POINT',
    Project = 'PROJECT',
    ReportTemplate = 'REPORT_TEMPLATE',
    User = 'USER',
}

export type EventInterface = {
    name?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type EventLastRecord = EventInterface & {
    __typename?: 'EventLastRecord';
    name?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    uploading?: Maybe<Scalars['String']['output']>;
};

export type EventServerContact = EventInterface & {
    __typename?: 'EventServerContact';
    name?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    uploading?: Maybe<Scalars['String']['output']>;
};

export type EventStart = EventInterface & {
    __typename?: 'EventStart';
    config?: Maybe<SwarmConfig>;
    name?: Maybe<Scalars['String']['output']>;
    startMessage?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type EventStop = EventInterface & {
    __typename?: 'EventStop';
    name?: Maybe<Scalars['String']['output']>;
    stopCause?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ExternalApiTarget {
    NewYorkApi = 'newYorkApi',
    NoExternalApi = 'noExternalApi',
}

export type Fdom = {
    __typename?: 'Fdom';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    vector?: Maybe<Scalars['Float']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum FileType {
    Csv = 'csv',
    Pdf = 'pdf',
    Xlsx = 'xlsx',
}

/** An enumeration. */
export enum FoundationType {
    FoundationOnOrInSoil = 'foundationOnOrInSoil',
    FoundationOnRock = 'foundationOnRock',
}

/** An enumeration. */
export enum FrequencyClass {
    Frequently = 'frequently',
    Occasionally = 'occasionally',
    Often = 'often',
    Permanent = 'permanent',
    Rarely = 'rarely',
    Repetitive = 'repetitive',
}

/** An enumeration. */
export enum FrequencyGraphScaleType {
    Auto = 'AUTO',
    Linear = 'LINEAR',
    Logarithmic = 'LOGARITHMIC',
}

/** An enumeration. */
export enum FrequencyWeighting {
    FrequencyWeightingA = 'frequencyWeightingA',
    FrequencyWeightingB = 'frequencyWeightingB',
    FrequencyWeightingC = 'frequencyWeightingC',
    FrequencyWeightingZ = 'frequencyWeightingZ',
}

export type GraphReportType = Node & {
    __typename?: 'GraphReportType';
    category?: Maybe<DownloadCategory>;
    fileType?: Maybe<Scalars['String']['output']>;
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    lastDownloaded?: Maybe<Scalars['DateTime']['output']>;
    name: Scalars['String']['output'];
    /** Size in bytes. */
    size?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<ReportStatus>;
    url?: Maybe<Scalars['String']['output']>;
};

export type GraphReportTypeConnection = {
    __typename?: 'GraphReportTypeConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<GraphReportTypeEdge>>;
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    /** The count of ready reports that belong to the current user. */
    readyReportsCount?: Maybe<Scalars['Int']['output']>;
    /** The total count of objects in this query. */
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `GraphReportType` and its cursor. */
export type GraphReportTypeEdge = {
    __typename?: 'GraphReportTypeEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<GraphReportType>;
};

/** An enumeration. */
export enum GraphType {
    Bar = 'BAR',
    Dot = 'DOT',
    Line = 'LINE',
    Step = 'STEP',
}

/** An enumeration. */
export enum GroundCondition {
    DenseMoraineAndCompactedFillOver2m = 'denseMoraineAndCompactedFillOver2m',
    Rock = 'rock',
    Soil = 'soil',
}

/** An enumeration. */
export enum GuideLine {
    Bs7385_250Hz = 'BS7385_250Hz',
    Circulaire86 = 'Circulaire86',
    Din4150_2 = 'DIN4150_2',
    Din4150_3_80Hz = 'DIN4150_3_80Hz',
    Din4150_3_315Hz = 'DIN4150_3_315Hz',
    In1226 = 'IN1226',
    Isee_250Hz = 'ISEE_250Hz',
    Ns_8141_1_2022 = 'NS_8141_1_2022',
    OnormS_9020 = 'ONORM_S_9020',
    SbrA_2010 = 'SBR_A_2010',
    SbrA_2017 = 'SBR_A_2017',
    SbrB_2002 = 'SBR_B_2002',
    Sn640312a = 'SN640312a',
    Ss_025211 = 'SS_025211',
    Ss_4604861 = 'SS_4604861',
    Une_22_381_93 = 'UNE_22_381_93',
}

export type HighestVtopEntries = {
    __typename?: 'HighestVtopEntries';
    entries?: Maybe<Array<Maybe<HighestVtopEntry>>>;
    vectorEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type HighestVtopEntry = {
    __typename?: 'HighestVtopEntry';
    datetime?: Maybe<Scalars['String']['output']>;
    fdom?: Maybe<Fdom>;
    percentage?: Maybe<Percentage>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    vtop?: Maybe<Vtop>;
};

export type HighestVtopPerDayEntries = {
    __typename?: 'HighestVtopPerDayEntries';
    entries?: Maybe<Array<Maybe<SingleAxisEntry>>>;
};

export type ImageAttributeEntry = AttributeEntryInterface & {
    __typename?: 'ImageAttributeEntry';
    definitionId: Scalars['ID']['output'];
    image?: Maybe<AttributeAsset>;
    isSystem: Scalars['Boolean']['output'];
    key: Scalars['String']['output'];
    label: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    valueType: AttributeValueType;
};

export type ImageListAttributeEntry = AttributeEntryInterface & {
    __typename?: 'ImageListAttributeEntry';
    definitionId: Scalars['ID']['output'];
    imageList: Array<AttributeAsset>;
    isSystem: Scalars['Boolean']['output'];
    key: Scalars['String']['output'];
    label: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    valueType: AttributeValueType;
};

export enum InviteStatus {
    Accepted = 'ACCEPTED',
    Pending = 'PENDING',
}

export type KbfTrBucket = BucketInterface & {
    __typename?: 'KBFTrBucket';
    limits?: Maybe<VperLimits>;
    period?: Maybe<VperPeriod>;
    periodCompleteness?: Maybe<VperPeriodCompleteness>;
    timespan?: Maybe<TimeSpan>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    vmax?: Maybe<Vmax>;
    vper?: Maybe<Vper>;
};

/** An enumeration. */
export enum KbfRailTraffic {
    SurfaceNonUrban = 'surfaceNonUrban',
    SurfaceUrban = 'surfaceUrban',
    Underground = 'underground',
}

/** An enumeration. */
export enum KbfSource {
    Construction = 'construction',
    InfrequentShortTerm = 'infrequentShortTerm',
    RailTraffic = 'railTraffic',
    RoadTraffic = 'roadTraffic',
}

/** An enumeration. */
export enum KbfVibrationLevel {
    Level1 = 'level1',
    Level2 = 'level2',
    Level3 = 'level3',
}

export type LxEq = {
    __typename?: 'LXEq';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

export type Lxn = {
    __typename?: 'LXN';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    value?: Maybe<Array<Maybe<LxnValue>>>;
};

export type LxnValue = {
    __typename?: 'LXNValue';
    timePercent?: Maybe<Scalars['Int']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

export type LxPeak = {
    __typename?: 'LXPeak';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum LXnInterval {
    Interval1Hour = 'interval1Hour',
    Interval1Minute = 'interval1Minute',
    Interval1Second = 'interval1Second',
    Interval5Minutes = 'interval5Minutes',
    Interval5Seconds = 'interval5Seconds',
    Interval10Minutes = 'interval10Minutes',
    Interval15Minutes = 'interval15Minutes',
    Interval15Seconds = 'interval15Seconds',
    Interval20Minutes = 'interval20Minutes',
    Interval30Minutes = 'interval30Minutes',
    Interval30Seconds = 'interval30Seconds',
    IntervalDisabled = 'intervalDisabled',
}

export type LXtMax = {
    __typename?: 'LXtMax';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

export type LXtMin = {
    __typename?: 'LXtMin';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum LXtMinMaxInterval {
    Interval1Hour = 'interval1Hour',
    Interval1Minute = 'interval1Minute',
    Interval1Second = 'interval1Second',
    Interval5Minutes = 'interval5Minutes',
    Interval5Seconds = 'interval5Seconds',
    Interval10Minutes = 'interval10Minutes',
    Interval15Minutes = 'interval15Minutes',
    Interval15Seconds = 'interval15Seconds',
    Interval20Minutes = 'interval20Minutes',
    Interval30Minutes = 'interval30Minutes',
    Interval30Seconds = 'interval30Seconds',
    IntervalDisabled = 'intervalDisabled',
}

export type LastGraphStateType = {
    __typename?: 'LastGraphStateType';
    endTime?: Maybe<Scalars['BigInteger']['output']>;
    measuringPointIds: Array<Scalars['ID']['output']>;
    startTime?: Maybe<Scalars['BigInteger']['output']>;
};

export type LdenPeriod = {
    __typename?: 'LdenPeriod';
    timeSpan?: Maybe<TimeSpan>;
    timeWindow?: Maybe<LdenScheduleObject>;
    value?: Maybe<Scalars['Float']['output']>;
};

export type LdenSchedule = {
    __typename?: 'LdenSchedule';
    alarmLevel?: Maybe<Scalars['Float']['output']>;
    correction?: Maybe<Scalars['Float']['output']>;
    endDay?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    startDay?: Maybe<Scalars['Int']['output']>;
    startTime?: Maybe<Scalars['Int']['output']>;
    warningLevel?: Maybe<Scalars['Float']['output']>;
};

export type LdenScheduleInput = {
    alarmLevel?: InputMaybe<Scalars['Float']['input']>;
    correction?: InputMaybe<Scalars['Float']['input']>;
    endDay?: InputMaybe<Scalars['Int']['input']>;
    endTime?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    startDay?: InputMaybe<Scalars['Int']['input']>;
    startTime?: InputMaybe<Scalars['Int']['input']>;
    warningLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type LdenScheduleObject = {
    __typename?: 'LdenScheduleObject';
    alarmLevel?: Maybe<Scalars['Float']['output']>;
    correction?: Maybe<Scalars['Float']['output']>;
    endDay?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    startDay?: Maybe<Scalars['Int']['output']>;
    startTime?: Maybe<Scalars['Int']['output']>;
    warningLevel?: Maybe<Scalars['Float']['output']>;
};

export type LdenValues = {
    __typename?: 'LdenValues';
    settings?: Maybe<Array<Maybe<LdenScheduleObject>>>;
    timeSpan?: Maybe<TimeSpan>;
    values?: Maybe<Array<Maybe<LdenPeriod>>>;
};

export type LeqAlarm = {
    __typename?: 'LeqAlarm';
    alarmLevel?: Maybe<Scalars['Float']['output']>;
    interval?: Maybe<AlarmInterval>;
    key?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type LeqAlarmExceedances = {
    __typename?: 'LeqAlarmExceedances';
    alarms: Array<Maybe<LeqAlarmSummaryRow>>;
    entries: Array<Maybe<LeqAlarmRow>>;
    limitReachedValue?: Maybe<Scalars['Int']['output']>;
};

export type LeqAlarmInput = {
    alarmLevel?: InputMaybe<Scalars['Float']['input']>;
    interval?: InputMaybe<AlarmInterval>;
    key?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type LeqAlarmRow = {
    __typename?: 'LeqAlarmRow';
    alarmInterval?: Maybe<Scalars['Int']['output']>;
    alarmLevel?: Maybe<Scalars['Float']['output']>;
    endTime?: Maybe<Scalars['BigInteger']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    startTime?: Maybe<Scalars['BigInteger']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

export type LeqAlarmSummaryRow = {
    __typename?: 'LeqAlarmSummaryRow';
    alarmInterval: Scalars['Int']['output'];
    alarmLevel: Scalars['Float']['output'];
    counts: Scalars['Int']['output'];
    name: Scalars['String']['output'];
};

export type LeqAlarmTable = {
    __typename?: 'LeqAlarmTable';
    data?: Maybe<Array<Maybe<LeqAlarmRow>>>;
};

/** An enumeration. */
export enum LiningMaterial {
    AeratedConcreteAndDelicateDetails = 'aeratedConcreteAndDelicateDetails',
    ConcreteAndStone = 'concreteAndStone',
    Masonry = 'masonry',
    MaterialClass1 = 'materialClass1',
    MaterialClass2 = 'materialClass2',
    MaterialClass3 = 'materialClass3',
    MaterialClass4 = 'materialClass4',
    ReinforcedConcreteAndTubing = 'reinforcedConcreteAndTubing',
    ReinforcedConcreteSteelWood = 'reinforcedConcreteSteelWood',
    UnreinforcedConcreteBrickEtc = 'unreinforcedConcreteBrickEtc',
}

export type LmaxAlarmExceedances = {
    __typename?: 'LmaxAlarmExceedances';
    alarms: Array<Maybe<LmaxAlarmSummaryRow>>;
    entries: Array<Maybe<LmaxAlarmRow>>;
    limitReachedValue?: Maybe<Scalars['Int']['output']>;
};

export type LmaxAlarmRow = {
    __typename?: 'LmaxAlarmRow';
    alarmLevel: Scalars['Float']['output'];
    endTime: Scalars['BigInteger']['output'];
    name: Scalars['String']['output'];
    startTime: Scalars['BigInteger']['output'];
    value: Scalars['Float']['output'];
};

export type LmaxAlarmSummaryRow = {
    __typename?: 'LmaxAlarmSummaryRow';
    alarmLevel: Scalars['Float']['output'];
    counts: Scalars['Int']['output'];
    name: Scalars['String']['output'];
};

/** An enumeration. */
export enum LxEqInterval {
    Interval1Hour = 'interval1Hour',
    Interval1Minute = 'interval1Minute',
    Interval1Second = 'interval1Second',
    Interval5Minutes = 'interval5Minutes',
    Interval5Seconds = 'interval5Seconds',
    Interval10Minutes = 'interval10Minutes',
    Interval15Minutes = 'interval15Minutes',
    Interval15Seconds = 'interval15Seconds',
    Interval20Minutes = 'interval20Minutes',
    Interval30Minutes = 'interval30Minutes',
    Interval30Seconds = 'interval30Seconds',
    IntervalDisabled = 'intervalDisabled',
}

/** An enumeration. */
export enum LxPeakInterval {
    Interval1Hour = 'interval1Hour',
    Interval1Minute = 'interval1Minute',
    Interval1Second = 'interval1Second',
    Interval5Minutes = 'interval5Minutes',
    Interval5Seconds = 'interval5Seconds',
    Interval10Minutes = 'interval10Minutes',
    Interval15Minutes = 'interval15Minutes',
    Interval15Seconds = 'interval15Seconds',
    Interval20Minutes = 'interval20Minutes',
    Interval30Minutes = 'interval30Minutes',
    Interval30Seconds = 'interval30Seconds',
    IntervalDisabled = 'intervalDisabled',
}

export type LxnValueRow = {
    __typename?: 'LxnValueRow';
    l10?: Maybe<Scalars['Float']['output']>;
    l50?: Maybe<Scalars['Float']['output']>;
    l90?: Maybe<Scalars['Float']['output']>;
    timestamp: Scalars['BigInteger']['output'];
};

export type LxnValues = {
    __typename?: 'LxnValues';
    values: Array<LxnValueRow>;
};

export type MapMarkerPageType = {
    __typename?: 'MapMarkerPageType';
    hasMore: Scalars['Boolean']['output'];
    markers: Array<MapMarkerType>;
};

export type MapMarkerType = {
    __typename?: 'MapMarkerType';
    latitude: Scalars['Float']['output'];
    longitude: Scalars['Float']['output'];
    measuringPointId: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    ownerUserId: Scalars['Int']['output'];
};

/** An enumeration. */
export enum MapScope {
    Admin = 'ADMIN',
    User = 'USER',
}

export type MaxAlarm = {
    __typename?: 'MaxAlarm';
    alarmLevel?: Maybe<Scalars['Float']['output']>;
    key?: Maybe<Scalars['String']['output']>;
    smsTemplate?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type MaxAlarmInput = {
    alarmLevel?: InputMaybe<Scalars['Float']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    smsTemplate?: InputMaybe<Scalars['String']['input']>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type MeasurementSettingEntry = {
    __typename?: 'MeasurementSettingEntry';
    name: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type MeasuringPointCommentType = {
    __typename?: 'MeasuringPointCommentType';
    createdAt: Scalars['DateTime']['output'];
    dataType?: Maybe<DataType>;
    editedAt?: Maybe<Scalars['DateTime']['output']>;
    endTime?: Maybe<Scalars['BigInteger']['output']>;
    id: Scalars['ID']['output'];
    measuringPointId?: Maybe<Scalars['ID']['output']>;
    modifiedAt: Scalars['DateTime']['output'];
    parentId?: Maybe<Scalars['ID']['output']>;
    replies: Array<MeasuringPointCommentType>;
    startTime?: Maybe<Scalars['BigInteger']['output']>;
    text: Scalars['String']['output'];
    user?: Maybe<UserType>;
};

export type MeasuringPointInterface = {
    archived?: Maybe<Scalars['Boolean']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    directShare: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    privateNotes?: Maybe<Scalars['String']['output']>;
    status: MeasuringPointStatus;
    swarmType: SwarmType;
};

/** An enumeration. */
export enum MeasuringPointSensorAction {
    Restart = 'RESTART',
    Rotate = 'ROTATE',
}

/** An enumeration. */
export enum MeasuringPointStatus {
    DownloadingUpdate = 'DOWNLOADING_UPDATE',
    Inactive = 'INACTIVE',
    Offline = 'OFFLINE',
    Online = 'ONLINE',
    OutOfData = 'OUT_OF_DATA',
    UpdateReady = 'UPDATE_READY',
}

/** An enumeration. */
export enum MeasuringPointSwarmType {
    /** vibration */
    A_1 = 'A_1',
    /** air */
    A_2 = 'A_2',
    /** sound */
    A_3 = 'A_3',
}

/** An enumeration. */
export enum MeasuringSchedule {
    EntireDay = 'entireDay',
    LdenTimeSettings = 'ldenTimeSettings',
    LegacySettings = 'legacySettings',
}

/** An enumeration. */
export enum MeasuringType {
    Extensive = 'extensive',
    Indicative = 'indicative',
    Limited = 'limited',
}

export type Mutation = {
    __typename?: 'Mutation';
    ShareCreate?: Maybe<ShareCreate>;
    ShareDelete?: Maybe<ShareDelete>;
    ShareUpdate?: Maybe<ShareUpdate>;
    activateSubscription?: Maybe<ActivateSubscription>;
    airGeneralPartialConfigCreate?: Maybe<AirGeneralPartialConfigCreatePayload>;
    airGeneralPartialConfigUpdate?: Maybe<AirGeneralPartialConfigUpdatePayload>;
    airMeasuringPointCreate?: Maybe<AirMeasuringPointCreatePayload>;
    airMeasuringPointCreateFromExistingMeasuringPoint?: Maybe<AirMeasuringPointCreateFromExistingMeasuringPointPayload>;
    airMeasuringPointCreateFromExistingProject?: Maybe<AirMeasuringPointCreateFromExistingProjectPayload>;
    airMeasuringPointDelete?: Maybe<AirMeasuringPointDeletePayload>;
    airMeasuringPointUpdate?: Maybe<AirMeasuringPointUpdatePayload>;
    airNotificationPartialConfigCreate?: Maybe<AirNotificationPartialConfigCreatePayload>;
    airNotificationPartialConfigUpdate?: Maybe<AirNotificationPartialConfigUpdatePayload>;
    airProjectCreate?: Maybe<AirProjectCreatePayload>;
    airProjectCreateFromExistingMeasuringPoint?: Maybe<AirProjectCreateFromExistingMeasuringPointPayload>;
    airProjectCreateFromExistingProject?: Maybe<AirProjectCreateFromExistingProjectPayload>;
    airProjectDelete?: Maybe<AirProjectDeletePayload>;
    airProjectUpdate?: Maybe<AirProjectUpdatePayload>;
    appendAttributeImages?: Maybe<AppendAttributeImages>;
    convertPersonalAccountToOrganization?: Maybe<ConvertPersonalAccountToOrganization>;
    createAttributeDefinition?: Maybe<CreateAttributeDefinition>;
    createContact?: Maybe<CreateContactPayload>;
    createGraphReport?: Maybe<CreateGraphReport>;
    createMeasuringPointComment?: Maybe<CreateMeasuringPointComment>;
    createOrganization?: Maybe<CreateOrganization>;
    createReportTemplate?: Maybe<CreateReportTemplate>;
    customAlarmCreate?: Maybe<CustomAlarmCreateMutationPayload>;
    customAlarmDelete?: Maybe<CustomAlarmDeleteMutationPayload>;
    customAlarmUpdate?: Maybe<CustomAlarmUpdateMutationPayload>;
    deleteAttributeAsset?: Maybe<DeleteAttributeAsset>;
    deleteContact?: Maybe<DeleteContactPayload>;
    deleteMeasuringPointComment?: Maybe<DeleteMeasuringPointComment>;
    deleteReportTemplate?: Maybe<DeleteReportTemplate>;
    detachSensorFromMeasuringPoint?: Maybe<DetachSensorFromMeasuringPoint>;
    duplicateReportTemplate?: Maybe<DuplicateReportTemplate>;
    registerNyDepDevice?: Maybe<RegisterNyDepDevice>;
    reorderAttributeImages?: Maybe<ReorderAttributeImages>;
    requestMeasuringPointSensorAction?: Maybe<RequestMeasuringPointSensorAction>;
    setAttributeAssetCaption?: Maybe<SetAttributeAssetCaption>;
    setAttributeText?: Maybe<SetAttributeText>;
    setMeasuringPointArchived?: Maybe<SetMeasuringPointArchived>;
    setProjectArchived?: Maybe<SetProjectArchived>;
    softDeleteMeasuringPoint?: Maybe<SoftDeleteMeasuringPoint>;
    softDeleteProject?: Maybe<SoftDeleteProject>;
    soundDailyValueSettingsPartialConfigCreate?: Maybe<SoundDailyValueSettingsPartialConfigCreatePayload>;
    soundDailyValueSettingsPartialConfigUpdate?: Maybe<SoundDailyValueSettingsPartialConfigUpdatePayload>;
    soundGeneralPartialConfigCreate?: Maybe<SoundGeneralPartialConfigCreatePayload>;
    soundGeneralPartialConfigUpdate?: Maybe<SoundGeneralPartialConfigUpdatePayload>;
    soundLdenGuidelinePartialConfigCreate?: Maybe<SoundLdenGuidelinePartialConfigCreatePayload>;
    soundLdenGuidelinePartialConfigUpdate?: Maybe<SoundLdenGuidelinePartialConfigUpdatePayload>;
    soundMeasuringPointCreate?: Maybe<SoundMeasuringPointCreatePayload>;
    soundMeasuringPointCreateFromExistingMeasuringPoint?: Maybe<SoundMeasuringPointCreateFromExistingMeasuringPointPayload>;
    soundMeasuringPointCreateFromExistingProject?: Maybe<SoundMeasuringPointCreateFromExistingProjectPayload>;
    soundMeasuringPointDelete?: Maybe<SoundMeasuringPointDeletePayload>;
    soundMeasuringPointUpdate?: Maybe<SoundMeasuringPointUpdatePayload>;
    soundNotificationPartialConfigCreate?: Maybe<SoundNotificationPartialConfigCreatePayload>;
    soundNotificationPartialConfigUpdate?: Maybe<SoundNotificationPartialConfigUpdatePayload>;
    soundProjectCreate?: Maybe<SoundProjectCreatePayload>;
    soundProjectCreateFromExistingMeasuringPoint?: Maybe<SoundProjectCreateFromExistingMeasuringPointPayload>;
    soundProjectCreateFromExistingProject?: Maybe<SoundProjectCreateFromExistingProjectPayload>;
    soundProjectDelete?: Maybe<SoundProjectDeletePayload>;
    soundProjectUpdate?: Maybe<SoundProjectUpdatePayload>;
    storeGraphState?: Maybe<StoreGraphState>;
    submitPurchaseOrderNumber?: Maybe<SubmitPurchaseOrderNumber>;
    toggleProjectStar?: Maybe<ToggleProjectStar>;
    undoMyMeasuringPointShare?: Maybe<UndoMyMeasuringPointShare>;
    undoMyProjectShare?: Maybe<UndoMyProjectShare>;
    updateContact?: Maybe<UpdateContactPayload>;
    updateGraphReportLastDownloaded?: Maybe<UpdateGraphReportLastDownloaded>;
    updateMeasuringPointComment?: Maybe<UpdateMeasuringPointComment>;
    updateMeasuringPointPrivateNotes?: Maybe<UpdateMeasuringPointPrivateNotes>;
    updateProjectPrivateNotes?: Maybe<UpdateProjectPrivateNotes>;
    updateReportTemplate?: Maybe<UpdateReportTemplate>;
    updateWalkthroughState?: Maybe<Walkthrough>;
    vibrationGeneralPartialConfigCreate?: Maybe<VibrationGeneralPartialConfigCreatePayload>;
    vibrationGeneralPartialConfigUpdate?: Maybe<VibrationGeneralPartialConfigUpdatePayload>;
    vibrationMeasuringPointCreate?: Maybe<VibrationMeasuringPointCreatePayload>;
    vibrationMeasuringPointCreateFromExistingMeasuringPoint?: Maybe<VibrationMeasuringPointCreateFromExistingMeasuringPointPayload>;
    vibrationMeasuringPointCreateFromExistingProject?: Maybe<VibrationMeasuringPointCreateFromExistingProjectPayload>;
    vibrationMeasuringPointDelete?: Maybe<VibrationMeasuringPointDeletePayload>;
    vibrationMeasuringPointUpdate?: Maybe<VibrationMeasuringPointUpdatePayload>;
    vibrationNotificationPartialConfigCreate?: Maybe<VibrationNotificationPartialConfigCreatePayload>;
    vibrationNotificationPartialConfigUpdate?: Maybe<VibrationNotificationPartialConfigUpdatePayload>;
    vibrationProjectCreate?: Maybe<VibrationProjectCreatePayload>;
    vibrationProjectCreateFromExistingMeasuringPoint?: Maybe<VibrationProjectCreateFromExistingMeasuringPointPayload>;
    vibrationProjectCreateFromExistingProject?: Maybe<VibrationProjectCreateFromExistingProjectPayload>;
    vibrationProjectDelete?: Maybe<VibrationProjectDeletePayload>;
    vibrationProjectUpdate?: Maybe<VibrationProjectUpdatePayload>;
    vibrationSchedulePartialConfigCreate?: Maybe<VibrationSchedulePartialConfigCreatePayload>;
    vibrationSchedulePartialConfigUpdate?: Maybe<VibrationSchedulePartialConfigUpdatePayload>;
};

export type MutationShareCreateArgs = {
    entityId?: InputMaybe<Scalars['Int']['input']>;
    entityType: EntityType;
    forUser: Scalars['String']['input'];
    permission: Permission;
};

export type MutationShareDeleteArgs = {
    entityId?: InputMaybe<Scalars['Int']['input']>;
    entityType: EntityType;
    forUser: Scalars['String']['input'];
};

export type MutationShareUpdateArgs = {
    entityId?: InputMaybe<Scalars['Int']['input']>;
    entityType?: InputMaybe<EntityType>;
    forUser?: InputMaybe<Scalars['String']['input']>;
    permission?: InputMaybe<Permission>;
};

export type MutationActivateSubscriptionArgs = {
    deviceName: Scalars['String']['input'];
};

export type MutationAirGeneralPartialConfigCreateArgs = {
    input: AirGeneralPartialConfigCreateInput;
};

export type MutationAirGeneralPartialConfigUpdateArgs = {
    input: AirGeneralPartialConfigUpdateInput;
};

export type MutationAirMeasuringPointCreateArgs = {
    input: AirMeasuringPointCreateInput;
};

export type MutationAirMeasuringPointCreateFromExistingMeasuringPointArgs = {
    input: AirMeasuringPointCreateFromExistingMeasuringPointInput;
};

export type MutationAirMeasuringPointCreateFromExistingProjectArgs = {
    input: AirMeasuringPointCreateFromExistingProjectInput;
};

export type MutationAirMeasuringPointDeleteArgs = {
    input: AirMeasuringPointDeleteInput;
};

export type MutationAirMeasuringPointUpdateArgs = {
    input: AirMeasuringPointUpdateInput;
};

export type MutationAirNotificationPartialConfigCreateArgs = {
    input: AirNotificationPartialConfigCreateInput;
};

export type MutationAirNotificationPartialConfigUpdateArgs = {
    input: AirNotificationPartialConfigUpdateInput;
};

export type MutationAirProjectCreateArgs = {
    input: AirProjectCreateInput;
};

export type MutationAirProjectCreateFromExistingMeasuringPointArgs = {
    input: AirProjectCreateFromExistingMeasuringPointInput;
};

export type MutationAirProjectCreateFromExistingProjectArgs = {
    input: AirProjectCreateFromExistingProjectInput;
};

export type MutationAirProjectDeleteArgs = {
    input: AirProjectDeleteInput;
};

export type MutationAirProjectUpdateArgs = {
    input: AirProjectUpdateInput;
};

export type MutationAppendAttributeImagesArgs = {
    entityId: Scalars['ID']['input'];
    entityType: AttributesEntityType;
    key: Scalars['String']['input'];
};

export type MutationConvertPersonalAccountToOrganizationArgs = {
    name: Scalars['String']['input'];
};

export type MutationCreateAttributeDefinitionArgs = {
    description?: InputMaybe<Scalars['String']['input']>;
    entityId: Scalars['ID']['input'];
    entityType: AttributesEntityType;
    key?: InputMaybe<Scalars['String']['input']>;
    label: Scalars['String']['input'];
    valueType: AttributeValueType;
};

export type MutationCreateContactArgs = {
    input: CreateContactInput;
};

export type MutationCreateGraphReportArgs = {
    entityType: ReportTemplateEntityType;
    fileType: FileType;
    id: Scalars['ID']['input'];
    parameters: ParametersInput;
    sendEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateMeasuringPointCommentArgs = {
    dataType: DataType;
    endTime?: InputMaybe<Scalars['BigInteger']['input']>;
    measuringPointId: Scalars['ID']['input'];
    parentId?: InputMaybe<Scalars['ID']['input']>;
    startTime: Scalars['BigInteger']['input'];
    text: Scalars['String']['input'];
};

export type MutationCreateOrganizationArgs = {
    name: Scalars['String']['input'];
};

export type MutationCreateReportTemplateArgs = {
    entityType: ReportTemplateEntityType;
    name: Scalars['String']['input'];
};

export type MutationCustomAlarmCreateArgs = {
    input: CustomAlarmCreateMutationInput;
};

export type MutationCustomAlarmDeleteArgs = {
    input: CustomAlarmDeleteMutationInput;
};

export type MutationCustomAlarmUpdateArgs = {
    input: CustomAlarmUpdateMutationInput;
};

export type MutationDeleteAttributeAssetArgs = {
    assetId: Scalars['ID']['input'];
    entityId: Scalars['ID']['input'];
    entityType: AttributesEntityType;
    key: Scalars['String']['input'];
};

export type MutationDeleteContactArgs = {
    input: DeleteContactInput;
};

export type MutationDeleteMeasuringPointCommentArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDeleteReportTemplateArgs = {
    force?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
};

export type MutationDetachSensorFromMeasuringPointArgs = {
    id: Scalars['ID']['input'];
};

export type MutationDuplicateReportTemplateArgs = {
    id: Scalars['ID']['input'];
};

export type MutationRegisterNyDepDeviceArgs = {
    id: Scalars['ID']['input'];
};

export type MutationReorderAttributeImagesArgs = {
    assetIds: Array<InputMaybe<Scalars['ID']['input']>>;
    entityId: Scalars['ID']['input'];
    entityType: AttributesEntityType;
    key: Scalars['String']['input'];
};

export type MutationRequestMeasuringPointSensorActionArgs = {
    action: MeasuringPointSensorAction;
    id: Scalars['ID']['input'];
};

export type MutationSetAttributeAssetCaptionArgs = {
    assetId: Scalars['ID']['input'];
    caption: Scalars['String']['input'];
    entityId: Scalars['ID']['input'];
    entityType: AttributesEntityType;
    key: Scalars['String']['input'];
};

export type MutationSetAttributeTextArgs = {
    entityId: Scalars['ID']['input'];
    entityType: AttributesEntityType;
    key: Scalars['String']['input'];
    textValue: Scalars['String']['input'];
};

export type MutationSetMeasuringPointArchivedArgs = {
    archived: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
};

export type MutationSetProjectArchivedArgs = {
    archived: Scalars['Boolean']['input'];
    id: Scalars['ID']['input'];
};

export type MutationSoftDeleteMeasuringPointArgs = {
    id: Scalars['ID']['input'];
};

export type MutationSoftDeleteProjectArgs = {
    id: Scalars['ID']['input'];
};

export type MutationSoundDailyValueSettingsPartialConfigCreateArgs = {
    input: SoundDailyValueSettingsPartialConfigCreateInput;
};

export type MutationSoundDailyValueSettingsPartialConfigUpdateArgs = {
    input: SoundDailyValueSettingsPartialConfigUpdateInput;
};

export type MutationSoundGeneralPartialConfigCreateArgs = {
    input: SoundGeneralPartialConfigCreateInput;
};

export type MutationSoundGeneralPartialConfigUpdateArgs = {
    input: SoundGeneralPartialConfigUpdateInput;
};

export type MutationSoundLdenGuidelinePartialConfigCreateArgs = {
    input: SoundLdenGuidelinePartialConfigCreateInput;
};

export type MutationSoundLdenGuidelinePartialConfigUpdateArgs = {
    input: SoundLdenGuidelinePartialConfigUpdateInput;
};

export type MutationSoundMeasuringPointCreateArgs = {
    input: SoundMeasuringPointCreateInput;
};

export type MutationSoundMeasuringPointCreateFromExistingMeasuringPointArgs = {
    input: SoundMeasuringPointCreateFromExistingMeasuringPointInput;
};

export type MutationSoundMeasuringPointCreateFromExistingProjectArgs = {
    input: SoundMeasuringPointCreateFromExistingProjectInput;
};

export type MutationSoundMeasuringPointDeleteArgs = {
    input: SoundMeasuringPointDeleteInput;
};

export type MutationSoundMeasuringPointUpdateArgs = {
    input: SoundMeasuringPointUpdateInput;
};

export type MutationSoundNotificationPartialConfigCreateArgs = {
    input: SoundNotificationPartialConfigCreateInput;
};

export type MutationSoundNotificationPartialConfigUpdateArgs = {
    input: SoundNotificationPartialConfigUpdateInput;
};

export type MutationSoundProjectCreateArgs = {
    input: SoundProjectCreateInput;
};

export type MutationSoundProjectCreateFromExistingMeasuringPointArgs = {
    input: SoundProjectCreateFromExistingMeasuringPointInput;
};

export type MutationSoundProjectCreateFromExistingProjectArgs = {
    input: SoundProjectCreateFromExistingProjectInput;
};

export type MutationSoundProjectDeleteArgs = {
    input: SoundProjectDeleteInput;
};

export type MutationSoundProjectUpdateArgs = {
    input: SoundProjectUpdateInput;
};

export type MutationStoreGraphStateArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type MutationSubmitPurchaseOrderNumberArgs = {
    poNumber?: InputMaybe<Scalars['String']['input']>;
    token?: InputMaybe<Scalars['UUID']['input']>;
};

export type MutationToggleProjectStarArgs = {
    id: Scalars['ID']['input'];
};

export type MutationUndoMyMeasuringPointShareArgs = {
    measuringPointId: Scalars['Int']['input'];
};

export type MutationUndoMyProjectShareArgs = {
    projectId: Scalars['Int']['input'];
};

export type MutationUpdateContactArgs = {
    input: UpdateContactInput;
};

export type MutationUpdateGraphReportLastDownloadedArgs = {
    id: Scalars['ID']['input'];
};

export type MutationUpdateMeasuringPointCommentArgs = {
    id: Scalars['ID']['input'];
    text: Scalars['String']['input'];
};

export type MutationUpdateMeasuringPointPrivateNotesArgs = {
    id: Scalars['ID']['input'];
    privateNotes: Scalars['String']['input'];
};

export type MutationUpdateProjectPrivateNotesArgs = {
    id: Scalars['ID']['input'];
    privateNotes: Scalars['String']['input'];
};

export type MutationUpdateReportTemplateArgs = {
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    pageMargin?: InputMaybe<ReportTemplatePageMarginInput>;
    pageOrientation?: InputMaybe<ReportTemplatePageOrientation>;
    pageSize?: InputMaybe<ReportTemplatePageSize>;
    structure?: InputMaybe<Scalars['JSONString']['input']>;
};

export type MutationUpdateWalkthroughStateArgs = {
    name: Scalars['String']['input'];
    status?: InputMaybe<WalkthroughStatus>;
    step?: InputMaybe<Scalars['String']['input']>;
};

export type MutationVibrationGeneralPartialConfigCreateArgs = {
    input: VibrationGeneralPartialConfigCreateInput;
};

export type MutationVibrationGeneralPartialConfigUpdateArgs = {
    input: VibrationGeneralPartialConfigUpdateInput;
};

export type MutationVibrationMeasuringPointCreateArgs = {
    input: VibrationMeasuringPointCreateInput;
};

export type MutationVibrationMeasuringPointCreateFromExistingMeasuringPointArgs = {
    input: VibrationMeasuringPointCreateFromExistingMeasuringPointInput;
};

export type MutationVibrationMeasuringPointCreateFromExistingProjectArgs = {
    input: VibrationMeasuringPointCreateFromExistingProjectInput;
};

export type MutationVibrationMeasuringPointDeleteArgs = {
    input: VibrationMeasuringPointDeleteInput;
};

export type MutationVibrationMeasuringPointUpdateArgs = {
    input: VibrationMeasuringPointUpdateInput;
};

export type MutationVibrationNotificationPartialConfigCreateArgs = {
    input: VibrationNotificationPartialConfigCreateInput;
};

export type MutationVibrationNotificationPartialConfigUpdateArgs = {
    input: VibrationNotificationPartialConfigUpdateInput;
};

export type MutationVibrationProjectCreateArgs = {
    input: VibrationProjectCreateInput;
};

export type MutationVibrationProjectCreateFromExistingMeasuringPointArgs = {
    input: VibrationProjectCreateFromExistingMeasuringPointInput;
};

export type MutationVibrationProjectCreateFromExistingProjectArgs = {
    input: VibrationProjectCreateFromExistingProjectInput;
};

export type MutationVibrationProjectDeleteArgs = {
    input: VibrationProjectDeleteInput;
};

export type MutationVibrationProjectUpdateArgs = {
    input: VibrationProjectUpdateInput;
};

export type MutationVibrationSchedulePartialConfigCreateArgs = {
    input: VibrationSchedulePartialConfigCreateInput;
};

export type MutationVibrationSchedulePartialConfigUpdateArgs = {
    input: VibrationSchedulePartialConfigUpdateInput;
};

/** An error that happened in a mutation. */
export type MutationErrorType = {
    __typename?: 'MutationErrorType';
    /** The field that caused the error, or `null` if it isn't associated with any particular field. */
    field?: Maybe<Scalars['String']['output']>;
    /** The error message. */
    message?: Maybe<Scalars['String']['output']>;
};

/** A warning that happened in a mutation. */
export type MutationWarningType = {
    __typename?: 'MutationWarningType';
    /** The field that caused the warning, or `null` if it isn't associated with any particular field. */
    field?: Maybe<Scalars['String']['output']>;
    /** The warning message. */
    message?: Maybe<Scalars['String']['output']>;
};

/** An object with an ID */
export type Node = {
    /** The ID of the object. */
    id: Scalars['ID']['output'];
};

export type NotificationConfigInputObject = {
    alarmSchedules?: InputMaybe<Array<InputMaybe<AlarmScheduleInput>>>;
    concentrationAlarms?: InputMaybe<Array<InputMaybe<ConcentrationAlarmInput>>>;
    emailDelay?: InputMaybe<Scalars['Int']['input']>;
    ldenSchedules?: InputMaybe<Array<InputMaybe<LdenScheduleInput>>>;
    leqAlarms?: InputMaybe<Array<InputMaybe<LeqAlarmInput>>>;
    maxAlarms?: InputMaybe<Array<InputMaybe<MaxAlarmInput>>>;
    recipients?: InputMaybe<Array<InputMaybe<RecipientInput>>>;
};

export type NotificationConfigObject = {
    __typename?: 'NotificationConfigObject';
    alarmSchedules?: Maybe<Array<Maybe<AlarmSchedule>>>;
    concentrationAlarms?: Maybe<Array<Maybe<ConcentrationAlarm>>>;
    emailDelay?: Maybe<Scalars['Int']['output']>;
    ldenSchedules?: Maybe<Array<Maybe<LdenSchedule>>>;
    leqAlarms?: Maybe<Array<Maybe<LeqAlarm>>>;
    maxAlarms?: Maybe<Array<Maybe<MaxAlarm>>>;
    recipients?: Maybe<Array<Maybe<Recipient>>>;
};

/** An enumeration. */
export enum NotificationLevel {
    Error = 'error',
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
}

export type NotificationType = Node & {
    __typename?: 'NotificationType';
    createdAt: Scalars['DateTime']['output'];
    data: Scalars['String']['output'];
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    isLegacy: Scalars['Boolean']['output'];
    isLong: Scalars['Boolean']['output'];
    level: NotificationLevel;
    mpPk: Scalars['Int']['output'];
    subscription: Scalars['Int']['output'];
    swarmType: SwarmType;
};

export type NotificationTypeConnection = {
    __typename?: 'NotificationTypeConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<NotificationTypeEdge>>;
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    /** The total count of objects in this query. */
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `NotificationType` and its cursor. */
export type NotificationTypeEdge = {
    __typename?: 'NotificationTypeEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<NotificationType>;
};

export type NyDepIntegration = {
    __typename?: 'NyDepIntegration';
    registrationErrorCode?: Maybe<NyDepRegistrationErrorCode>;
    registrationStatus: NyDepRegistrationStatus;
};

/** An enumeration. */
export enum NyDepRegistrationErrorCode {
    AddressCoordinateMismatch = 'ADDRESS_COORDINATE_MISMATCH',
    ExternalApiError = 'EXTERNAL_API_ERROR',
    InvalidConfiguration = 'INVALID_CONFIGURATION',
    InvalidRegistrationDetails = 'INVALID_REGISTRATION_DETAILS',
}

/** An enumeration. */
export enum NyDepRegistrationStatus {
    Disabled = 'DISABLED',
    Failed = 'FAILED',
    NotReady = 'NOT_READY',
    Pending = 'PENDING',
    Registered = 'REGISTERED',
}

export type Organization = {
    __typename?: 'Organization';
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    permission: Permission;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
    __typename?: 'PageInfo';
    /** When paginating forwards, the cursor to continue. */
    endCursor?: Maybe<Scalars['String']['output']>;
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean']['output'];
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean']['output'];
    /** When paginating backwards, the cursor to continue. */
    startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParametersInput = {
    accelerationScale?: InputMaybe<Scalars['Int']['input']>;
    dataType?: InputMaybe<Scalars['String']['input']>;
    dustType?: InputMaybe<DustType>;
    frequencyGraphScaleType?: InputMaybe<FrequencyGraphScaleType>;
    frequencyScale?: InputMaybe<Scalars['Int']['input']>;
    graphType?: InputMaybe<GraphType>;
    lxnPercentiles?: InputMaybe<Array<Scalars['Int']['input']>>;
    omnidotsTemplateId?: InputMaybe<Scalars['ID']['input']>;
    overrides?: InputMaybe<Scalars['JSONString']['input']>;
    templateId?: InputMaybe<Scalars['ID']['input']>;
    viewEnd: Scalars['BigInteger']['input'];
    viewStart: Scalars['BigInteger']['input'];
};

/** An enumeration. */
export enum PartialConfigCategory {
    DailyValueSettings = 'DAILY_VALUE_SETTINGS',
    General = 'GENERAL',
    LdenGuideline = 'LDEN_GUIDELINE',
    Notification = 'NOTIFICATION',
    Schedule = 'SCHEDULE',
}

export type PartialConfigConnection = {
    __typename?: 'PartialConfigConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<PartialConfigEdge>>;
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PartialConfig` and its cursor. */
export type PartialConfigEdge = {
    __typename?: 'PartialConfigEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<PartialConfigType>;
};

export type PartialConfigType = Node & {
    __typename?: 'PartialConfigType';
    config: Scalars['JSONString']['output'];
    createdAt: Scalars['DateTime']['output'];
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    modifiedAt: Scalars['DateTime']['output'];
    name: Scalars['String']['output'];
    partialConfigType: PartialConfigCategory;
    swarmType: SwarmType;
};

/** An enumeration. */
export enum ParticleType {
    Pm1 = 'PM1',
    Pm2p5 = 'PM2p5',
    Pm10 = 'PM10',
    Tsp = 'TSP',
}

export type PastSensorType = {
    __typename?: 'PastSensorType';
    calibrationReportUrl: Scalars['String']['output'];
    sensorPk: Scalars['Int']['output'];
    simpleName: Scalars['String']['output'];
};

export type Percentage = {
    __typename?: 'Percentage';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    vector?: Maybe<Scalars['Float']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

export enum PeriodType {
    Auto = 'AUTO',
    KbfTr = 'KBFTr',
    Vper = 'Vper',
}

export enum Permission {
    FullAccess = 'FULL_ACCESS',
    /** Reference-only access, which follows from access to another entity, such as the project of a measuring point. The whole entity can be read, but it cannot be changed, shared or acted on. */
    Reference = 'REFERENCE',
    View = 'VIEW',
}

export type PersonalAccountConversionPreview = {
    __typename?: 'PersonalAccountConversionPreview';
    blockers: Array<Maybe<ConversionBlocker>>;
    brandingFields: Array<Maybe<Scalars['String']['output']>>;
    canConvert: Scalars['Boolean']['output'];
    items: Array<Maybe<ConversionItem>>;
};

/** An enumeration. */
export enum PipelineType {
    BrickworkAndPlastic = 'brickworkAndPlastic',
    ConcreteAndSteel = 'concreteAndSteel',
    WeldedSteel = 'weldedSteel',
}

export type ProjectCatalogType = Node & {
    __typename?: 'ProjectCatalogType';
    archived: Scalars['Boolean']['output'];
    city: Scalars['String']['output'];
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    isStarred: Scalars['Boolean']['output'];
    measuringPointCount: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    permission: Permission;
    pk: Scalars['ID']['output'];
    swarmType: SwarmType;
};

export type ProjectCatalogTypeConnection = {
    __typename?: 'ProjectCatalogTypeConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<ProjectCatalogTypeEdge>>;
    hasAnyData: Scalars['Boolean']['output'];
    maxStarredProjects: Scalars['Int']['output'];
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    starredCount: Scalars['Int']['output'];
    summaries: Array<ProjectSummaryType>;
    /** The total count of objects in this query. */
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ProjectCatalogType` and its cursor. */
export type ProjectCatalogTypeEdge = {
    __typename?: 'ProjectCatalogTypeEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<ProjectCatalogType>;
};

export type ProjectInterface = {
    archived?: Maybe<Scalars['Boolean']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    privateNotes?: Maybe<Scalars['String']['output']>;
    swarmType: SwarmType;
};

export type ProjectSummaryType = {
    __typename?: 'ProjectSummaryType';
    dataWarnings: DataWarningGroupType;
    inactive: Scalars['Int']['output'];
    offline: Scalars['Int']['output'];
    online: Scalars['Int']['output'];
    projectId: Scalars['ID']['output'];
    recentExceedances: RecentExceedanceGroupType;
};

/** An enumeration. */
export enum ProjectSwarmType {
    /** vibration */
    A_1 = 'A_1',
    /** air */
    A_2 = 'A_2',
    /** sound */
    A_3 = 'A_3',
}

export type PurchaseOrderRequestType = {
    __typename?: 'PurchaseOrderRequestType';
    invoiceReference?: Maybe<Scalars['String']['output']>;
    isExpired: Scalars['Boolean']['output'];
    poNumber?: Maybe<Scalars['String']['output']>;
    subscriptionNames: Array<Scalars['String']['output']>;
};

export type Query = {
    __typename?: 'Query';
    alarmExceedances?: Maybe<AlarmExceedances>;
    alarmLine?: Maybe<AlarmLine>;
    allMeasurementsBounds?: Maybe<TimeSpan>;
    attributesByEntity: Array<AttributeEntryInterface>;
    availableOrganizations: Array<Maybe<Organization>>;
    canActivateSubscription?: Maybe<Scalars['Boolean']['output']>;
    config?: Maybe<SwarmConfig>;
    contact?: Maybe<ContactType>;
    contacts?: Maybe<ContactTypeConnection>;
    /** The ID of the object */
    customAlarm?: Maybe<CustomAlarmType>;
    customAlarms?: Maybe<CustomAlarmTypeConnection>;
    dailyValues?: Maybe<DailyValues>;
    dustMeta?: Maybe<Array<Maybe<DustMeta>>>;
    dustSamples?: Maybe<Array<Maybe<Dust>>>;
    events?: Maybe<Array<Maybe<EventInterface>>>;
    featureCheckProject?: Maybe<Array<Maybe<SwarmFeatures>>>;
    featureCheckSwarm?: Maybe<Array<Maybe<SwarmFeatures>>>;
    graphReports?: Maybe<GraphReportTypeConnection>;
    highestVtopEntries?: Maybe<HighestVtopEntries>;
    highestVtopOverPeriod?: Maybe<HighestVtopPerDayEntries>;
    highestVtopPerDay?: Maybe<HighestVtopPerDayEntries>;
    hubspotIdentificationToken?: Maybe<Scalars['String']['output']>;
    lastGraphState?: Maybe<LastGraphStateType>;
    ldenValues?: Maybe<LdenValues>;
    leqAlarmExceedances?: Maybe<LeqAlarmExceedances>;
    leqAlarmTable?: Maybe<LeqAlarmTable>;
    lmaxAlarmExceedances?: Maybe<LmaxAlarmExceedances>;
    lxnValues?: Maybe<LxnValues>;
    mapMarkers?: Maybe<MapMarkerPageType>;
    measurementSettings: Array<Maybe<MeasurementSettingEntry>>;
    measuringPointById?: Maybe<MeasuringPointInterface>;
    measuringPointComment?: Maybe<MeasuringPointCommentType>;
    measuringPointComments?: Maybe<Array<Maybe<MeasuringPointCommentType>>>;
    measuringPoints?: Maybe<Array<Maybe<MeasuringPointInterface>>>;
    measuringPointsByIds?: Maybe<Array<Maybe<MeasuringPointInterface>>>;
    notifications?: Maybe<NotificationTypeConnection>;
    nyDepIntegration?: Maybe<NyDepIntegration>;
    /** The ID of the object */
    partialConfig?: Maybe<PartialConfigType>;
    partialConfigs?: Maybe<PartialConfigConnection>;
    personalAccountConversionPreview: PersonalAccountConversionPreview;
    projectById?: Maybe<ProjectInterface>;
    projectCatalog?: Maybe<ProjectCatalogTypeConnection>;
    projects?: Maybe<Array<Maybe<ProjectInterface>>>;
    projectsByIds?: Maybe<Array<Maybe<ProjectInterface>>>;
    purchaseOrderRequest?: Maybe<PurchaseOrderRequestType>;
    rangedSamples?: Maybe<Array<Maybe<BucketInterface>>>;
    reportProfileLogo?: Maybe<ReportProfileLogo>;
    reportTemplates?: Maybe<ReportTemplateTypeConnection>;
    reportTemplatesLegacy?: Maybe<Array<Maybe<ReportTemplateLegacy>>>;
    /** Get all shares for the given entityType and entityId. */
    shares?: Maybe<Array<Maybe<ShareType>>>;
    soundAnalysis?: Maybe<SoundAnalysis>;
    soundClips?: Maybe<SoundClipTypeConnection>;
    soundSamples?: Maybe<Sound>;
    standaloneMeasuringPoints?: Maybe<StandaloneMeasuringPointsType>;
    /** Get active top banner configurations */
    topBannerConfigs: Array<TopBannerConfigType>;
    traces?: Maybe<Array<Maybe<Trace>>>;
    walkthroughs?: Maybe<Array<Maybe<Walkthrough>>>;
};

export type QueryAlarmExceedancesArgs = {
    endTime: Scalars['BigInteger']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryAlarmLineArgs = {
    config: Scalars['JSONString']['input'];
    override?: InputMaybe<Scalars['JSONString']['input']>;
};

export type QueryAllMeasurementsBoundsArgs = {
    measuringPointId: Scalars['Int']['input'];
};

export type QueryAttributesByEntityArgs = {
    entityId: Scalars['ID']['input'];
    entityType: AttributesEntityType;
    ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCanActivateSubscriptionArgs = {
    deviceName: Scalars['String']['input'];
};

export type QueryConfigArgs = {
    dataTab?: InputMaybe<DataTab>;
    endTime?: InputMaybe<Scalars['BigInteger']['input']>;
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryContactArgs = {
    id: Scalars['ID']['input'];
};

export type QueryContactsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    createdAt_Date?: InputMaybe<Scalars['DateTime']['input']>;
    createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
    createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    emailVerificationStatus?: InputMaybe<VerificationStatus>;
    emailVerificationStatus_In?: InputMaybe<Array<InputMaybe<VerificationStatus>>>;
    email_Icontains?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    name_Icontains?: InputMaybe<Scalars['String']['input']>;
    name_Istartswith?: InputMaybe<Scalars['String']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    phoneNumber_Icontains?: InputMaybe<Scalars['String']['input']>;
    phoneVerificationStatus?: InputMaybe<VerificationStatus>;
    phoneVerificationStatus_In?: InputMaybe<Array<InputMaybe<VerificationStatus>>>;
    search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCustomAlarmArgs = {
    id: Scalars['ID']['input'];
};

export type QueryCustomAlarmsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDailyValuesArgs = {
    measuringPointId: Scalars['Int']['input'];
};

export type QueryDustMetaArgs = {
    endTime?: InputMaybe<Scalars['BigInteger']['input']>;
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryDustSamplesArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryEventsArgs = {
    endTime?: InputMaybe<Scalars['BigInteger']['input']>;
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryFeatureCheckProjectArgs = {
    projectId: Scalars['ID']['input'];
};

export type QueryFeatureCheckSwarmArgs = {
    deviceName: Scalars['String']['input'];
};

export type QueryGraphReportsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    last?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHighestVtopEntriesArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryHighestVtopOverPeriodArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryHighestVtopPerDayArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryLdenValuesArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryLeqAlarmExceedancesArgs = {
    endTime: Scalars['BigInteger']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryLeqAlarmTableArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryLmaxAlarmExceedancesArgs = {
    endTime: Scalars['BigInteger']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryLxnValuesArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['ID']['input'];
    percentiles?: InputMaybe<Array<Scalars['Int']['input']>>;
    startTime: Scalars['BigInteger']['input'];
};

export type QueryMapMarkersArgs = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    limit: Scalars['Int']['input'];
    offset?: InputMaybe<Scalars['Int']['input']>;
    scope: MapScope;
    useDeviceGps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryMeasurementSettingsArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryMeasuringPointByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryMeasuringPointCommentArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMeasuringPointCommentsArgs = {
    measuringPointId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMeasuringPointsArgs = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    swarmType?: InputMaybe<SwarmType>;
};

export type QueryMeasuringPointsByIdsArgs = {
    ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryNotificationsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
    createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    levels?: InputMaybe<Array<InputMaybe<NotificationLevel>>>;
    mpPk?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryNyDepIntegrationArgs = {
    measuringPointId: Scalars['ID']['input'];
};

export type QueryPartialConfigArgs = {
    id: Scalars['ID']['input'];
};

export type QueryPartialConfigsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    partialConfigType?: InputMaybe<PartialConfigCategory>;
    search?: InputMaybe<Scalars['String']['input']>;
    swarmType?: InputMaybe<SwarmType>;
};

export type QueryProjectByIdArgs = {
    id: Scalars['ID']['input'];
};

export type QueryProjectCatalogArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProjectsArgs = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    swarmType?: InputMaybe<SwarmType>;
};

export type QueryProjectsByIdsArgs = {
    ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryPurchaseOrderRequestArgs = {
    token?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryRangedSamplesArgs = {
    endTime?: InputMaybe<Scalars['BigInteger']['input']>;
    measuringPointId: Scalars['Int']['input'];
    periodType?: InputMaybe<PeriodType>;
    startTime: Scalars['BigInteger']['input'];
};

export type QueryReportProfileLogoArgs = {
    entityId: Scalars['ID']['input'];
    entityType: ReportTemplateEntityType;
};

export type QueryReportTemplatesArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    last?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySharesArgs = {
    entityId?: InputMaybe<Scalars['Int']['input']>;
    entityType: EntityType;
};

export type QuerySoundAnalysisArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QuerySoundClipsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    endTime: Scalars['BigInteger']['input'];
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    measuringPoint: Scalars['ID']['input'];
    offset?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    startTime: Scalars['BigInteger']['input'];
};

export type QuerySoundSamplesArgs = {
    endTime: Scalars['BigInteger']['input'];
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type QueryStandaloneMeasuringPointsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    archived: Scalars['Boolean']['input'];
    first: Scalars['Int']['input'];
    orderBy?: InputMaybe<Scalars['String']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTracesArgs = {
    endTime?: InputMaybe<Scalars['BigInteger']['input']>;
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
};

export type RecentExceedanceEventType = {
    __typename?: 'RecentExceedanceEventType';
    deviceName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    measuringPointId: Scalars['ID']['output'];
    occurredAt: Scalars['DateTime']['output'];
};

export type RecentExceedanceGroupType = {
    __typename?: 'RecentExceedanceGroupType';
    count: Scalars['Int']['output'];
    events: Array<RecentExceedanceEventType>;
};

export type Recipient = {
    __typename?: 'Recipient';
    email?: Maybe<Scalars['String']['output']>;
    enabledAlarms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    webhook?: Maybe<Webhook>;
};

export type RecipientInput = {
    email?: InputMaybe<Scalars['String']['input']>;
    enabledAlarms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    webhook?: InputMaybe<WebhookInput>;
};

export type RecordInterface = {
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type RegisterNyDepDevice = {
    __typename?: 'RegisterNyDepDevice';
    errorCode?: Maybe<NyDepRegistrationErrorCode>;
    status: NyDepRegistrationStatus;
};

export type ReorderAttributeImages = {
    __typename?: 'ReorderAttributeImages';
    attributeEntry?: Maybe<AttributeEntryInterface>;
};

export enum ReportInterval {
    Daily = 'DAILY',
    Weekly = 'WEEKLY',
}

export type ReportProfileLogo = {
    __typename?: 'ReportProfileLogo';
    caption: Scalars['String']['output'];
    url: Scalars['String']['output'];
};

/** An enumeration. */
export enum ReportStatus {
    Downloaded = 'DOWNLOADED',
    Failed = 'FAILED',
    InProgress = 'IN_PROGRESS',
    Ready = 'READY',
}

export enum ReportTemplateEntityType {
    MeasuringPoint = 'MEASURING_POINT',
    Project = 'PROJECT',
}

/** The active uses that kept a template from being deleted. Lists only uses the caller may edit. */
export type ReportTemplateInUse = {
    __typename?: 'ReportTemplateInUse';
    /** Whether the caller may delete the template anyway, switching every use to the Default template. */
    canForce: Scalars['Boolean']['output'];
    /** Uses the caller may not edit. */
    hiddenCount: Scalars['Int']['output'];
    /** Further uses the caller may edit. */
    remainingCount: Scalars['Int']['output'];
    usages: Array<ReportTemplateUsage>;
};

export type ReportTemplateLegacy = {
    __typename?: 'ReportTemplateLegacy';
    id?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

/** A page margin as a value plus the unit it is expressed in. */
export type ReportTemplatePageMargin = {
    __typename?: 'ReportTemplatePageMargin';
    unit: ReportTemplatePageMarginUnit;
    value: Scalars['Float']['output'];
};

export type ReportTemplatePageMarginInput = {
    unit: ReportTemplatePageMarginUnit;
    value: Scalars['Float']['input'];
};

export enum ReportTemplatePageMarginUnit {
    Cm = 'CM',
    In = 'IN',
}

export enum ReportTemplatePageOrientation {
    Landscape = 'LANDSCAPE',
    Portrait = 'PORTRAIT',
}

export enum ReportTemplatePageSize {
    A4 = 'A4',
    Letter = 'LETTER',
}

export type ReportTemplateType = Node & {
    __typename?: 'ReportTemplateType';
    createdAt: Scalars['DateTime']['output'];
    deleted: Scalars['Boolean']['output'];
    entityType: ReportTemplateEntityType;
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    isSystem: Scalars['Boolean']['output'];
    modifiedAt: Scalars['DateTime']['output'];
    name: Scalars['String']['output'];
    pageMargin: ReportTemplatePageMargin;
    pageOrientation: ReportTemplatePageOrientation;
    pageSize: ReportTemplatePageSize;
    permission: Permission;
    structure: Scalars['JSONString']['output'];
    user: UserType;
};

export type ReportTemplateTypeConnection = {
    __typename?: 'ReportTemplateTypeConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<ReportTemplateTypeEdge>>;
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    /** The total count of objects in this query. */
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ReportTemplateType` and its cursor. */
export type ReportTemplateTypeEdge = {
    __typename?: 'ReportTemplateTypeEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<ReportTemplateType>;
};

/** A daily or weekly report setting of a measuring point or project that selects the template. */
export type ReportTemplateUsage = {
    __typename?: 'ReportTemplateUsage';
    entityType: ReportTemplateEntityType;
    interval: ReportInterval;
    name: Scalars['String']['output'];
};

export type RequestMeasuringPointSensorAction = {
    __typename?: 'RequestMeasuringPointSensorAction';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type SampleBucket = BucketInterface & {
    __typename?: 'SampleBucket';
    atop?: Maybe<Atop>;
    fdom?: Maybe<Fdom>;
    timespan?: Maybe<TimeSpan>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    vdv?: Maybe<Vdv>;
    veff?: Maybe<Veff>;
    vtop?: Maybe<Vtop>;
};

export type ScheduleDay = {
    __typename?: 'ScheduleDay';
    disable?: Maybe<Scalars['String']['output']>;
    enable?: Maybe<Scalars['String']['output']>;
};

export type ScheduleDayInput = {
    disable?: InputMaybe<Scalars['String']['input']>;
    enable?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleInputObject = {
    friday?: InputMaybe<ScheduleDayInput>;
    monday?: InputMaybe<ScheduleDayInput>;
    saturday?: InputMaybe<ScheduleDayInput>;
    sunday?: InputMaybe<ScheduleDayInput>;
    thursday?: InputMaybe<ScheduleDayInput>;
    tuesday?: InputMaybe<ScheduleDayInput>;
    wednesday?: InputMaybe<ScheduleDayInput>;
};

export type ScheduleObject = {
    __typename?: 'ScheduleObject';
    friday?: Maybe<ScheduleDay>;
    monday?: Maybe<ScheduleDay>;
    saturday?: Maybe<ScheduleDay>;
    sunday?: Maybe<ScheduleDay>;
    thursday?: Maybe<ScheduleDay>;
    tuesday?: Maybe<ScheduleDay>;
    wednesday?: Maybe<ScheduleDay>;
};

/** An enumeration. */
export enum SensitivityClass {
    Elevated = 'elevated',
    Little = 'little',
    ScNormal = 'scNormal',
    SensitivityClass0 = 'sensitivityClass0',
    SensitivityClass1 = 'sensitivityClass1',
    SensitivityClass2 = 'sensitivityClass2',
    SensitivityClass3 = 'sensitivityClass3',
    SensitivityClass4 = 'sensitivityClass4',
    VeryLittle = 'veryLittle',
}

export type Sensor = {
    __typename?: 'Sensor';
    batteryCharge?: Maybe<Scalars['Int']['output']>;
    batteryChargeLastUpdate?: Maybe<Scalars['DateTime']['output']>;
    connectedUsing?: Maybe<Scalars['String']['output']>;
    coordinates?: Maybe<CoordinatesType>;
    dataQuota?: Maybe<SensorQuotaType>;
    firmwareUpgradePercentage?: Maybe<Scalars['Float']['output']>;
    hasDataUsageInfo?: Maybe<Scalars['Boolean']['output']>;
    hasPendingFirmwareUpgrade?: Maybe<Scalars['Boolean']['output']>;
    hasValidSubscription?: Maybe<Scalars['Boolean']['output']>;
    isRestarting?: Maybe<Scalars['Boolean']['output']>;
    isRotating?: Maybe<Scalars['Boolean']['output']>;
    lastContact?: Maybe<Scalars['DateTime']['output']>;
    name: Scalars['String']['output'];
    online?: Maybe<Scalars['Boolean']['output']>;
    smsLimit?: Maybe<Scalars['Int']['output']>;
    smsQuota?: Maybe<SensorQuotaType>;
    smsUsed?: Maybe<Scalars['Int']['output']>;
    wifiPassword?: Maybe<Scalars['String']['output']>;
};

export type SensorQuotaType = {
    __typename?: 'SensorQuotaType';
    isLimit: Scalars['Boolean']['output'];
    isWarning: Scalars['Boolean']['output'];
    percent: Scalars['Float']['output'];
};

export type SetAttributeAssetCaption = {
    __typename?: 'SetAttributeAssetCaption';
    attributeEntry?: Maybe<AttributeEntryInterface>;
};

export type SetAttributeText = {
    __typename?: 'SetAttributeText';
    attributeEntry?: Maybe<AttributeEntryInterface>;
};

export type SetMeasuringPointArchived = {
    __typename?: 'SetMeasuringPointArchived';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type SetProjectArchived = {
    __typename?: 'SetProjectArchived';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type ShareCreate = {
    __typename?: 'ShareCreate';
    shareCreate?: Maybe<ShareType>;
};

export type ShareDelete = {
    __typename?: 'ShareDelete';
    shareDelete?: Maybe<ShareType>;
};

export type ShareType = {
    __typename?: 'ShareType';
    entityId?: Maybe<Scalars['Int']['output']>;
    entityType?: Maybe<EntityType>;
    forUser?: Maybe<Scalars['String']['output']>;
    invite?: Maybe<InviteStatus>;
    permission?: Maybe<Permission>;
    sharedBy?: Maybe<Scalars['String']['output']>;
};

export type ShareUpdate = {
    __typename?: 'ShareUpdate';
    shareUpdate?: Maybe<ShareType>;
};

export type SingleAxisEntry = {
    __typename?: 'SingleAxisEntry';
    axis?: Maybe<Scalars['String']['output']>;
    datetime?: Maybe<Scalars['String']['output']>;
    fdom?: Maybe<Scalars['Float']['output']>;
    percentage?: Maybe<Scalars['Float']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    vtop?: Maybe<Scalars['Float']['output']>;
};

export type SoftDeleteMeasuringPoint = {
    __typename?: 'SoftDeleteMeasuringPoint';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type SoftDeleteProject = {
    __typename?: 'SoftDeleteProject';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type Sound = {
    __typename?: 'Sound';
    lXEq?: Maybe<Array<Maybe<LxEq>>>;
    lXPeak?: Maybe<Array<Maybe<LxPeak>>>;
    lXn?: Maybe<Array<Maybe<Lxn>>>;
    lXtMax?: Maybe<Array<Maybe<LXtMax>>>;
    lXtMin?: Maybe<Array<Maybe<LXtMin>>>;
};

export type SoundAnalysis = {
    __typename?: 'SoundAnalysis';
    endTime?: Maybe<Scalars['BigInteger']['output']>;
    lXEq?: Maybe<Scalars['Float']['output']>;
    lXPeak?: Maybe<Scalars['Float']['output']>;
    lXn?: Maybe<Array<Maybe<LxnValue>>>;
    lXtMax?: Maybe<Scalars['Float']['output']>;
    lXtMin?: Maybe<Scalars['Float']['output']>;
    startTime?: Maybe<Scalars['BigInteger']['output']>;
};

/** An enumeration. */
export enum SoundClipAlarmSource {
    Disabled = 'disabled',
    Leq = 'leq',
    Lmax = 'lmax',
    Lpeak = 'lpeak',
}

export type SoundClipType = Node & {
    __typename?: 'SoundClipType';
    configFileId?: Maybe<Scalars['BigInteger']['output']>;
    downloadUrl?: Maybe<Scalars['String']['output']>;
    endTime: Scalars['BigInteger']['output'];
    /** The ID of the object. */
    id: Scalars['ID']['output'];
    measuringPoint: Scalars['ID']['output'];
    startTime: Scalars['BigInteger']['output'];
    streamUrl?: Maybe<Scalars['String']['output']>;
    triggerSource?: Maybe<SoundClipAlarmSource>;
    triggerValue?: Maybe<Scalars['Float']['output']>;
};

export type SoundClipTypeConnection = {
    __typename?: 'SoundClipTypeConnection';
    /** Contains the nodes in this connection. */
    edges: Array<Maybe<SoundClipTypeEdge>>;
    /** Pagination data for this connection. */
    pageInfo: PageInfo;
    /** The total count of objects in this query. */
    totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SoundClipType` and its cursor. */
export type SoundClipTypeEdge = {
    __typename?: 'SoundClipTypeEdge';
    /** A cursor for use in pagination */
    cursor: Scalars['String']['output'];
    /** The item at the end of the edge */
    node?: Maybe<SoundClipType>;
};

export type SoundConfig = {
    __typename?: 'SoundConfig';
    alarmValue?: Maybe<Scalars['Float']['output']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    /** Synchronize data to */
    externalApiTarget?: Maybe<ExternalApiTarget>;
    /** Frequency weighting */
    frequencyWeighting?: Maybe<FrequencyWeighting>;
    id?: Maybe<Scalars['Int']['output']>;
    /** Ln interval */
    lXnInterval?: Maybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: Maybe<LXtMinMaxInterval>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    /** Leq Interval */
    lxEqInterval?: Maybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: Maybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: Maybe<MeasuringSchedule>;
    sensorPk?: Maybe<Scalars['Int']['output']>;
    /** Trigger source */
    soundClipAlarmSource?: Maybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: Maybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: Maybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: Maybe<Scalars['Float']['output']>;
    /** swarm type */
    swarmType?: Maybe<SwarmType>;
    /** Time weighting */
    timeWeighting?: Maybe<TimeWeighting>;
    timeWindows?: Maybe<Scalars['JSONString']['output']>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: Maybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: Maybe<Scalars['Float']['output']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: Maybe<Scalars['Float']['output']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: Maybe<Scalars['Float']['output']>;
};

export type SoundDailyValueSettingsPartialConfigCreateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** daily value settings */
    dailyValueSettings?: InputMaybe<DailyValueSettingsInput>;
    name: Scalars['String']['input'];
};

export type SoundDailyValueSettingsPartialConfigCreatePayload = {
    __typename?: 'SoundDailyValueSettingsPartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundDailyValueSettingsPartialConfigUpdateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** daily value settings */
    dailyValueSettings?: InputMaybe<DailyValueSettingsInput>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type SoundDailyValueSettingsPartialConfigUpdatePayload = {
    __typename?: 'SoundDailyValueSettingsPartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundGeneralPartialConfigCreateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** Synchronize data to */
    externalApiTarget?: InputMaybe<ExternalApiTarget>;
    /** Frequency weighting */
    frequencyWeighting?: InputMaybe<FrequencyWeighting>;
    /** Ln interval */
    lXnInterval?: InputMaybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: InputMaybe<LXtMinMaxInterval>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Leq Interval */
    lxEqInterval?: InputMaybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: InputMaybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: InputMaybe<MeasuringSchedule>;
    name: Scalars['String']['input'];
    /** Trigger source */
    soundClipAlarmSource?: InputMaybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: InputMaybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: InputMaybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: InputMaybe<Scalars['Float']['input']>;
    /** Time weighting */
    timeWeighting?: InputMaybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type SoundGeneralPartialConfigCreatePayload = {
    __typename?: 'SoundGeneralPartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundGeneralPartialConfigUpdateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** Synchronize data to */
    externalApiTarget?: InputMaybe<ExternalApiTarget>;
    /** Frequency weighting */
    frequencyWeighting?: InputMaybe<FrequencyWeighting>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** Ln interval */
    lXnInterval?: InputMaybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: InputMaybe<LXtMinMaxInterval>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Leq Interval */
    lxEqInterval?: InputMaybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: InputMaybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: InputMaybe<MeasuringSchedule>;
    name: Scalars['String']['input'];
    /** Trigger source */
    soundClipAlarmSource?: InputMaybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: InputMaybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: InputMaybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: InputMaybe<Scalars['Float']['input']>;
    /** Time weighting */
    timeWeighting?: InputMaybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type SoundGeneralPartialConfigUpdatePayload = {
    __typename?: 'SoundGeneralPartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An enumeration. */
export enum SoundGuideline {
    Iec_61672 = 'IEC_61672',
}

export type SoundLdenGuidelinePartialConfigCreateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** lden guideline */
    ldenGuideline?: InputMaybe<LdenGuideline>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type SoundLdenGuidelinePartialConfigCreatePayload = {
    __typename?: 'SoundLdenGuidelinePartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundLdenGuidelinePartialConfigUpdateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** lden guideline */
    ldenGuideline?: InputMaybe<LdenGuideline>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type SoundLdenGuidelinePartialConfigUpdatePayload = {
    __typename?: 'SoundLdenGuidelinePartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An enumeration. */
export enum SoundMeasurementCorrectionOption {
    Custom = 'custom',
    Facade = 'facade',
    Impulse = 'impulse',
    Music = 'music',
    NoCorrection = 'noCorrection',
}

/** An object that holds all configurations for a sound measuring point. */
export type SoundMeasuringPoint = MeasuringPointInterface & {
    __typename?: 'SoundMeasuringPoint';
    archived?: Maybe<Scalars['Boolean']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    coordinates?: Maybe<CoordinatesType>;
    /** daily value settings */
    dailyValueSettings?: Maybe<DailyValueSettings>;
    /** Unique name of your SWARM Sound. This name is placed on the front of the SWARM Sound */
    deviceName?: Maybe<Scalars['String']['output']>;
    directShare: Scalars['Boolean']['output'];
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    /** Synchronize data to */
    externalApiTarget?: Maybe<ExternalApiTarget>;
    /** Frequency weighting */
    frequencyWeighting?: Maybe<FrequencyWeighting>;
    id: Scalars['ID']['output'];
    /** Ln interval */
    lXnInterval?: Maybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: Maybe<LXtMinMaxInterval>;
    /** lden guideline */
    ldenGuideline?: Maybe<LdenGuideline>;
    /** Location */
    location?: Maybe<Scalars['String']['output']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    /** Leq Interval */
    lxEqInterval?: Maybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: Maybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: Maybe<MeasuringSchedule>;
    name: Scalars['String']['output'];
    notificationConfig?: Maybe<NotificationConfigObject>;
    /** overridden fields */
    overriddenFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    pastSensors?: Maybe<Array<Maybe<PastSensorType>>>;
    permission?: Maybe<Permission>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: Maybe<Scalars['String']['output']>;
    /** Project */
    project?: Maybe<Scalars['ID']['output']>;
    projectSoundThresholdPrivateNotes?: Maybe<Scalars['String']['output']>;
    sensor?: Maybe<Sensor>;
    /** Trigger source */
    soundClipAlarmSource?: Maybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: Maybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: Maybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: Maybe<Scalars['Float']['output']>;
    status: MeasuringPointStatus;
    swarmType: SwarmType;
    /** Time weighting */
    timeWeighting?: Maybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: Maybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: Maybe<Scalars['Float']['output']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: Maybe<Scalars['Float']['output']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: Maybe<Scalars['Float']['output']>;
};

export type SoundMeasuringPointCreateFromExistingMeasuringPointInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing sound_measuring_point */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type SoundMeasuringPointCreateFromExistingMeasuringPointPayload = {
    __typename?: 'SoundMeasuringPointCreateFromExistingMeasuringPointPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundMeasuringPoint?: Maybe<SoundMeasuringPoint>;
};

export type SoundMeasuringPointCreateFromExistingProjectInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing sound_project */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type SoundMeasuringPointCreateFromExistingProjectPayload = {
    __typename?: 'SoundMeasuringPointCreateFromExistingProjectPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundMeasuringPoint?: Maybe<SoundMeasuringPoint>;
};

export type SoundMeasuringPointCreateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** daily value settings */
    dailyValueSettings?: InputMaybe<DailyValueSettingsInput>;
    /** Unique name of your SWARM Sound. This name is placed on the front of the SWARM Sound */
    deviceName?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** Synchronize data to */
    externalApiTarget?: InputMaybe<ExternalApiTarget>;
    /** Frequency weighting */
    frequencyWeighting?: InputMaybe<FrequencyWeighting>;
    /** Ln interval */
    lXnInterval?: InputMaybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: InputMaybe<LXtMinMaxInterval>;
    /** lden guideline */
    ldenGuideline?: InputMaybe<LdenGuideline>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Leq Interval */
    lxEqInterval?: InputMaybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: InputMaybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: InputMaybe<MeasuringSchedule>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** overridden fields */
    overriddenFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Project */
    project?: InputMaybe<Scalars['ID']['input']>;
    /** Trigger source */
    soundClipAlarmSource?: InputMaybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: InputMaybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: InputMaybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<MeasuringPointSwarmType>;
    /** Time weighting */
    timeWeighting?: InputMaybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type SoundMeasuringPointCreatePayload = {
    __typename?: 'SoundMeasuringPointCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundMeasuringPoint?: Maybe<SoundMeasuringPoint>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundMeasuringPointDeleteInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type SoundMeasuringPointDeletePayload = {
    __typename?: 'SoundMeasuringPointDeletePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundMeasuringPoint?: Maybe<SoundMeasuringPoint>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundMeasuringPointUpdateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** daily value settings */
    dailyValueSettings?: InputMaybe<DailyValueSettingsInput>;
    /** Unique name of your SWARM Sound. This name is placed on the front of the SWARM Sound */
    deviceName?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** Synchronize data to */
    externalApiTarget?: InputMaybe<ExternalApiTarget>;
    /** Frequency weighting */
    frequencyWeighting?: InputMaybe<FrequencyWeighting>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** Ln interval */
    lXnInterval?: InputMaybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: InputMaybe<LXtMinMaxInterval>;
    /** lden guideline */
    ldenGuideline?: InputMaybe<LdenGuideline>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Leq Interval */
    lxEqInterval?: InputMaybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: InputMaybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: InputMaybe<MeasuringSchedule>;
    name?: InputMaybe<Scalars['String']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** overridden fields */
    overriddenFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Project */
    project?: InputMaybe<Scalars['ID']['input']>;
    /** Trigger source */
    soundClipAlarmSource?: InputMaybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: InputMaybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: InputMaybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<MeasuringPointSwarmType>;
    /** Time weighting */
    timeWeighting?: InputMaybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type SoundMeasuringPointUpdatePayload = {
    __typename?: 'SoundMeasuringPointUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundMeasuringPoint?: Maybe<SoundMeasuringPoint>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundNotificationPartialConfigCreateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type SoundNotificationPartialConfigCreatePayload = {
    __typename?: 'SoundNotificationPartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundNotificationPartialConfigUpdateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type SoundNotificationPartialConfigUpdatePayload = {
    __typename?: 'SoundNotificationPartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An object that holds all configurations for a sound project. */
export type SoundProject = ProjectInterface & {
    __typename?: 'SoundProject';
    archived?: Maybe<Scalars['Boolean']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    /** daily value settings */
    dailyValueSettings?: Maybe<DailyValueSettings>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    /** Frequency weighting */
    frequencyWeighting?: Maybe<FrequencyWeighting>;
    id: Scalars['ID']['output'];
    /** Ln interval */
    lXnInterval?: Maybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: Maybe<LXtMinMaxInterval>;
    /** lden guideline */
    ldenGuideline?: Maybe<LdenGuideline>;
    /** Location */
    location?: Maybe<Scalars['String']['output']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    /** Leq Interval */
    lxEqInterval?: Maybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: Maybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: Maybe<MeasuringSchedule>;
    name: Scalars['String']['output'];
    notificationConfig?: Maybe<NotificationConfigObject>;
    permission?: Maybe<Permission>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: Maybe<Scalars['String']['output']>;
    /** Trigger source */
    soundClipAlarmSource?: Maybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: Maybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: Maybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: Maybe<Scalars['Float']['output']>;
    swarmType: SwarmType;
    /** Time weighting */
    timeWeighting?: Maybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: Maybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: Maybe<Scalars['Float']['output']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: Maybe<Scalars['Float']['output']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: Maybe<Scalars['Float']['output']>;
};

export type SoundProjectCreateFromExistingMeasuringPointInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing sound_measuring_point */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type SoundProjectCreateFromExistingMeasuringPointPayload = {
    __typename?: 'SoundProjectCreateFromExistingMeasuringPointPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundProject?: Maybe<SoundProject>;
};

export type SoundProjectCreateFromExistingProjectInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing sound_project */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type SoundProjectCreateFromExistingProjectPayload = {
    __typename?: 'SoundProjectCreateFromExistingProjectPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundProject?: Maybe<SoundProject>;
};

export type SoundProjectCreateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** daily value settings */
    dailyValueSettings?: InputMaybe<DailyValueSettingsInput>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** Frequency weighting */
    frequencyWeighting?: InputMaybe<FrequencyWeighting>;
    /** Ln interval */
    lXnInterval?: InputMaybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: InputMaybe<LXtMinMaxInterval>;
    /** lden guideline */
    ldenGuideline?: InputMaybe<LdenGuideline>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Leq Interval */
    lxEqInterval?: InputMaybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: InputMaybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: InputMaybe<MeasuringSchedule>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Trigger source */
    soundClipAlarmSource?: InputMaybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: InputMaybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: InputMaybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<ProjectSwarmType>;
    /** Time weighting */
    timeWeighting?: InputMaybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type SoundProjectCreatePayload = {
    __typename?: 'SoundProjectCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundProject?: Maybe<SoundProject>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundProjectDeleteInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type SoundProjectDeletePayload = {
    __typename?: 'SoundProjectDeletePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundProject?: Maybe<SoundProject>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type SoundProjectUpdateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** daily value settings */
    dailyValueSettings?: InputMaybe<DailyValueSettingsInput>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** Frequency weighting */
    frequencyWeighting?: InputMaybe<FrequencyWeighting>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** Ln interval */
    lXnInterval?: InputMaybe<LXnInterval>;
    /** Lmax interval */
    lXtMinMaxInterval?: InputMaybe<LXtMinMaxInterval>;
    /** lden guideline */
    ldenGuideline?: InputMaybe<LdenGuideline>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Leq Interval */
    lxEqInterval?: InputMaybe<LxEqInterval>;
    /** Lpeak interval */
    lxPeakInterval?: InputMaybe<LxPeakInterval>;
    /** Measuring schedule */
    measuringSchedule?: InputMaybe<MeasuringSchedule>;
    name?: InputMaybe<Scalars['String']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Trigger source */
    soundClipAlarmSource?: InputMaybe<SoundClipAlarmSource>;
    /** Guideline */
    soundGuideline?: InputMaybe<SoundGuideline>;
    /** Correction */
    soundMeasurementCorrectionOption?: InputMaybe<SoundMeasurementCorrectionOption>;
    /** Correction in dB (dB) */
    soundMeasurementCorrectionValue?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<ProjectSwarmType>;
    /** Time weighting */
    timeWeighting?: InputMaybe<TimeWeighting>;
    /** Timezone. What is the timezone of the location of the SWARM Sound? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Alarm level (dB). At least 50.0 dB and at most 140.0 dB */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type SoundProjectUpdatePayload = {
    __typename?: 'SoundProjectUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    soundProject?: Maybe<SoundProject>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type StandaloneMeasuringPointsType = {
    __typename?: 'StandaloneMeasuringPointsType';
    nodes: Array<Maybe<MeasuringPointInterface>>;
    totalCount: Scalars['Int']['output'];
};

export type StoreGraphState = {
    __typename?: 'StoreGraphState';
    ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitPurchaseOrderNumber = {
    __typename?: 'SubmitPurchaseOrderNumber';
    ok?: Maybe<Scalars['Boolean']['output']>;
    request?: Maybe<PurchaseOrderRequestType>;
};

export type SwarmConfig = AirConfig | SoundConfig | VibrationConfig;

export type SwarmFeatures = {
    __typename?: 'SwarmFeatures';
    canActivateSubscription?: Maybe<Scalars['Boolean']['output']>;
    deviceName?: Maybe<Scalars['String']['output']>;
    swarmType?: Maybe<SwarmType>;
    unavailableFeatures?: Maybe<Array<Maybe<UnavailableFeature>>>;
    validSubscription?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum SwarmType {
    Air = 'air',
    Sound = 'sound',
    Vibration = 'vibration',
}

export type TextAttributeEntry = AttributeEntryInterface & {
    __typename?: 'TextAttributeEntry';
    definitionId: Scalars['ID']['output'];
    isSystem: Scalars['Boolean']['output'];
    key: Scalars['String']['output'];
    label: Scalars['String']['output'];
    textValue: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['DateTime']['output']>;
    valueType: AttributeValueType;
};

export type TimeSpan = {
    __typename?: 'TimeSpan';
    from?: Maybe<Scalars['BigInteger']['output']>;
    to?: Maybe<Scalars['BigInteger']['output']>;
};

/** An enumeration. */
export enum TimeWeighting {
    TimeWeightingFast = 'timeWeightingFast',
    TimeWeightingSlow = 'timeWeightingSlow',
}

/** An enumeration. */
export enum Timezone {
    AfricaAbidjan = 'Africa_Abidjan',
    AfricaAccra = 'Africa_Accra',
    AfricaAddisAbaba = 'Africa_Addis_Ababa',
    AfricaAlgiers = 'Africa_Algiers',
    AfricaAsmara = 'Africa_Asmara',
    AfricaAsmera = 'Africa_Asmera',
    AfricaBamako = 'Africa_Bamako',
    AfricaBangui = 'Africa_Bangui',
    AfricaBanjul = 'Africa_Banjul',
    AfricaBissau = 'Africa_Bissau',
    AfricaBlantyre = 'Africa_Blantyre',
    AfricaBrazzaville = 'Africa_Brazzaville',
    AfricaBujumbura = 'Africa_Bujumbura',
    AfricaCairo = 'Africa_Cairo',
    AfricaCasablanca = 'Africa_Casablanca',
    AfricaCeuta = 'Africa_Ceuta',
    AfricaConakry = 'Africa_Conakry',
    AfricaDakar = 'Africa_Dakar',
    AfricaDarEsSalaam = 'Africa_Dar_es_Salaam',
    AfricaDjibouti = 'Africa_Djibouti',
    AfricaDouala = 'Africa_Douala',
    AfricaElAaiun = 'Africa_El_Aaiun',
    AfricaFreetown = 'Africa_Freetown',
    AfricaGaborone = 'Africa_Gaborone',
    AfricaHarare = 'Africa_Harare',
    AfricaJohannesburg = 'Africa_Johannesburg',
    AfricaJuba = 'Africa_Juba',
    AfricaKampala = 'Africa_Kampala',
    AfricaKhartoum = 'Africa_Khartoum',
    AfricaKigali = 'Africa_Kigali',
    AfricaKinshasa = 'Africa_Kinshasa',
    AfricaLagos = 'Africa_Lagos',
    AfricaLibreville = 'Africa_Libreville',
    AfricaLome = 'Africa_Lome',
    AfricaLuanda = 'Africa_Luanda',
    AfricaLubumbashi = 'Africa_Lubumbashi',
    AfricaLusaka = 'Africa_Lusaka',
    AfricaMalabo = 'Africa_Malabo',
    AfricaMaputo = 'Africa_Maputo',
    AfricaMaseru = 'Africa_Maseru',
    AfricaMbabane = 'Africa_Mbabane',
    AfricaMogadishu = 'Africa_Mogadishu',
    AfricaMonrovia = 'Africa_Monrovia',
    AfricaNairobi = 'Africa_Nairobi',
    AfricaNdjamena = 'Africa_Ndjamena',
    AfricaNiamey = 'Africa_Niamey',
    AfricaNouakchott = 'Africa_Nouakchott',
    AfricaOuagadougou = 'Africa_Ouagadougou',
    AfricaPortoMinusNovo = 'Africa_PortoMinusNovo',
    AfricaSaoTome = 'Africa_Sao_Tome',
    AfricaTimbuktu = 'Africa_Timbuktu',
    AfricaTripoli = 'Africa_Tripoli',
    AfricaTunis = 'Africa_Tunis',
    AfricaWindhoek = 'Africa_Windhoek',
    AmericaAdak = 'America_Adak',
    AmericaAnchorage = 'America_Anchorage',
    AmericaAnguilla = 'America_Anguilla',
    AmericaAntigua = 'America_Antigua',
    AmericaAraguaina = 'America_Araguaina',
    AmericaArgentinaBuenosAires = 'America_Argentina_Buenos_Aires',
    AmericaArgentinaCatamarca = 'America_Argentina_Catamarca',
    AmericaArgentinaComodRivadavia = 'America_Argentina_ComodRivadavia',
    AmericaArgentinaCordoba = 'America_Argentina_Cordoba',
    AmericaArgentinaJujuy = 'America_Argentina_Jujuy',
    AmericaArgentinaLaRioja = 'America_Argentina_La_Rioja',
    AmericaArgentinaMendoza = 'America_Argentina_Mendoza',
    AmericaArgentinaRioGallegos = 'America_Argentina_Rio_Gallegos',
    AmericaArgentinaSalta = 'America_Argentina_Salta',
    AmericaArgentinaSanJuan = 'America_Argentina_San_Juan',
    AmericaArgentinaSanLuis = 'America_Argentina_San_Luis',
    AmericaArgentinaTucuman = 'America_Argentina_Tucuman',
    AmericaArgentinaUshuaia = 'America_Argentina_Ushuaia',
    AmericaAruba = 'America_Aruba',
    AmericaAsuncion = 'America_Asuncion',
    AmericaAtikokan = 'America_Atikokan',
    AmericaAtka = 'America_Atka',
    AmericaBahia = 'America_Bahia',
    AmericaBahiaBanderas = 'America_Bahia_Banderas',
    AmericaBarbados = 'America_Barbados',
    AmericaBelem = 'America_Belem',
    AmericaBelize = 'America_Belize',
    AmericaBlancMinusSablon = 'America_BlancMinusSablon',
    AmericaBoaVista = 'America_Boa_Vista',
    AmericaBogota = 'America_Bogota',
    AmericaBoise = 'America_Boise',
    AmericaBuenosAires = 'America_Buenos_Aires',
    AmericaCambridgeBay = 'America_Cambridge_Bay',
    AmericaCampoGrande = 'America_Campo_Grande',
    AmericaCancun = 'America_Cancun',
    AmericaCaracas = 'America_Caracas',
    AmericaCatamarca = 'America_Catamarca',
    AmericaCayenne = 'America_Cayenne',
    AmericaCayman = 'America_Cayman',
    AmericaChicago = 'America_Chicago',
    AmericaChihuahua = 'America_Chihuahua',
    AmericaCoralHarbour = 'America_Coral_Harbour',
    AmericaCordoba = 'America_Cordoba',
    AmericaCostaRica = 'America_Costa_Rica',
    AmericaCreston = 'America_Creston',
    AmericaCuiaba = 'America_Cuiaba',
    AmericaCuracao = 'America_Curacao',
    AmericaDanmarkshavn = 'America_Danmarkshavn',
    AmericaDawson = 'America_Dawson',
    AmericaDawsonCreek = 'America_Dawson_Creek',
    AmericaDenver = 'America_Denver',
    AmericaDetroit = 'America_Detroit',
    AmericaDominica = 'America_Dominica',
    AmericaEdmonton = 'America_Edmonton',
    AmericaEirunepe = 'America_Eirunepe',
    AmericaElSalvador = 'America_El_Salvador',
    AmericaEnsenada = 'America_Ensenada',
    AmericaFortNelson = 'America_Fort_Nelson',
    AmericaFortWayne = 'America_Fort_Wayne',
    AmericaFortaleza = 'America_Fortaleza',
    AmericaGlaceBay = 'America_Glace_Bay',
    AmericaGodthab = 'America_Godthab',
    AmericaGooseBay = 'America_Goose_Bay',
    AmericaGrandTurk = 'America_Grand_Turk',
    AmericaGrenada = 'America_Grenada',
    AmericaGuadeloupe = 'America_Guadeloupe',
    AmericaGuatemala = 'America_Guatemala',
    AmericaGuayaquil = 'America_Guayaquil',
    AmericaGuyana = 'America_Guyana',
    AmericaHalifax = 'America_Halifax',
    AmericaHavana = 'America_Havana',
    AmericaHermosillo = 'America_Hermosillo',
    AmericaIndianaIndianapolis = 'America_Indiana_Indianapolis',
    AmericaIndianaKnox = 'America_Indiana_Knox',
    AmericaIndianaMarengo = 'America_Indiana_Marengo',
    AmericaIndianaPetersburg = 'America_Indiana_Petersburg',
    AmericaIndianaTellCity = 'America_Indiana_Tell_City',
    AmericaIndianaVevay = 'America_Indiana_Vevay',
    AmericaIndianaVincennes = 'America_Indiana_Vincennes',
    AmericaIndianaWinamac = 'America_Indiana_Winamac',
    AmericaIndianapolis = 'America_Indianapolis',
    AmericaInuvik = 'America_Inuvik',
    AmericaIqaluit = 'America_Iqaluit',
    AmericaJamaica = 'America_Jamaica',
    AmericaJujuy = 'America_Jujuy',
    AmericaJuneau = 'America_Juneau',
    AmericaKentuckyLouisville = 'America_Kentucky_Louisville',
    AmericaKentuckyMonticello = 'America_Kentucky_Monticello',
    AmericaKnoxIn = 'America_Knox_IN',
    AmericaKralendijk = 'America_Kralendijk',
    AmericaLaPaz = 'America_La_Paz',
    AmericaLima = 'America_Lima',
    AmericaLosAngeles = 'America_Los_Angeles',
    AmericaLouisville = 'America_Louisville',
    AmericaLowerPrinces = 'America_Lower_Princes',
    AmericaMaceio = 'America_Maceio',
    AmericaManagua = 'America_Managua',
    AmericaManaus = 'America_Manaus',
    AmericaMarigot = 'America_Marigot',
    AmericaMartinique = 'America_Martinique',
    AmericaMatamoros = 'America_Matamoros',
    AmericaMazatlan = 'America_Mazatlan',
    AmericaMendoza = 'America_Mendoza',
    AmericaMenominee = 'America_Menominee',
    AmericaMerida = 'America_Merida',
    AmericaMetlakatla = 'America_Metlakatla',
    AmericaMexicoCity = 'America_Mexico_City',
    AmericaMiquelon = 'America_Miquelon',
    AmericaMoncton = 'America_Moncton',
    AmericaMonterrey = 'America_Monterrey',
    AmericaMontevideo = 'America_Montevideo',
    AmericaMontreal = 'America_Montreal',
    AmericaMontserrat = 'America_Montserrat',
    AmericaNassau = 'America_Nassau',
    AmericaNewYork = 'America_New_York',
    AmericaNipigon = 'America_Nipigon',
    AmericaNome = 'America_Nome',
    AmericaNoronha = 'America_Noronha',
    AmericaNorthDakotaBeulah = 'America_North_Dakota_Beulah',
    AmericaNorthDakotaCenter = 'America_North_Dakota_Center',
    AmericaNorthDakotaNewSalem = 'America_North_Dakota_New_Salem',
    AmericaNuuk = 'America_Nuuk',
    AmericaOjinaga = 'America_Ojinaga',
    AmericaPanama = 'America_Panama',
    AmericaPangnirtung = 'America_Pangnirtung',
    AmericaParamaribo = 'America_Paramaribo',
    AmericaPhoenix = 'America_Phoenix',
    AmericaPortMinusauMinusPrince = 'America_PortMinusauMinusPrince',
    AmericaPortOfSpain = 'America_Port_of_Spain',
    AmericaPortoAcre = 'America_Porto_Acre',
    AmericaPortoVelho = 'America_Porto_Velho',
    AmericaPuertoRico = 'America_Puerto_Rico',
    AmericaPuntaArenas = 'America_Punta_Arenas',
    AmericaRainyRiver = 'America_Rainy_River',
    AmericaRankinInlet = 'America_Rankin_Inlet',
    AmericaRecife = 'America_Recife',
    AmericaRegina = 'America_Regina',
    AmericaResolute = 'America_Resolute',
    AmericaRioBranco = 'America_Rio_Branco',
    AmericaRosario = 'America_Rosario',
    AmericaSantaIsabel = 'America_Santa_Isabel',
    AmericaSantarem = 'America_Santarem',
    AmericaSantiago = 'America_Santiago',
    AmericaSantoDomingo = 'America_Santo_Domingo',
    AmericaSaoPaulo = 'America_Sao_Paulo',
    AmericaScoresbysund = 'America_Scoresbysund',
    AmericaShiprock = 'America_Shiprock',
    AmericaSitka = 'America_Sitka',
    AmericaStBarthelemy = 'America_St_Barthelemy',
    AmericaStJohns = 'America_St_Johns',
    AmericaStKitts = 'America_St_Kitts',
    AmericaStLucia = 'America_St_Lucia',
    AmericaStThomas = 'America_St_Thomas',
    AmericaStVincent = 'America_St_Vincent',
    AmericaSwiftCurrent = 'America_Swift_Current',
    AmericaTegucigalpa = 'America_Tegucigalpa',
    AmericaThule = 'America_Thule',
    AmericaThunderBay = 'America_Thunder_Bay',
    AmericaTijuana = 'America_Tijuana',
    AmericaToronto = 'America_Toronto',
    AmericaTortola = 'America_Tortola',
    AmericaVancouver = 'America_Vancouver',
    AmericaVirgin = 'America_Virgin',
    AmericaWhitehorse = 'America_Whitehorse',
    AmericaWinnipeg = 'America_Winnipeg',
    AmericaYakutat = 'America_Yakutat',
    AmericaYellowknife = 'America_Yellowknife',
    AntarcticaCasey = 'Antarctica_Casey',
    AntarcticaDavis = 'Antarctica_Davis',
    AntarcticaDumontDUrville = 'Antarctica_DumontDUrville',
    AntarcticaMacquarie = 'Antarctica_Macquarie',
    AntarcticaMawson = 'Antarctica_Mawson',
    AntarcticaMcMurdo = 'Antarctica_McMurdo',
    AntarcticaPalmer = 'Antarctica_Palmer',
    AntarcticaRothera = 'Antarctica_Rothera',
    AntarcticaSouthPole = 'Antarctica_South_Pole',
    AntarcticaSyowa = 'Antarctica_Syowa',
    AntarcticaTroll = 'Antarctica_Troll',
    AntarcticaVostok = 'Antarctica_Vostok',
    ArcticLongyearbyen = 'Arctic_Longyearbyen',
    AsiaAden = 'Asia_Aden',
    AsiaAlmaty = 'Asia_Almaty',
    AsiaAmman = 'Asia_Amman',
    AsiaAnadyr = 'Asia_Anadyr',
    AsiaAqtau = 'Asia_Aqtau',
    AsiaAqtobe = 'Asia_Aqtobe',
    AsiaAshgabat = 'Asia_Ashgabat',
    AsiaAshkhabad = 'Asia_Ashkhabad',
    AsiaAtyrau = 'Asia_Atyrau',
    AsiaBaghdad = 'Asia_Baghdad',
    AsiaBahrain = 'Asia_Bahrain',
    AsiaBaku = 'Asia_Baku',
    AsiaBangkok = 'Asia_Bangkok',
    AsiaBarnaul = 'Asia_Barnaul',
    AsiaBeirut = 'Asia_Beirut',
    AsiaBishkek = 'Asia_Bishkek',
    AsiaBrunei = 'Asia_Brunei',
    AsiaCalcutta = 'Asia_Calcutta',
    AsiaChita = 'Asia_Chita',
    AsiaChoibalsan = 'Asia_Choibalsan',
    AsiaChongqing = 'Asia_Chongqing',
    AsiaChungking = 'Asia_Chungking',
    AsiaColombo = 'Asia_Colombo',
    AsiaDacca = 'Asia_Dacca',
    AsiaDamascus = 'Asia_Damascus',
    AsiaDhaka = 'Asia_Dhaka',
    AsiaDili = 'Asia_Dili',
    AsiaDubai = 'Asia_Dubai',
    AsiaDushanbe = 'Asia_Dushanbe',
    AsiaFamagusta = 'Asia_Famagusta',
    AsiaGaza = 'Asia_Gaza',
    AsiaHarbin = 'Asia_Harbin',
    AsiaHebron = 'Asia_Hebron',
    AsiaHoChiMinh = 'Asia_Ho_Chi_Minh',
    AsiaHongKong = 'Asia_Hong_Kong',
    AsiaHovd = 'Asia_Hovd',
    AsiaIrkutsk = 'Asia_Irkutsk',
    AsiaIstanbul = 'Asia_Istanbul',
    AsiaJakarta = 'Asia_Jakarta',
    AsiaJayapura = 'Asia_Jayapura',
    AsiaJerusalem = 'Asia_Jerusalem',
    AsiaKabul = 'Asia_Kabul',
    AsiaKamchatka = 'Asia_Kamchatka',
    AsiaKarachi = 'Asia_Karachi',
    AsiaKashgar = 'Asia_Kashgar',
    AsiaKathmandu = 'Asia_Kathmandu',
    AsiaKatmandu = 'Asia_Katmandu',
    AsiaKhandyga = 'Asia_Khandyga',
    AsiaKolkata = 'Asia_Kolkata',
    AsiaKrasnoyarsk = 'Asia_Krasnoyarsk',
    AsiaKualaLumpur = 'Asia_Kuala_Lumpur',
    AsiaKuching = 'Asia_Kuching',
    AsiaKuwait = 'Asia_Kuwait',
    AsiaMacao = 'Asia_Macao',
    AsiaMacau = 'Asia_Macau',
    AsiaMagadan = 'Asia_Magadan',
    AsiaMakassar = 'Asia_Makassar',
    AsiaManila = 'Asia_Manila',
    AsiaMuscat = 'Asia_Muscat',
    AsiaNicosia = 'Asia_Nicosia',
    AsiaNovokuznetsk = 'Asia_Novokuznetsk',
    AsiaNovosibirsk = 'Asia_Novosibirsk',
    AsiaOmsk = 'Asia_Omsk',
    AsiaOral = 'Asia_Oral',
    AsiaPhnomPenh = 'Asia_Phnom_Penh',
    AsiaPontianak = 'Asia_Pontianak',
    AsiaPyongyang = 'Asia_Pyongyang',
    AsiaQatar = 'Asia_Qatar',
    AsiaQostanay = 'Asia_Qostanay',
    AsiaQyzylorda = 'Asia_Qyzylorda',
    AsiaRangoon = 'Asia_Rangoon',
    AsiaRiyadh = 'Asia_Riyadh',
    AsiaSaigon = 'Asia_Saigon',
    AsiaSakhalin = 'Asia_Sakhalin',
    AsiaSamarkand = 'Asia_Samarkand',
    AsiaSeoul = 'Asia_Seoul',
    AsiaShanghai = 'Asia_Shanghai',
    AsiaSingapore = 'Asia_Singapore',
    AsiaSrednekolymsk = 'Asia_Srednekolymsk',
    AsiaTaipei = 'Asia_Taipei',
    AsiaTashkent = 'Asia_Tashkent',
    AsiaTbilisi = 'Asia_Tbilisi',
    AsiaTehran = 'Asia_Tehran',
    AsiaTelAviv = 'Asia_Tel_Aviv',
    AsiaThimbu = 'Asia_Thimbu',
    AsiaThimphu = 'Asia_Thimphu',
    AsiaTokyo = 'Asia_Tokyo',
    AsiaTomsk = 'Asia_Tomsk',
    AsiaUjungPandang = 'Asia_Ujung_Pandang',
    AsiaUlaanbaatar = 'Asia_Ulaanbaatar',
    AsiaUlanBator = 'Asia_Ulan_Bator',
    AsiaUrumqi = 'Asia_Urumqi',
    AsiaUstMinusNera = 'Asia_UstMinusNera',
    AsiaVientiane = 'Asia_Vientiane',
    AsiaVladivostok = 'Asia_Vladivostok',
    AsiaYakutsk = 'Asia_Yakutsk',
    AsiaYangon = 'Asia_Yangon',
    AsiaYekaterinburg = 'Asia_Yekaterinburg',
    AsiaYerevan = 'Asia_Yerevan',
    AtlanticAzores = 'Atlantic_Azores',
    AtlanticBermuda = 'Atlantic_Bermuda',
    AtlanticCanary = 'Atlantic_Canary',
    AtlanticCapeVerde = 'Atlantic_Cape_Verde',
    AtlanticFaeroe = 'Atlantic_Faeroe',
    AtlanticFaroe = 'Atlantic_Faroe',
    AtlanticJanMayen = 'Atlantic_Jan_Mayen',
    AtlanticMadeira = 'Atlantic_Madeira',
    AtlanticReykjavik = 'Atlantic_Reykjavik',
    AtlanticSouthGeorgia = 'Atlantic_South_Georgia',
    AtlanticStHelena = 'Atlantic_St_Helena',
    AtlanticStanley = 'Atlantic_Stanley',
    AustraliaAct = 'Australia_ACT',
    AustraliaAdelaide = 'Australia_Adelaide',
    AustraliaBrisbane = 'Australia_Brisbane',
    AustraliaBrokenHill = 'Australia_Broken_Hill',
    AustraliaCanberra = 'Australia_Canberra',
    AustraliaCurrie = 'Australia_Currie',
    AustraliaDarwin = 'Australia_Darwin',
    AustraliaEucla = 'Australia_Eucla',
    AustraliaHobart = 'Australia_Hobart',
    AustraliaLhi = 'Australia_LHI',
    AustraliaLindeman = 'Australia_Lindeman',
    AustraliaLordHowe = 'Australia_Lord_Howe',
    AustraliaMelbourne = 'Australia_Melbourne',
    AustraliaNsw = 'Australia_NSW',
    AustraliaNorth = 'Australia_North',
    AustraliaPerth = 'Australia_Perth',
    AustraliaQueensland = 'Australia_Queensland',
    AustraliaSouth = 'Australia_South',
    AustraliaSydney = 'Australia_Sydney',
    AustraliaTasmania = 'Australia_Tasmania',
    AustraliaVictoria = 'Australia_Victoria',
    AustraliaWest = 'Australia_West',
    AustraliaYancowinna = 'Australia_Yancowinna',
    BrazilAcre = 'Brazil_Acre',
    BrazilDeNoronha = 'Brazil_DeNoronha',
    BrazilEast = 'Brazil_East',
    BrazilWest = 'Brazil_West',
    Cet = 'CET',
    Cst6Cdt = 'CST6CDT',
    CanadaAtlantic = 'Canada_Atlantic',
    CanadaCentral = 'Canada_Central',
    CanadaEastern = 'Canada_Eastern',
    CanadaMountain = 'Canada_Mountain',
    CanadaNewfoundland = 'Canada_Newfoundland',
    CanadaPacific = 'Canada_Pacific',
    CanadaSaskatchewan = 'Canada_Saskatchewan',
    CanadaYukon = 'Canada_Yukon',
    ChileContinental = 'Chile_Continental',
    ChileEasterIsland = 'Chile_EasterIsland',
    Cuba = 'Cuba',
    Eet = 'EET',
    Est = 'EST',
    Est5Edt = 'EST5EDT',
    Egypt = 'Egypt',
    Eire = 'Eire',
    EtcGmt = 'Etc_GMT',
    EtcGmt0 = 'Etc_GMT0',
    EtcGmtMinus0 = 'Etc_GMTMinus0',
    EtcGmtMinus1 = 'Etc_GMTMinus1',
    EtcGmtMinus2 = 'Etc_GMTMinus2',
    EtcGmtMinus3 = 'Etc_GMTMinus3',
    EtcGmtMinus4 = 'Etc_GMTMinus4',
    EtcGmtMinus5 = 'Etc_GMTMinus5',
    EtcGmtMinus6 = 'Etc_GMTMinus6',
    EtcGmtMinus7 = 'Etc_GMTMinus7',
    EtcGmtMinus8 = 'Etc_GMTMinus8',
    EtcGmtMinus9 = 'Etc_GMTMinus9',
    EtcGmtMinus10 = 'Etc_GMTMinus10',
    EtcGmtMinus11 = 'Etc_GMTMinus11',
    EtcGmtMinus12 = 'Etc_GMTMinus12',
    EtcGmtMinus13 = 'Etc_GMTMinus13',
    EtcGmtMinus14 = 'Etc_GMTMinus14',
    EtcGmtPlus0 = 'Etc_GMTPlus0',
    EtcGmtPlus1 = 'Etc_GMTPlus1',
    EtcGmtPlus2 = 'Etc_GMTPlus2',
    EtcGmtPlus3 = 'Etc_GMTPlus3',
    EtcGmtPlus4 = 'Etc_GMTPlus4',
    EtcGmtPlus5 = 'Etc_GMTPlus5',
    EtcGmtPlus6 = 'Etc_GMTPlus6',
    EtcGmtPlus7 = 'Etc_GMTPlus7',
    EtcGmtPlus8 = 'Etc_GMTPlus8',
    EtcGmtPlus9 = 'Etc_GMTPlus9',
    EtcGmtPlus10 = 'Etc_GMTPlus10',
    EtcGmtPlus11 = 'Etc_GMTPlus11',
    EtcGmtPlus12 = 'Etc_GMTPlus12',
    EtcGreenwich = 'Etc_Greenwich',
    EtcUct = 'Etc_UCT',
    EtcUtc = 'Etc_UTC',
    EtcUniversal = 'Etc_Universal',
    EtcZulu = 'Etc_Zulu',
    EuropeAmsterdam = 'Europe_Amsterdam',
    EuropeAndorra = 'Europe_Andorra',
    EuropeAstrakhan = 'Europe_Astrakhan',
    EuropeAthens = 'Europe_Athens',
    EuropeBelfast = 'Europe_Belfast',
    EuropeBelgrade = 'Europe_Belgrade',
    EuropeBerlin = 'Europe_Berlin',
    EuropeBratislava = 'Europe_Bratislava',
    EuropeBrussels = 'Europe_Brussels',
    EuropeBucharest = 'Europe_Bucharest',
    EuropeBudapest = 'Europe_Budapest',
    EuropeBusingen = 'Europe_Busingen',
    EuropeChisinau = 'Europe_Chisinau',
    EuropeCopenhagen = 'Europe_Copenhagen',
    EuropeDublin = 'Europe_Dublin',
    EuropeGibraltar = 'Europe_Gibraltar',
    EuropeGuernsey = 'Europe_Guernsey',
    EuropeHelsinki = 'Europe_Helsinki',
    EuropeIsleOfMan = 'Europe_Isle_of_Man',
    EuropeIstanbul = 'Europe_Istanbul',
    EuropeJersey = 'Europe_Jersey',
    EuropeKaliningrad = 'Europe_Kaliningrad',
    EuropeKiev = 'Europe_Kiev',
    EuropeKirov = 'Europe_Kirov',
    EuropeLisbon = 'Europe_Lisbon',
    EuropeLjubljana = 'Europe_Ljubljana',
    EuropeLondon = 'Europe_London',
    EuropeLuxembourg = 'Europe_Luxembourg',
    EuropeMadrid = 'Europe_Madrid',
    EuropeMalta = 'Europe_Malta',
    EuropeMariehamn = 'Europe_Mariehamn',
    EuropeMinsk = 'Europe_Minsk',
    EuropeMonaco = 'Europe_Monaco',
    EuropeMoscow = 'Europe_Moscow',
    EuropeNicosia = 'Europe_Nicosia',
    EuropeOslo = 'Europe_Oslo',
    EuropeParis = 'Europe_Paris',
    EuropePodgorica = 'Europe_Podgorica',
    EuropePrague = 'Europe_Prague',
    EuropeRiga = 'Europe_Riga',
    EuropeRome = 'Europe_Rome',
    EuropeSamara = 'Europe_Samara',
    EuropeSanMarino = 'Europe_San_Marino',
    EuropeSarajevo = 'Europe_Sarajevo',
    EuropeSaratov = 'Europe_Saratov',
    EuropeSimferopol = 'Europe_Simferopol',
    EuropeSkopje = 'Europe_Skopje',
    EuropeSofia = 'Europe_Sofia',
    EuropeStockholm = 'Europe_Stockholm',
    EuropeTallinn = 'Europe_Tallinn',
    EuropeTirane = 'Europe_Tirane',
    EuropeTiraspol = 'Europe_Tiraspol',
    EuropeUlyanovsk = 'Europe_Ulyanovsk',
    EuropeUzhgorod = 'Europe_Uzhgorod',
    EuropeVaduz = 'Europe_Vaduz',
    EuropeVatican = 'Europe_Vatican',
    EuropeVienna = 'Europe_Vienna',
    EuropeVilnius = 'Europe_Vilnius',
    EuropeVolgograd = 'Europe_Volgograd',
    EuropeWarsaw = 'Europe_Warsaw',
    EuropeZagreb = 'Europe_Zagreb',
    EuropeZaporozhye = 'Europe_Zaporozhye',
    EuropeZurich = 'Europe_Zurich',
    Gb = 'GB',
    GbMinusEire = 'GBMinusEire',
    Gmt = 'GMT',
    Gmt0 = 'GMT0',
    GmtMinus0 = 'GMTMinus0',
    GmtPlus0 = 'GMTPlus0',
    Greenwich = 'Greenwich',
    Hst = 'HST',
    Hongkong = 'Hongkong',
    Iceland = 'Iceland',
    IndianAntananarivo = 'Indian_Antananarivo',
    IndianChagos = 'Indian_Chagos',
    IndianChristmas = 'Indian_Christmas',
    IndianCocos = 'Indian_Cocos',
    IndianComoro = 'Indian_Comoro',
    IndianKerguelen = 'Indian_Kerguelen',
    IndianMahe = 'Indian_Mahe',
    IndianMaldives = 'Indian_Maldives',
    IndianMauritius = 'Indian_Mauritius',
    IndianMayotte = 'Indian_Mayotte',
    IndianReunion = 'Indian_Reunion',
    Iran = 'Iran',
    Israel = 'Israel',
    Jamaica = 'Jamaica',
    Japan = 'Japan',
    Kwajalein = 'Kwajalein',
    Libya = 'Libya',
    Met = 'MET',
    Mst = 'MST',
    Mst7Mdt = 'MST7MDT',
    MexicoBajaNorte = 'Mexico_BajaNorte',
    MexicoBajaSur = 'Mexico_BajaSur',
    MexicoGeneral = 'Mexico_General',
    Nz = 'NZ',
    NzMinusChat = 'NZMinusCHAT',
    Navajo = 'Navajo',
    Prc = 'PRC',
    Pst8Pdt = 'PST8PDT',
    PacificApia = 'Pacific_Apia',
    PacificAuckland = 'Pacific_Auckland',
    PacificBougainville = 'Pacific_Bougainville',
    PacificChatham = 'Pacific_Chatham',
    PacificChuuk = 'Pacific_Chuuk',
    PacificEaster = 'Pacific_Easter',
    PacificEfate = 'Pacific_Efate',
    PacificEnderbury = 'Pacific_Enderbury',
    PacificFakaofo = 'Pacific_Fakaofo',
    PacificFiji = 'Pacific_Fiji',
    PacificFunafuti = 'Pacific_Funafuti',
    PacificGalapagos = 'Pacific_Galapagos',
    PacificGambier = 'Pacific_Gambier',
    PacificGuadalcanal = 'Pacific_Guadalcanal',
    PacificGuam = 'Pacific_Guam',
    PacificHonolulu = 'Pacific_Honolulu',
    PacificJohnston = 'Pacific_Johnston',
    PacificKanton = 'Pacific_Kanton',
    PacificKiritimati = 'Pacific_Kiritimati',
    PacificKosrae = 'Pacific_Kosrae',
    PacificKwajalein = 'Pacific_Kwajalein',
    PacificMajuro = 'Pacific_Majuro',
    PacificMarquesas = 'Pacific_Marquesas',
    PacificMidway = 'Pacific_Midway',
    PacificNauru = 'Pacific_Nauru',
    PacificNiue = 'Pacific_Niue',
    PacificNorfolk = 'Pacific_Norfolk',
    PacificNoumea = 'Pacific_Noumea',
    PacificPagoPago = 'Pacific_Pago_Pago',
    PacificPalau = 'Pacific_Palau',
    PacificPitcairn = 'Pacific_Pitcairn',
    PacificPohnpei = 'Pacific_Pohnpei',
    PacificPonape = 'Pacific_Ponape',
    PacificPortMoresby = 'Pacific_Port_Moresby',
    PacificRarotonga = 'Pacific_Rarotonga',
    PacificSaipan = 'Pacific_Saipan',
    PacificSamoa = 'Pacific_Samoa',
    PacificTahiti = 'Pacific_Tahiti',
    PacificTarawa = 'Pacific_Tarawa',
    PacificTongatapu = 'Pacific_Tongatapu',
    PacificTruk = 'Pacific_Truk',
    PacificWake = 'Pacific_Wake',
    PacificWallis = 'Pacific_Wallis',
    PacificYap = 'Pacific_Yap',
    Poland = 'Poland',
    Portugal = 'Portugal',
    Roc = 'ROC',
    Rok = 'ROK',
    Singapore = 'Singapore',
    Turkey = 'Turkey',
    Uct = 'UCT',
    UsAlaska = 'US_Alaska',
    UsAleutian = 'US_Aleutian',
    UsArizona = 'US_Arizona',
    UsCentral = 'US_Central',
    UsEastMinusIndiana = 'US_EastMinusIndiana',
    UsEastern = 'US_Eastern',
    UsHawaii = 'US_Hawaii',
    UsIndianaMinusStarke = 'US_IndianaMinusStarke',
    UsMichigan = 'US_Michigan',
    UsMountain = 'US_Mountain',
    UsPacific = 'US_Pacific',
    UsSamoa = 'US_Samoa',
    Utc = 'UTC',
    Universal = 'Universal',
    Wet = 'WET',
    WMinusSu = 'WMinusSU',
    Zulu = 'Zulu',
}

export type ToggleProjectStar = {
    __typename?: 'ToggleProjectStar';
    isStarred: Scalars['Boolean']['output'];
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type TopBannerConfigType = {
    __typename?: 'TopBannerConfigType';
    campaignKey: Scalars['String']['output'];
    content: TopBannerContentType;
    cookieTtlDays: Scalars['Int']['output'];
    id: Scalars['ID']['output'];
};

export type TopBannerContentCtaType = {
    __typename?: 'TopBannerContentCtaType';
    text: Scalars['String']['output'];
    url: Scalars['String']['output'];
};

export type TopBannerContentItemType = {
    __typename?: 'TopBannerContentItemType';
    text: Scalars['String']['output'];
    url?: Maybe<Scalars['String']['output']>;
};

export type TopBannerContentType = {
    __typename?: 'TopBannerContentType';
    cta?: Maybe<TopBannerContentCtaType>;
    items: Array<TopBannerContentItemType>;
    prefixText: Scalars['String']['output'];
};

export type Trace = RecordInterface & {
    __typename?: 'Trace';
    end?: Maybe<Scalars['BigInteger']['output']>;
    start?: Maybe<Scalars['BigInteger']['output']>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type UnavailableFeature = {
    __typename?: 'UnavailableFeature';
    field?: Maybe<Scalars['String']['output']>;
    option?: Maybe<Scalars['String']['output']>;
    showBanner?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum Underground {
    ClaySiltSandGravel = 'claySiltSandGravel',
    Moraine = 'moraine',
    Mountain = 'mountain',
}

export type UndoMyMeasuringPointShare = {
    __typename?: 'UndoMyMeasuringPointShare';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type UndoMyProjectShare = {
    __typename?: 'UndoMyProjectShare';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateContactInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactPayload = {
    __typename?: 'UpdateContactPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** The mutated object. */
    contact?: Maybe<ContactType>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
};

export type UpdateGraphReportLastDownloaded = {
    __typename?: 'UpdateGraphReportLastDownloaded';
    graphReport?: Maybe<GraphReportType>;
};

export type UpdateMeasuringPointComment = {
    __typename?: 'UpdateMeasuringPointComment';
    measuringPointComment?: Maybe<MeasuringPointCommentType>;
};

export type UpdateMeasuringPointPrivateNotes = {
    __typename?: 'UpdateMeasuringPointPrivateNotes';
    measuringPoint?: Maybe<MeasuringPointInterface>;
};

export type UpdateProjectPrivateNotes = {
    __typename?: 'UpdateProjectPrivateNotes';
    project?: Maybe<ProjectInterface>;
};

export type UpdateReportTemplate = {
    __typename?: 'UpdateReportTemplate';
    reportTemplate?: Maybe<ReportTemplateType>;
};

export type UserType = {
    __typename?: 'UserType';
    email: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastName: Scalars['String']['output'];
    /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
    username: Scalars['String']['output'];
};

export type Vdv = {
    __typename?: 'VDV';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum VdvX {
    Bs6841Wb = 'BS6841_Wb',
    Bs6841Wc = 'BS6841_Wc',
    Bs6841Wd = 'BS6841_Wd',
    Bs6841We = 'BS6841_We',
    Bs6841Wf = 'BS6841_Wf',
    Bs6841Wg = 'BS6841_Wg',
    Iso2631Wc = 'ISO2631_Wc',
    Iso2631Wd = 'ISO2631_Wd',
    Iso2631We = 'ISO2631_We',
    Iso2631Wf = 'ISO2631_Wf',
    Iso2631Wj = 'ISO2631_Wj',
    Iso2631Wk = 'ISO2631_Wk',
    Iso2631Wm = 'ISO2631_Wm',
    Iso5349Wh = 'ISO5349_Wh',
    Iso8041Wh = 'ISO8041_Wh',
}

/** An enumeration. */
export enum VdvY {
    Bs6841Wb = 'BS6841_Wb',
    Bs6841Wc = 'BS6841_Wc',
    Bs6841Wd = 'BS6841_Wd',
    Bs6841We = 'BS6841_We',
    Bs6841Wf = 'BS6841_Wf',
    Bs6841Wg = 'BS6841_Wg',
    Iso2631Wc = 'ISO2631_Wc',
    Iso2631Wd = 'ISO2631_Wd',
    Iso2631We = 'ISO2631_We',
    Iso2631Wf = 'ISO2631_Wf',
    Iso2631Wj = 'ISO2631_Wj',
    Iso2631Wk = 'ISO2631_Wk',
    Iso2631Wm = 'ISO2631_Wm',
    Iso5349Wh = 'ISO5349_Wh',
    Iso8041Wh = 'ISO8041_Wh',
}

/** An enumeration. */
export enum VdvZ {
    Bs6841Wb = 'BS6841_Wb',
    Bs6841Wc = 'BS6841_Wc',
    Bs6841Wd = 'BS6841_Wd',
    Bs6841We = 'BS6841_We',
    Bs6841Wf = 'BS6841_Wf',
    Bs6841Wg = 'BS6841_Wg',
    Iso2631Wc = 'ISO2631_Wc',
    Iso2631Wd = 'ISO2631_Wd',
    Iso2631We = 'ISO2631_We',
    Iso2631Wf = 'ISO2631_Wf',
    Iso2631Wj = 'ISO2631_Wj',
    Iso2631Wk = 'ISO2631_Wk',
    Iso2631Wm = 'ISO2631_Wm',
    Iso5349Wh = 'ISO5349_Wh',
    Iso8041Wh = 'ISO8041_Wh',
}

export type Veff = {
    __typename?: 'Veff';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    vper?: Maybe<Xyz>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum VeffBuildingType {
    Commercial = 'commercial',
    CriticalWorkspaces = 'criticalWorkspaces',
    Healthcare = 'healthcare',
    Industrial = 'industrial',
    MeetingBuildings = 'meetingBuildings',
    Mixed = 'mixed',
    OfficeAndEducation = 'officeAndEducation',
    Residential = 'residential',
}

/** An enumeration. */
export enum VeffCircumstance {
    ContinuousLongTerm = 'continuousLongTerm',
    ContinuousOrRepeatedShortTerm = 'continuousOrRepeatedShortTerm',
    Incidental = 'incidental',
    RepeatedLongTerm = 'repeatedLongTerm',
}

/** An enumeration. */
export enum VeffDurationOfActivities {
    FiveDays = 'fiveDays',
    FourDays = 'fourDays',
    OneDay = 'oneDay',
    SixToTwentySixDays = 'sixToTwentySixDays',
    ThreeDays = 'threeDays',
    TwentySevenToSeventyEightDays = 'twentySevenToSeventyEightDays',
    TwoDays = 'twoDays',
}

/** An enumeration. */
export enum VeffSituation {
    Changed = 'changed',
    Existing = 'existing',
    New = 'new',
}

export enum VerificationStatus {
    Failed = 'FAILED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Verified = 'VERIFIED',
}

export type VibrationConfig = {
    __typename?: 'VibrationConfig';
    alarmValue?: Maybe<Scalars['Float']['output']>;
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: Maybe<Scalars['Float']['output']>;
    /** Evaluation type */
    buildingLevel?: Maybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: Maybe<BuildingState>;
    /** Building category */
    category?: Maybe<Category>;
    /** Concrete setting level */
    concreteSettingLevel?: Maybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: Maybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: Maybe<Scalars['Float']['output']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: Maybe<Scalars['Float']['output']>;
    /** Foundation type */
    foundationType?: Maybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: Maybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: Maybe<GroundCondition>;
    /** Guideline */
    guideLine?: Maybe<GuideLine>;
    id?: Maybe<Scalars['Int']['output']>;
    /** Day AO */
    kbfCustomLimitDayAo?: Maybe<Scalars['Float']['output']>;
    /** Day AR */
    kbfCustomLimitDayAr?: Maybe<Scalars['Float']['output']>;
    /** Day AU */
    kbfCustomLimitDayAu?: Maybe<Scalars['Float']['output']>;
    /** Night AO */
    kbfCustomLimitNightAo?: Maybe<Scalars['Float']['output']>;
    /** Night AR */
    kbfCustomLimitNightAr?: Maybe<Scalars['Float']['output']>;
    /** Night AU */
    kbfCustomLimitNightAu?: Maybe<Scalars['Float']['output']>;
    /** Rail traffic */
    kbfRailTraffic?: Maybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: Maybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: Maybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: Maybe<LiningMaterial>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: Maybe<Scalars['Int']['output']>;
    /** Type of measurement */
    measuringType?: Maybe<MeasuringType>;
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: Maybe<Scalars['Int']['output']>;
    /** Store values below threshold */
    noiseSavingEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Pipeline type */
    pipelineType?: Maybe<PipelineType>;
    schedule?: Maybe<ScheduleObject>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: Maybe<Scalars['ID']['output']>;
    /** Sensitivity class */
    sensitivityClass?: Maybe<SensitivityClass>;
    sensorPk?: Maybe<Scalars['Int']['output']>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: Maybe<Scalars['Float']['output']>;
    /** swarm type */
    swarmType?: Maybe<SwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: Maybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: Maybe<Scalars['Float']['output']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: Maybe<Scalars['Float']['output']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: Maybe<Scalars['Float']['output']>;
    /** Underground */
    underground?: Maybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: Maybe<Scalars['Int']['output']>;
    /** VDV frequency weighting X */
    vdvX?: Maybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: Maybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: Maybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Building function */
    veffBuildingType?: Maybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: Maybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: Maybe<Scalars['Float']['output']>;
    /** Day A2 */
    veffCustomLimitDayA2?: Maybe<Scalars['Float']['output']>;
    /** Day A3 */
    veffCustomLimitDayA3?: Maybe<Scalars['Float']['output']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: Maybe<Scalars['Float']['output']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: Maybe<Scalars['Float']['output']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: Maybe<Scalars['Float']['output']>;
    /** Night A1 */
    veffCustomLimitNightA1?: Maybe<Scalars['Float']['output']>;
    /** Night A2 */
    veffCustomLimitNightA2?: Maybe<Scalars['Float']['output']>;
    /** Night A3 */
    veffCustomLimitNightA3?: Maybe<Scalars['Float']['output']>;
    /** Duration of the activities */
    veffDurationOfActivities?: Maybe<VeffDurationOfActivities>;
    veffEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Lower degree of protection */
    veffLowerProtection?: Maybe<Scalars['Boolean']['output']>;
    /** Situation */
    veffSituation?: Maybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: Maybe<Scalars['Boolean']['output']>;
    /** Vibration source */
    vibrationSource?: Maybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: Maybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: Maybe<ZetGevLaagdikte>;
};

export type VibrationGeneralPartialConfigCreateInput = {
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Evaluation type */
    buildingLevel?: InputMaybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: InputMaybe<BuildingState>;
    /** Building category */
    category?: InputMaybe<Category>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Concrete setting level */
    concreteSettingLevel?: InputMaybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: InputMaybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Foundation type */
    foundationType?: InputMaybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: InputMaybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: InputMaybe<GroundCondition>;
    /** Guideline */
    guideLine?: InputMaybe<GuideLine>;
    /** Day AO */
    kbfCustomLimitDayAo?: InputMaybe<Scalars['Float']['input']>;
    /** Day AR */
    kbfCustomLimitDayAr?: InputMaybe<Scalars['Float']['input']>;
    /** Day AU */
    kbfCustomLimitDayAu?: InputMaybe<Scalars['Float']['input']>;
    /** Night AO */
    kbfCustomLimitNightAo?: InputMaybe<Scalars['Float']['input']>;
    /** Night AR */
    kbfCustomLimitNightAr?: InputMaybe<Scalars['Float']['input']>;
    /** Night AU */
    kbfCustomLimitNightAu?: InputMaybe<Scalars['Float']['input']>;
    /** Rail traffic */
    kbfRailTraffic?: InputMaybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: InputMaybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: InputMaybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: InputMaybe<LiningMaterial>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Type of measurement */
    measuringType?: InputMaybe<MeasuringType>;
    name: Scalars['String']['input'];
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Store values below threshold */
    noiseSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Pipeline type */
    pipelineType?: InputMaybe<PipelineType>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: InputMaybe<Scalars['ID']['input']>;
    /** Sensitivity class */
    sensitivityClass?: InputMaybe<SensitivityClass>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: InputMaybe<Scalars['Float']['input']>;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Underground */
    underground?: InputMaybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: InputMaybe<Scalars['Int']['input']>;
    /** VDV frequency weighting X */
    vdvX?: InputMaybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: InputMaybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: InputMaybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Building function */
    veffBuildingType?: InputMaybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: InputMaybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: InputMaybe<Scalars['Float']['input']>;
    /** Day A2 */
    veffCustomLimitDayA2?: InputMaybe<Scalars['Float']['input']>;
    /** Day A3 */
    veffCustomLimitDayA3?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: InputMaybe<Scalars['Float']['input']>;
    /** Night A1 */
    veffCustomLimitNightA1?: InputMaybe<Scalars['Float']['input']>;
    /** Night A2 */
    veffCustomLimitNightA2?: InputMaybe<Scalars['Float']['input']>;
    /** Night A3 */
    veffCustomLimitNightA3?: InputMaybe<Scalars['Float']['input']>;
    /** Duration of the activities */
    veffDurationOfActivities?: InputMaybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: InputMaybe<Scalars['Boolean']['input']>;
    /** Situation */
    veffSituation?: InputMaybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: InputMaybe<Scalars['Boolean']['input']>;
    /** Vibration source */
    vibrationSource?: InputMaybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: InputMaybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: InputMaybe<ZetGevLaagdikte>;
};

export type VibrationGeneralPartialConfigCreatePayload = {
    __typename?: 'VibrationGeneralPartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationGeneralPartialConfigUpdateInput = {
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Evaluation type */
    buildingLevel?: InputMaybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: InputMaybe<BuildingState>;
    /** Building category */
    category?: InputMaybe<Category>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Concrete setting level */
    concreteSettingLevel?: InputMaybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: InputMaybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Foundation type */
    foundationType?: InputMaybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: InputMaybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: InputMaybe<GroundCondition>;
    /** Guideline */
    guideLine?: InputMaybe<GuideLine>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** Day AO */
    kbfCustomLimitDayAo?: InputMaybe<Scalars['Float']['input']>;
    /** Day AR */
    kbfCustomLimitDayAr?: InputMaybe<Scalars['Float']['input']>;
    /** Day AU */
    kbfCustomLimitDayAu?: InputMaybe<Scalars['Float']['input']>;
    /** Night AO */
    kbfCustomLimitNightAo?: InputMaybe<Scalars['Float']['input']>;
    /** Night AR */
    kbfCustomLimitNightAr?: InputMaybe<Scalars['Float']['input']>;
    /** Night AU */
    kbfCustomLimitNightAu?: InputMaybe<Scalars['Float']['input']>;
    /** Rail traffic */
    kbfRailTraffic?: InputMaybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: InputMaybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: InputMaybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: InputMaybe<LiningMaterial>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Type of measurement */
    measuringType?: InputMaybe<MeasuringType>;
    name: Scalars['String']['input'];
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Store values below threshold */
    noiseSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Pipeline type */
    pipelineType?: InputMaybe<PipelineType>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: InputMaybe<Scalars['ID']['input']>;
    /** Sensitivity class */
    sensitivityClass?: InputMaybe<SensitivityClass>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: InputMaybe<Scalars['Float']['input']>;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Underground */
    underground?: InputMaybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: InputMaybe<Scalars['Int']['input']>;
    /** VDV frequency weighting X */
    vdvX?: InputMaybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: InputMaybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: InputMaybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Building function */
    veffBuildingType?: InputMaybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: InputMaybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: InputMaybe<Scalars['Float']['input']>;
    /** Day A2 */
    veffCustomLimitDayA2?: InputMaybe<Scalars['Float']['input']>;
    /** Day A3 */
    veffCustomLimitDayA3?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: InputMaybe<Scalars['Float']['input']>;
    /** Night A1 */
    veffCustomLimitNightA1?: InputMaybe<Scalars['Float']['input']>;
    /** Night A2 */
    veffCustomLimitNightA2?: InputMaybe<Scalars['Float']['input']>;
    /** Night A3 */
    veffCustomLimitNightA3?: InputMaybe<Scalars['Float']['input']>;
    /** Duration of the activities */
    veffDurationOfActivities?: InputMaybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: InputMaybe<Scalars['Boolean']['input']>;
    /** Situation */
    veffSituation?: InputMaybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: InputMaybe<Scalars['Boolean']['input']>;
    /** Vibration source */
    vibrationSource?: InputMaybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: InputMaybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: InputMaybe<ZetGevLaagdikte>;
};

export type VibrationGeneralPartialConfigUpdatePayload = {
    __typename?: 'VibrationGeneralPartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An object that holds all configurations for a vibration measuring point. */
export type VibrationMeasuringPoint = MeasuringPointInterface & {
    __typename?: 'VibrationMeasuringPoint';
    alarmValue?: Maybe<Scalars['Float']['output']>;
    archived?: Maybe<Scalars['Boolean']['output']>;
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: Maybe<Scalars['Float']['output']>;
    /** Evaluation type */
    buildingLevel?: Maybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: Maybe<BuildingState>;
    /** Building category */
    category?: Maybe<Category>;
    city?: Maybe<Scalars['String']['output']>;
    /** Concrete setting level */
    concreteSettingLevel?: Maybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: Maybe<ConstructionType>;
    coordinates?: Maybe<CoordinatesType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: Maybe<Scalars['Float']['output']>;
    /** Unique name of your SWARM Vibration. This name is placed on the front of the SWARM Vibration */
    deviceName?: Maybe<Scalars['String']['output']>;
    directShare: Scalars['Boolean']['output'];
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: Maybe<Scalars['Float']['output']>;
    /** Foundation type */
    foundationType?: Maybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: Maybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: Maybe<GroundCondition>;
    /** Guideline */
    guideLine?: Maybe<GuideLine>;
    /** Number of highest records in PDF */
    highestNRecords?: Maybe<Scalars['Int']['output']>;
    /** List highest reading per axis per day in PDF */
    highestReadingPerDay?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    /** Day AO */
    kbfCustomLimitDayAo?: Maybe<Scalars['Float']['output']>;
    /** Day AR */
    kbfCustomLimitDayAr?: Maybe<Scalars['Float']['output']>;
    /** Day AU */
    kbfCustomLimitDayAu?: Maybe<Scalars['Float']['output']>;
    /** Night AO */
    kbfCustomLimitNightAo?: Maybe<Scalars['Float']['output']>;
    /** Night AR */
    kbfCustomLimitNightAr?: Maybe<Scalars['Float']['output']>;
    /** Night AU */
    kbfCustomLimitNightAu?: Maybe<Scalars['Float']['output']>;
    /** Rail traffic */
    kbfRailTraffic?: Maybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: Maybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: Maybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: Maybe<LiningMaterial>;
    /** Location */
    location?: Maybe<Scalars['String']['output']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: Maybe<Scalars['Int']['output']>;
    /** Type of measurement */
    measuringType?: Maybe<MeasuringType>;
    name: Scalars['String']['output'];
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: Maybe<Scalars['Int']['output']>;
    /** Store values below threshold */
    noiseSavingEnabled?: Maybe<Scalars['Boolean']['output']>;
    notificationConfig?: Maybe<NotificationConfigObject>;
    /** overridden fields */
    overriddenFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    pastSensors?: Maybe<Array<Maybe<PastSensorType>>>;
    permission?: Maybe<Permission>;
    /** Pipeline type */
    pipelineType?: Maybe<PipelineType>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: Maybe<Scalars['String']['output']>;
    /** Project */
    project?: Maybe<Scalars['ID']['output']>;
    schedule?: Maybe<ScheduleObject>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: Maybe<Scalars['ID']['output']>;
    /** Sensitivity class */
    sensitivityClass?: Maybe<SensitivityClass>;
    sensor?: Maybe<Sensor>;
    /** Show alarm levels in the graph */
    showAlarms?: Maybe<Scalars['Boolean']['output']>;
    /** Show exceedances in the PDF */
    showExceedancesInPdf?: Maybe<Scalars['Boolean']['output']>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: Maybe<Scalars['Float']['output']>;
    status: MeasuringPointStatus;
    swarmType: SwarmType;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: Maybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: Maybe<Scalars['Float']['output']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: Maybe<Scalars['Float']['output']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: Maybe<Scalars['Float']['output']>;
    /** Underground */
    underground?: Maybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: Maybe<Scalars['Int']['output']>;
    /** VDV frequency weighting X */
    vdvX?: Maybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: Maybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: Maybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Building function */
    veffBuildingType?: Maybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: Maybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: Maybe<Scalars['Float']['output']>;
    /** Day A2 */
    veffCustomLimitDayA2?: Maybe<Scalars['Float']['output']>;
    /** Day A3 */
    veffCustomLimitDayA3?: Maybe<Scalars['Float']['output']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: Maybe<Scalars['Float']['output']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: Maybe<Scalars['Float']['output']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: Maybe<Scalars['Float']['output']>;
    /** Night A1 */
    veffCustomLimitNightA1?: Maybe<Scalars['Float']['output']>;
    /** Night A2 */
    veffCustomLimitNightA2?: Maybe<Scalars['Float']['output']>;
    /** Night A3 */
    veffCustomLimitNightA3?: Maybe<Scalars['Float']['output']>;
    /** Duration of the activities */
    veffDurationOfActivities?: Maybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: Maybe<Scalars['Boolean']['output']>;
    /** Situation */
    veffSituation?: Maybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: Maybe<Scalars['Boolean']['output']>;
    /** Vibration source */
    vibrationSource?: Maybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: Maybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: Maybe<ZetGevLaagdikte>;
};

export type VibrationMeasuringPointCreateFromExistingMeasuringPointInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing vibration_measuring_point */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type VibrationMeasuringPointCreateFromExistingMeasuringPointPayload = {
    __typename?: 'VibrationMeasuringPointCreateFromExistingMeasuringPointPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationMeasuringPoint?: Maybe<VibrationMeasuringPoint>;
};

export type VibrationMeasuringPointCreateFromExistingProjectInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing vibration_project */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type VibrationMeasuringPointCreateFromExistingProjectPayload = {
    __typename?: 'VibrationMeasuringPointCreateFromExistingProjectPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationMeasuringPoint?: Maybe<VibrationMeasuringPoint>;
};

export type VibrationMeasuringPointCreateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Evaluation type */
    buildingLevel?: InputMaybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: InputMaybe<BuildingState>;
    /** Building category */
    category?: InputMaybe<Category>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Concrete setting level */
    concreteSettingLevel?: InputMaybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: InputMaybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Unique name of your SWARM Vibration. This name is placed on the front of the SWARM Vibration */
    deviceName?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Foundation type */
    foundationType?: InputMaybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: InputMaybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: InputMaybe<GroundCondition>;
    /** Guideline */
    guideLine?: InputMaybe<GuideLine>;
    /** Number of highest records in PDF */
    highestNRecords?: InputMaybe<Scalars['Int']['input']>;
    /** List highest reading per axis per day in PDF */
    highestReadingPerDay?: InputMaybe<Scalars['Boolean']['input']>;
    /** Day AO */
    kbfCustomLimitDayAo?: InputMaybe<Scalars['Float']['input']>;
    /** Day AR */
    kbfCustomLimitDayAr?: InputMaybe<Scalars['Float']['input']>;
    /** Day AU */
    kbfCustomLimitDayAu?: InputMaybe<Scalars['Float']['input']>;
    /** Night AO */
    kbfCustomLimitNightAo?: InputMaybe<Scalars['Float']['input']>;
    /** Night AR */
    kbfCustomLimitNightAr?: InputMaybe<Scalars['Float']['input']>;
    /** Night AU */
    kbfCustomLimitNightAu?: InputMaybe<Scalars['Float']['input']>;
    /** Rail traffic */
    kbfRailTraffic?: InputMaybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: InputMaybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: InputMaybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: InputMaybe<LiningMaterial>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Type of measurement */
    measuringType?: InputMaybe<MeasuringType>;
    name: Scalars['String']['input'];
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Store values below threshold */
    noiseSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** overridden fields */
    overriddenFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Pipeline type */
    pipelineType?: InputMaybe<PipelineType>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Project */
    project?: InputMaybe<Scalars['ID']['input']>;
    schedule?: InputMaybe<ScheduleInputObject>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: InputMaybe<Scalars['ID']['input']>;
    /** Sensitivity class */
    sensitivityClass?: InputMaybe<SensitivityClass>;
    /** Show alarm levels in the graph */
    showAlarms?: InputMaybe<Scalars['Boolean']['input']>;
    /** Show exceedances in the PDF */
    showExceedancesInPdf?: InputMaybe<Scalars['Boolean']['input']>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<MeasuringPointSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Underground */
    underground?: InputMaybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: InputMaybe<Scalars['Int']['input']>;
    /** VDV frequency weighting X */
    vdvX?: InputMaybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: InputMaybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: InputMaybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Building function */
    veffBuildingType?: InputMaybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: InputMaybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: InputMaybe<Scalars['Float']['input']>;
    /** Day A2 */
    veffCustomLimitDayA2?: InputMaybe<Scalars['Float']['input']>;
    /** Day A3 */
    veffCustomLimitDayA3?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: InputMaybe<Scalars['Float']['input']>;
    /** Night A1 */
    veffCustomLimitNightA1?: InputMaybe<Scalars['Float']['input']>;
    /** Night A2 */
    veffCustomLimitNightA2?: InputMaybe<Scalars['Float']['input']>;
    /** Night A3 */
    veffCustomLimitNightA3?: InputMaybe<Scalars['Float']['input']>;
    /** Duration of the activities */
    veffDurationOfActivities?: InputMaybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: InputMaybe<Scalars['Boolean']['input']>;
    /** Situation */
    veffSituation?: InputMaybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: InputMaybe<Scalars['Boolean']['input']>;
    /** Vibration source */
    vibrationSource?: InputMaybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: InputMaybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: InputMaybe<ZetGevLaagdikte>;
};

export type VibrationMeasuringPointCreatePayload = {
    __typename?: 'VibrationMeasuringPointCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationMeasuringPoint?: Maybe<VibrationMeasuringPoint>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationMeasuringPointDeleteInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type VibrationMeasuringPointDeletePayload = {
    __typename?: 'VibrationMeasuringPointDeletePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationMeasuringPoint?: Maybe<VibrationMeasuringPoint>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationMeasuringPointUpdateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Evaluation type */
    buildingLevel?: InputMaybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: InputMaybe<BuildingState>;
    /** Building category */
    category?: InputMaybe<Category>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Concrete setting level */
    concreteSettingLevel?: InputMaybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: InputMaybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Unique name of your SWARM Vibration. This name is placed on the front of the SWARM Vibration */
    deviceName?: InputMaybe<Scalars['String']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Foundation type */
    foundationType?: InputMaybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: InputMaybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: InputMaybe<GroundCondition>;
    /** Guideline */
    guideLine?: InputMaybe<GuideLine>;
    /** Number of highest records in PDF */
    highestNRecords?: InputMaybe<Scalars['Int']['input']>;
    /** List highest reading per axis per day in PDF */
    highestReadingPerDay?: InputMaybe<Scalars['Boolean']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** Day AO */
    kbfCustomLimitDayAo?: InputMaybe<Scalars['Float']['input']>;
    /** Day AR */
    kbfCustomLimitDayAr?: InputMaybe<Scalars['Float']['input']>;
    /** Day AU */
    kbfCustomLimitDayAu?: InputMaybe<Scalars['Float']['input']>;
    /** Night AO */
    kbfCustomLimitNightAo?: InputMaybe<Scalars['Float']['input']>;
    /** Night AR */
    kbfCustomLimitNightAr?: InputMaybe<Scalars['Float']['input']>;
    /** Night AU */
    kbfCustomLimitNightAu?: InputMaybe<Scalars['Float']['input']>;
    /** Rail traffic */
    kbfRailTraffic?: InputMaybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: InputMaybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: InputMaybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: InputMaybe<LiningMaterial>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Type of measurement */
    measuringType?: InputMaybe<MeasuringType>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Store values below threshold */
    noiseSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** overridden fields */
    overriddenFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Pipeline type */
    pipelineType?: InputMaybe<PipelineType>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    /** Project */
    project?: InputMaybe<Scalars['ID']['input']>;
    schedule?: InputMaybe<ScheduleInputObject>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: InputMaybe<Scalars['ID']['input']>;
    /** Sensitivity class */
    sensitivityClass?: InputMaybe<SensitivityClass>;
    /** Show alarm levels in the graph */
    showAlarms?: InputMaybe<Scalars['Boolean']['input']>;
    /** Show exceedances in the PDF */
    showExceedancesInPdf?: InputMaybe<Scalars['Boolean']['input']>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<MeasuringPointSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Underground */
    underground?: InputMaybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: InputMaybe<Scalars['Int']['input']>;
    /** VDV frequency weighting X */
    vdvX?: InputMaybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: InputMaybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: InputMaybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Building function */
    veffBuildingType?: InputMaybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: InputMaybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: InputMaybe<Scalars['Float']['input']>;
    /** Day A2 */
    veffCustomLimitDayA2?: InputMaybe<Scalars['Float']['input']>;
    /** Day A3 */
    veffCustomLimitDayA3?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: InputMaybe<Scalars['Float']['input']>;
    /** Night A1 */
    veffCustomLimitNightA1?: InputMaybe<Scalars['Float']['input']>;
    /** Night A2 */
    veffCustomLimitNightA2?: InputMaybe<Scalars['Float']['input']>;
    /** Night A3 */
    veffCustomLimitNightA3?: InputMaybe<Scalars['Float']['input']>;
    /** Duration of the activities */
    veffDurationOfActivities?: InputMaybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: InputMaybe<Scalars['Boolean']['input']>;
    /** Situation */
    veffSituation?: InputMaybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: InputMaybe<Scalars['Boolean']['input']>;
    /** Vibration source */
    vibrationSource?: InputMaybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: InputMaybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: InputMaybe<ZetGevLaagdikte>;
};

export type VibrationMeasuringPointUpdatePayload = {
    __typename?: 'VibrationMeasuringPointUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationMeasuringPoint?: Maybe<VibrationMeasuringPoint>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationNotificationPartialConfigCreateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type VibrationNotificationPartialConfigCreatePayload = {
    __typename?: 'VibrationNotificationPartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationNotificationPartialConfigUpdateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
};

export type VibrationNotificationPartialConfigUpdatePayload = {
    __typename?: 'VibrationNotificationPartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An object that holds all configurations for a vibration project. */
export type VibrationProject = ProjectInterface & {
    __typename?: 'VibrationProject';
    alarmValue?: Maybe<Scalars['Float']['output']>;
    archived?: Maybe<Scalars['Boolean']['output']>;
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: Maybe<Scalars['Float']['output']>;
    /** Evaluation type */
    buildingLevel?: Maybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: Maybe<BuildingState>;
    /** Building category */
    category?: Maybe<Category>;
    city?: Maybe<Scalars['String']['output']>;
    /** Concrete setting level */
    concreteSettingLevel?: Maybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: Maybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: Maybe<Scalars['Float']['output']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: Maybe<Scalars['Boolean']['output']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: Maybe<Scalars['Float']['output']>;
    /** Foundation type */
    foundationType?: Maybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: Maybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: Maybe<GroundCondition>;
    /** Guideline */
    guideLine?: Maybe<GuideLine>;
    /** Number of highest records in PDF */
    highestNRecords?: Maybe<Scalars['Int']['output']>;
    /** List highest reading per axis per day in PDF */
    highestReadingPerDay?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    /** Day AO */
    kbfCustomLimitDayAo?: Maybe<Scalars['Float']['output']>;
    /** Day AR */
    kbfCustomLimitDayAr?: Maybe<Scalars['Float']['output']>;
    /** Day AU */
    kbfCustomLimitDayAu?: Maybe<Scalars['Float']['output']>;
    /** Night AO */
    kbfCustomLimitNightAo?: Maybe<Scalars['Float']['output']>;
    /** Night AR */
    kbfCustomLimitNightAr?: Maybe<Scalars['Float']['output']>;
    /** Night AU */
    kbfCustomLimitNightAu?: Maybe<Scalars['Float']['output']>;
    /** Rail traffic */
    kbfRailTraffic?: Maybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: Maybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: Maybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: Maybe<LiningMaterial>;
    /** Location */
    location?: Maybe<Scalars['String']['output']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: Maybe<Scalars['Int']['output']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: Maybe<Scalars['Int']['output']>;
    /** Type of measurement */
    measuringType?: Maybe<MeasuringType>;
    name: Scalars['String']['output'];
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: Maybe<Scalars['Int']['output']>;
    /** Store values below threshold */
    noiseSavingEnabled?: Maybe<Scalars['Boolean']['output']>;
    notificationConfig?: Maybe<NotificationConfigObject>;
    permission?: Maybe<Permission>;
    /** Pipeline type */
    pipelineType?: Maybe<PipelineType>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: Maybe<Scalars['String']['output']>;
    schedule?: Maybe<ScheduleObject>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: Maybe<Scalars['ID']['output']>;
    /** Sensitivity class */
    sensitivityClass?: Maybe<SensitivityClass>;
    /** Show alarm levels in the graph */
    showAlarms?: Maybe<Scalars['Boolean']['output']>;
    /** Show exceedances in the PDF */
    showExceedancesInPdf?: Maybe<Scalars['Boolean']['output']>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: Maybe<Scalars['Float']['output']>;
    swarmType: SwarmType;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: Maybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: Maybe<Scalars['Float']['output']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: Maybe<Scalars['Float']['output']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: Maybe<Scalars['Float']['output']>;
    /** Underground */
    underground?: Maybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: Maybe<Scalars['Int']['output']>;
    /** VDV frequency weighting X */
    vdvX?: Maybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: Maybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: Maybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Building function */
    veffBuildingType?: Maybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: Maybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: Maybe<Scalars['Float']['output']>;
    /** Day A2 */
    veffCustomLimitDayA2?: Maybe<Scalars['Float']['output']>;
    /** Day A3 */
    veffCustomLimitDayA3?: Maybe<Scalars['Float']['output']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: Maybe<Scalars['Float']['output']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: Maybe<Scalars['Float']['output']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: Maybe<Scalars['Float']['output']>;
    /** Night A1 */
    veffCustomLimitNightA1?: Maybe<Scalars['Float']['output']>;
    /** Night A2 */
    veffCustomLimitNightA2?: Maybe<Scalars['Float']['output']>;
    /** Night A3 */
    veffCustomLimitNightA3?: Maybe<Scalars['Float']['output']>;
    /** Duration of the activities */
    veffDurationOfActivities?: Maybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: Maybe<Scalars['Boolean']['output']>;
    /** Situation */
    veffSituation?: Maybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: Maybe<Scalars['Boolean']['output']>;
    /** Vibration source */
    vibrationSource?: Maybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: Maybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: Maybe<ZetGevLaagdikte>;
};

export type VibrationProjectCreateFromExistingMeasuringPointInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing vibration_measuring_point */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type VibrationProjectCreateFromExistingMeasuringPointPayload = {
    __typename?: 'VibrationProjectCreateFromExistingMeasuringPointPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationProject?: Maybe<VibrationProject>;
};

export type VibrationProjectCreateFromExistingProjectInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the existing vibration_project */
    existingId: Scalars['ID']['input'];
    name: Scalars['String']['input'];
};

export type VibrationProjectCreateFromExistingProjectPayload = {
    __typename?: 'VibrationProjectCreateFromExistingProjectPayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationProject?: Maybe<VibrationProject>;
};

export type VibrationProjectCreateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Evaluation type */
    buildingLevel?: InputMaybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: InputMaybe<BuildingState>;
    /** Building category */
    category?: InputMaybe<Category>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Concrete setting level */
    concreteSettingLevel?: InputMaybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: InputMaybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Foundation type */
    foundationType?: InputMaybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: InputMaybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: InputMaybe<GroundCondition>;
    /** Guideline */
    guideLine?: InputMaybe<GuideLine>;
    /** Number of highest records in PDF */
    highestNRecords?: InputMaybe<Scalars['Int']['input']>;
    /** List highest reading per axis per day in PDF */
    highestReadingPerDay?: InputMaybe<Scalars['Boolean']['input']>;
    /** Day AO */
    kbfCustomLimitDayAo?: InputMaybe<Scalars['Float']['input']>;
    /** Day AR */
    kbfCustomLimitDayAr?: InputMaybe<Scalars['Float']['input']>;
    /** Day AU */
    kbfCustomLimitDayAu?: InputMaybe<Scalars['Float']['input']>;
    /** Night AO */
    kbfCustomLimitNightAo?: InputMaybe<Scalars['Float']['input']>;
    /** Night AR */
    kbfCustomLimitNightAr?: InputMaybe<Scalars['Float']['input']>;
    /** Night AU */
    kbfCustomLimitNightAu?: InputMaybe<Scalars['Float']['input']>;
    /** Rail traffic */
    kbfRailTraffic?: InputMaybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: InputMaybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: InputMaybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: InputMaybe<LiningMaterial>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Type of measurement */
    measuringType?: InputMaybe<MeasuringType>;
    name: Scalars['String']['input'];
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Store values below threshold */
    noiseSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** Pipeline type */
    pipelineType?: InputMaybe<PipelineType>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    schedule?: InputMaybe<ScheduleInputObject>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: InputMaybe<Scalars['ID']['input']>;
    /** Sensitivity class */
    sensitivityClass?: InputMaybe<SensitivityClass>;
    /** Show alarm levels in the graph */
    showAlarms?: InputMaybe<Scalars['Boolean']['input']>;
    /** Show exceedances in the PDF */
    showExceedancesInPdf?: InputMaybe<Scalars['Boolean']['input']>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<ProjectSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Underground */
    underground?: InputMaybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: InputMaybe<Scalars['Int']['input']>;
    /** VDV frequency weighting X */
    vdvX?: InputMaybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: InputMaybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: InputMaybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Building function */
    veffBuildingType?: InputMaybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: InputMaybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: InputMaybe<Scalars['Float']['input']>;
    /** Day A2 */
    veffCustomLimitDayA2?: InputMaybe<Scalars['Float']['input']>;
    /** Day A3 */
    veffCustomLimitDayA3?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: InputMaybe<Scalars['Float']['input']>;
    /** Night A1 */
    veffCustomLimitNightA1?: InputMaybe<Scalars['Float']['input']>;
    /** Night A2 */
    veffCustomLimitNightA2?: InputMaybe<Scalars['Float']['input']>;
    /** Night A3 */
    veffCustomLimitNightA3?: InputMaybe<Scalars['Float']['input']>;
    /** Duration of the activities */
    veffDurationOfActivities?: InputMaybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: InputMaybe<Scalars['Boolean']['input']>;
    /** Situation */
    veffSituation?: InputMaybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: InputMaybe<Scalars['Boolean']['input']>;
    /** Vibration source */
    vibrationSource?: InputMaybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: InputMaybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: InputMaybe<ZetGevLaagdikte>;
};

export type VibrationProjectCreatePayload = {
    __typename?: 'VibrationProjectCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationProject?: Maybe<VibrationProject>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationProjectDeleteInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
};

export type VibrationProjectDeletePayload = {
    __typename?: 'VibrationProjectDeletePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationProject?: Maybe<VibrationProject>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationProjectUpdateInput = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    /** Calculate ~~atop~~ (~~atop_ext~~) */
    atopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~atop~~ flat line threshold (mm/s^2). At least 100.0 mm/s^2 and at most 40000.0 mm/s^2 */
    atopFlatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Evaluation type */
    buildingLevel?: InputMaybe<BuildingLevel>;
    /** Architectural state */
    buildingState?: InputMaybe<BuildingState>;
    /** Building category */
    category?: InputMaybe<Category>;
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** Concrete setting level */
    concreteSettingLevel?: InputMaybe<ConcreteSettingLevel>;
    /** Construction type */
    constructionType?: InputMaybe<ConstructionType>;
    /** Threshold for measurement storage (mm/s). At least 0.1 mm/s */
    dataSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** LED. Should the LED turn off if there is a connection to the server? */
    disableLed?: InputMaybe<Scalars['Boolean']['input']>;
    /** ~~vtop~~ flat line threshold (mm/s). At least 0.02 mm/s and at most 300.0 mm/s */
    flatLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Foundation type */
    foundationType?: InputMaybe<FoundationType>;
    /** Frequency class */
    frequencyClass?: InputMaybe<FrequencyClass>;
    /** Ground condition */
    groundCondition?: InputMaybe<GroundCondition>;
    /** Guideline */
    guideLine?: InputMaybe<GuideLine>;
    /** Number of highest records in PDF */
    highestNRecords?: InputMaybe<Scalars['Int']['input']>;
    /** List highest reading per axis per day in PDF */
    highestReadingPerDay?: InputMaybe<Scalars['Boolean']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    /** Day AO */
    kbfCustomLimitDayAo?: InputMaybe<Scalars['Float']['input']>;
    /** Day AR */
    kbfCustomLimitDayAr?: InputMaybe<Scalars['Float']['input']>;
    /** Day AU */
    kbfCustomLimitDayAu?: InputMaybe<Scalars['Float']['input']>;
    /** Night AO */
    kbfCustomLimitNightAo?: InputMaybe<Scalars['Float']['input']>;
    /** Night AR */
    kbfCustomLimitNightAr?: InputMaybe<Scalars['Float']['input']>;
    /** Night AU */
    kbfCustomLimitNightAu?: InputMaybe<Scalars['Float']['input']>;
    /** Rail traffic */
    kbfRailTraffic?: InputMaybe<KbfRailTraffic>;
    /** Vibration source */
    kbfSource?: InputMaybe<KbfSource>;
    /** Vibration level */
    kbfVibrationLevel?: InputMaybe<KbfVibrationLevel>;
    /** Lining material */
    liningMaterial?: InputMaybe<LiningMaterial>;
    /** Location */
    location?: InputMaybe<Scalars['String']['input']>;
    /** Send interval (seconds). At least 1 seconds */
    logFlushInterval?: InputMaybe<Scalars['Int']['input']>;
    /** Measuring interval (seconds). At least 2 seconds */
    measurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Type of measurement */
    measuringType?: InputMaybe<MeasuringType>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** Storage below threshold interval (seconds). At least 30 seconds */
    noiseMeasurementDuration?: InputMaybe<Scalars['Int']['input']>;
    /** Store values below threshold */
    noiseSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    notificationConfig?: InputMaybe<NotificationConfigInputObject>;
    /** Pipeline type */
    pipelineType?: InputMaybe<PipelineType>;
    /** Private notes. Add private notes for this configuration. Notes are never shown in reports or exports. */
    privateNotes?: InputMaybe<Scalars['String']['input']>;
    schedule?: InputMaybe<ScheduleInputObject>;
    /** Own alarm line specification */
    selfDefinedAlarmLine?: InputMaybe<Scalars['ID']['input']>;
    /** Sensitivity class */
    sensitivityClass?: InputMaybe<SensitivityClass>;
    /** Show alarm levels in the graph */
    showAlarms?: InputMaybe<Scalars['Boolean']['input']>;
    /** Show exceedances in the PDF */
    showExceedancesInPdf?: InputMaybe<Scalars['Boolean']['input']>;
    /** Distance to source (m). At least 1.0 m */
    sourceDistance?: InputMaybe<Scalars['Float']['input']>;
    swarmType?: InputMaybe<ProjectSwarmType>;
    /** Timezone. What is the timezone of the location of the SWARM Vibration? */
    timezone?: InputMaybe<Timezone>;
    /** Time after trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePostTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Time before trace trigger (seconds). At least 1.0 seconds and at most 4.0 seconds */
    tracePreTrigger?: InputMaybe<Scalars['Float']['input']>;
    /** Threshold for trace storage (mm/s). At least 0.1 mm/s */
    traceSaveLevel?: InputMaybe<Scalars['Float']['input']>;
    /** Underground */
    underground?: InputMaybe<Underground>;
    /** Calculate VDV (Vibration Dose Value) */
    vdvEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** VDV period (seconds). At least 5 seconds */
    vdvPeriod?: InputMaybe<Scalars['Int']['input']>;
    /** VDV frequency weighting X */
    vdvX?: InputMaybe<VdvX>;
    /** VDV frequency weighting Y */
    vdvY?: InputMaybe<VdvY>;
    /** VDV frequency weighting Z */
    vdvZ?: InputMaybe<VdvZ>;
    /** Calculate PVS (Peak Vector Sum) */
    vectorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Building function */
    veffBuildingType?: InputMaybe<VeffBuildingType>;
    /** Circumstances */
    veffCircumstance?: InputMaybe<VeffCircumstance>;
    /** Day A1 */
    veffCustomLimitDayA1?: InputMaybe<Scalars['Float']['input']>;
    /** Day A2 */
    veffCustomLimitDayA2?: InputMaybe<Scalars['Float']['input']>;
    /** Day A3 */
    veffCustomLimitDayA3?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A1 */
    veffCustomLimitEveningA1?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A2 */
    veffCustomLimitEveningA2?: InputMaybe<Scalars['Float']['input']>;
    /** Evening A3 */
    veffCustomLimitEveningA3?: InputMaybe<Scalars['Float']['input']>;
    /** Night A1 */
    veffCustomLimitNightA1?: InputMaybe<Scalars['Float']['input']>;
    /** Night A2 */
    veffCustomLimitNightA2?: InputMaybe<Scalars['Float']['input']>;
    /** Night A3 */
    veffCustomLimitNightA3?: InputMaybe<Scalars['Float']['input']>;
    /** Duration of the activities */
    veffDurationOfActivities?: InputMaybe<VeffDurationOfActivities>;
    /** Lower degree of protection */
    veffLowerProtection?: InputMaybe<Scalars['Boolean']['input']>;
    /** Situation */
    veffSituation?: InputMaybe<VeffSituation>;
    /** Vmax complied in unchanged situation? */
    veffVmaxCompliedBeforeChange?: InputMaybe<Scalars['Boolean']['input']>;
    /** Vibration source */
    vibrationSource?: InputMaybe<VibrationSource>;
    /** Vibration type */
    vibrationType?: InputMaybe<VibrationType>;
    /** Calculate ~~vtop~~ (~~vtop_ext~~) */
    vtopEnabled?: InputMaybe<Scalars['Boolean']['input']>;
    /** Setting sensitive layer thickness */
    zetGevLaagdikte?: InputMaybe<ZetGevLaagdikte>;
};

export type VibrationProjectUpdatePayload = {
    __typename?: 'VibrationProjectUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    vibrationProject?: Maybe<VibrationProject>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationSchedulePartialConfigCreateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    schedule?: InputMaybe<ScheduleInputObject>;
};

export type VibrationSchedulePartialConfigCreatePayload = {
    __typename?: 'VibrationSchedulePartialConfigCreatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

export type VibrationSchedulePartialConfigUpdateInput = {
    clientMutationId?: InputMaybe<Scalars['String']['input']>;
    /** The ID of the object. */
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    schedule?: InputMaybe<ScheduleInputObject>;
};

export type VibrationSchedulePartialConfigUpdatePayload = {
    __typename?: 'VibrationSchedulePartialConfigUpdatePayload';
    clientMutationId?: Maybe<Scalars['String']['output']>;
    /** List of errors that occurred while executing the mutation. */
    errors?: Maybe<Array<MutationErrorType>>;
    /** The mutated object. */
    partialConfig?: Maybe<PartialConfigType>;
    /** List of warnings that occurred while executing the mutation. */
    warnings?: Maybe<Array<Maybe<MutationWarningType>>>;
};

/** An enumeration. */
export enum VibrationSource {
    Blasting = 'blasting',
    Compaction = 'compaction',
    ConstructionActivities = 'constructionActivities',
    LicensedQuarryAndMiningBlasting = 'licensedQuarryAndMiningBlasting',
    MechanicalDevices = 'mechanicalDevices',
    PilingSheetingExcavation = 'pilingSheetingExcavation',
    VibratoryActivities = 'vibratoryActivities',
}

/** An enumeration. */
export enum VibrationType {
    Continually = 'continually',
    Continuous = 'continuous',
    Impulsive = 'impulsive',
    LongTerm = 'longTerm',
    Momentarily = 'momentarily',
    Peak = 'peak',
    Repeated = 'repeated',
    ShortTerm = 'shortTerm',
}

export type Vmax = {
    __typename?: 'Vmax';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

export type Vper = {
    __typename?: 'Vper';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

export type VperBucket = BucketInterface & {
    __typename?: 'VperBucket';
    limits?: Maybe<VperLimits>;
    period?: Maybe<VperPeriod>;
    periodCompleteness?: Maybe<VperPeriodCompleteness>;
    timespan?: Maybe<TimeSpan>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    vmax?: Maybe<Vmax>;
    vper?: Maybe<Vper>;
};

export type VperCompliance = {
    __typename?: 'VperCompliance';
    complies?: Maybe<Scalars['Boolean']['output']>;
    reason?: Maybe<Scalars['String']['output']>;
};

export type VperLimits = {
    __typename?: 'VperLimits';
    A1?: Maybe<Scalars['Float']['output']>;
    A2?: Maybe<Scalars['Float']['output']>;
    A3?: Maybe<Scalars['Float']['output']>;
    complies?: Maybe<Scalars['Boolean']['output']>;
    x?: Maybe<VperCompliance>;
    y?: Maybe<VperCompliance>;
    z?: Maybe<VperCompliance>;
};

export enum VperPeriod {
    /** 07:00-19:00 for SBR-B, 06:00-22:00 for DIN4150-2 */
    Day = 'DAY',
    /** 19:00-23:00 */
    Evening = 'EVENING',
    /** 23:00-07:00 for SBR-B, 22:00-06:00 for DIN4150-2 */
    Night = 'NIGHT',
}

export type VperPeriodCompleteness = {
    __typename?: 'VperPeriodCompleteness';
    /** Percentage 0-100 */
    completeness?: Maybe<Scalars['Int']['output']>;
    /** Period duration in milliseconds */
    duration?: Maybe<Scalars['Int']['output']>;
    expectedSamples?: Maybe<Scalars['Int']['output']>;
    samplesInPeriod?: Maybe<Scalars['Int']['output']>;
};

export type Vtop = {
    __typename?: 'Vtop';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    vector?: Maybe<Scalars['Float']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

export type Walkthrough = {
    __typename?: 'Walkthrough';
    name?: Maybe<Scalars['String']['output']>;
    status?: Maybe<WalkthroughStatus>;
    step?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum WalkthroughStatus {
    AwaitingBiggerScreen = 'AWAITING_BIGGER_SCREEN',
    Canceled = 'CANCELED',
    Finished = 'FINISHED',
    Open = 'OPEN',
    Pending = 'PENDING',
}

export type Webhook = {
    __typename?: 'Webhook';
    endpoint?: Maybe<Scalars['String']['output']>;
    secret?: Maybe<Scalars['String']['output']>;
};

export type WebhookInput = {
    endpoint?: InputMaybe<Scalars['String']['input']>;
    secret?: InputMaybe<Scalars['String']['input']>;
};

export type Xyz = {
    __typename?: 'XYZ';
    config?: Maybe<SwarmConfig>;
    timestamp?: Maybe<Scalars['BigInteger']['output']>;
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
    z?: Maybe<Scalars['Float']['output']>;
};

/** An enumeration. */
export enum ZetGevLaagdikte {
    H_1m = 'H_1m',
    H_2m = 'H_2m',
    H_3m = 'H_3m',
    H_4m = 'H_4m',
    H_5m = 'H_5m',
    H_6m = 'H_6m',
    H_7m = 'H_7m',
    H_8m = 'H_8m',
}

/** An enumeration. */
export enum LdenGuideline {
    LdenGuidelineCustom = 'LdenGuidelineCustom',
    LdenGuidelineDutch = 'LdenGuidelineDutch',
    LdenGuidelineNone = 'LdenGuidelineNone',
    LdenGuidelineUk = 'LdenGuidelineUK',
    LdenGuidelineUk2 = 'LdenGuidelineUK2',
}

export type CreateGraphReportMutationVariables = Exact<{
    fileType: FileType;
    id: Scalars['ID']['input'];
    entityType: ReportTemplateEntityType;
    parameters: ParametersInput;
    sendEmailNotification: Scalars['Boolean']['input'];
}>;

export type CreateGraphReportMutation = {
    __typename?: 'Mutation';
    createGraphReport?: {
        __typename?: 'CreateGraphReport';
        graphReport?:
            | ({ __typename?: 'GraphReportType' } & {
                  ' $fragmentRefs'?: {
                      GraphReportTypeFieldsFragment: GraphReportTypeFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type ReportTemplatesLegacyQueryVariables = Exact<{ [key: string]: never }>;

export type ReportTemplatesLegacyQuery = {
    __typename?: 'Query';
    reportTemplatesLegacy?: Array<{
        __typename?: 'ReportTemplateLegacy';
        id?: number | null;
        name?: string | null;
    } | null> | null;
};

export type GetMeasuringPointsQueryVariables = Exact<{
    swarmType?: InputMaybe<SwarmType>;
}>;

export type GetMeasuringPointsQuery = {
    __typename?: 'Query';
    measuringPoints?: Array<
        | {
              __typename?: 'AirMeasuringPoint';
              project?: string | null;
              deviceName?: string | null;
              timezone?: Timezone | null;
              permission?: Permission | null;
              id: string;
              name: string;
          }
        | {
              __typename?: 'SoundMeasuringPoint';
              project?: string | null;
              deviceName?: string | null;
              timezone?: Timezone | null;
              permission?: Permission | null;
              id: string;
              name: string;
          }
        | {
              __typename?: 'VibrationMeasuringPoint';
              project?: string | null;
              deviceName?: string | null;
              timezone?: Timezone | null;
              permission?: Permission | null;
              id: string;
              name: string;
          }
        | null
    > | null;
    projects?: Array<
        | {
              __typename?: 'AirProject';
              permission?: Permission | null;
              timezone?: Timezone | null;
              id: string;
              name: string;
          }
        | {
              __typename?: 'SoundProject';
              permission?: Permission | null;
              timezone?: Timezone | null;
              id: string;
              name: string;
          }
        | {
              __typename?: 'VibrationProject';
              permission?: Permission | null;
              timezone?: Timezone | null;
              id: string;
              name: string;
          }
        | null
    > | null;
};

export type GraphReportTypeFieldsFragment = {
    __typename?: 'GraphReportType';
    id: string;
    name: string;
    url?: string | null;
    status?: ReportStatus | null;
} & { ' $fragmentName'?: 'GraphReportTypeFieldsFragment' };

export type GraphReportsQueryVariables = Exact<{
    ids?: InputMaybe<
        Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>
    >;
}>;

export type GraphReportsQuery = {
    __typename?: 'Query';
    graphReports?: {
        __typename?: 'GraphReportTypeConnection';
        readyReportsCount?: number | null;
        totalCount?: number | null;
        edges: Array<{
            __typename?: 'GraphReportTypeEdge';
            node?:
                | ({ __typename?: 'GraphReportType' } & {
                      ' $fragmentRefs'?: {
                          GraphReportTypeFieldsFragment: GraphReportTypeFieldsFragment;
                      };
                  })
                | null;
        } | null>;
    } | null;
};

export type UpdateGraphReportLastDownloadedMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type UpdateGraphReportLastDownloadedMutation = {
    __typename?: 'Mutation';
    updateGraphReportLastDownloaded?: {
        __typename?: 'UpdateGraphReportLastDownloaded';
        graphReport?:
            | ({ __typename?: 'GraphReportType' } & {
                  ' $fragmentRefs'?: {
                      GraphReportTypeFieldsFragment: GraphReportTypeFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type ContactFieldsFragment = {
    __typename?: 'ContactType';
    id: string;
    name: string;
    email: string;
    phoneNumber: string;
    createdAt: string;
} & { ' $fragmentName'?: 'ContactFieldsFragment' };

export type ContactsQueryVariables = Exact<{
    orderBy?: InputMaybe<Scalars['String']['input']>;
    after?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    search?: InputMaybe<Scalars['String']['input']>;
}>;

export type ContactsQuery = {
    __typename?: 'Query';
    contacts?: {
        __typename?: 'ContactTypeConnection';
        totalCount?: number | null;
        edges: Array<{
            __typename?: 'ContactTypeEdge';
            node?:
                | ({ __typename?: 'ContactType' } & {
                      ' $fragmentRefs'?: { ContactFieldsFragment: ContactFieldsFragment };
                  })
                | null;
        } | null>;
        pageInfo: {
            __typename?: 'PageInfo';
            startCursor?: string | null;
            endCursor?: string | null;
        };
    } | null;
};

export type CreateContactMutationVariables = Exact<{
    input: CreateContactInput;
}>;

export type CreateContactMutation = {
    __typename?: 'Mutation';
    createContact?: {
        __typename?: 'CreateContactPayload';
        contact?:
            | ({ __typename?: 'ContactType' } & {
                  ' $fragmentRefs'?: { ContactFieldsFragment: ContactFieldsFragment };
              })
            | null;
        errors?: Array<{
            __typename?: 'MutationErrorType';
            field?: string | null;
            message?: string | null;
        }> | null;
    } | null;
};

export type UpdateContactMutationVariables = Exact<{
    input: UpdateContactInput;
}>;

export type UpdateContactMutation = {
    __typename?: 'Mutation';
    updateContact?: {
        __typename?: 'UpdateContactPayload';
        contact?:
            | ({ __typename?: 'ContactType' } & {
                  ' $fragmentRefs'?: { ContactFieldsFragment: ContactFieldsFragment };
              })
            | null;
        errors?: Array<{
            __typename?: 'MutationErrorType';
            field?: string | null;
            message?: string | null;
        }> | null;
    } | null;
};

export type DeleteContactMutationVariables = Exact<{
    input: DeleteContactInput;
}>;

export type DeleteContactMutation = {
    __typename?: 'Mutation';
    deleteContact?: {
        __typename?: 'DeleteContactPayload';
        contact?:
            | ({ __typename?: 'ContactType' } & {
                  ' $fragmentRefs'?: { ContactFieldsFragment: ContactFieldsFragment };
              })
            | null;
        errors?: Array<{
            __typename?: 'MutationErrorType';
            field?: string | null;
            message?: string | null;
        }> | null;
    } | null;
};

export type AttributeAssetFieldsFragment = {
    __typename?: 'AttributeAsset';
    id: string;
    url: string;
    name?: string | null;
    caption: string;
    sortOrder?: number | null;
} & { ' $fragmentName'?: 'AttributeAssetFieldsFragment' };

type AttributeEntryFieldsImageAttributeEntryFragment = {
    __typename: 'ImageAttributeEntry';
    definitionId: string;
    key: string;
    label: string;
    isSystem: boolean;
    valueType: AttributeValueType;
    updatedAt?: string | null;
    image?:
        | ({ __typename?: 'AttributeAsset' } & {
              ' $fragmentRefs'?: { AttributeAssetFieldsFragment: AttributeAssetFieldsFragment };
          })
        | null;
} & { ' $fragmentName'?: 'AttributeEntryFieldsImageAttributeEntryFragment' };

type AttributeEntryFieldsImageListAttributeEntryFragment = {
    __typename: 'ImageListAttributeEntry';
    definitionId: string;
    key: string;
    label: string;
    isSystem: boolean;
    valueType: AttributeValueType;
    updatedAt?: string | null;
    imageList: Array<
        { __typename?: 'AttributeAsset' } & {
            ' $fragmentRefs'?: { AttributeAssetFieldsFragment: AttributeAssetFieldsFragment };
        }
    >;
} & { ' $fragmentName'?: 'AttributeEntryFieldsImageListAttributeEntryFragment' };

type AttributeEntryFieldsTextAttributeEntryFragment = {
    __typename: 'TextAttributeEntry';
    textValue: string;
    definitionId: string;
    key: string;
    label: string;
    isSystem: boolean;
    valueType: AttributeValueType;
    updatedAt?: string | null;
} & { ' $fragmentName'?: 'AttributeEntryFieldsTextAttributeEntryFragment' };

export type AttributeEntryFieldsFragment =
    | AttributeEntryFieldsImageAttributeEntryFragment
    | AttributeEntryFieldsImageListAttributeEntryFragment
    | AttributeEntryFieldsTextAttributeEntryFragment;

export type AttributesPageQueryVariables = Exact<{
    entityType: AttributesEntityType;
    entityId: Scalars['ID']['input'];
    keys?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
    >;
    includeMeasuringPoint: Scalars['Boolean']['input'];
    includeProject: Scalars['Boolean']['input'];
}>;

export type AttributesPageQuery = {
    __typename?: 'Query';
    attributesByEntity: Array<
        | ({ __typename?: 'ImageAttributeEntry' } & {
              ' $fragmentRefs'?: {
                  AttributeEntryFieldsImageAttributeEntryFragment: AttributeEntryFieldsImageAttributeEntryFragment;
              };
          })
        | ({ __typename?: 'ImageListAttributeEntry' } & {
              ' $fragmentRefs'?: {
                  AttributeEntryFieldsImageListAttributeEntryFragment: AttributeEntryFieldsImageListAttributeEntryFragment;
              };
          })
        | ({ __typename?: 'TextAttributeEntry' } & {
              ' $fragmentRefs'?: {
                  AttributeEntryFieldsTextAttributeEntryFragment: AttributeEntryFieldsTextAttributeEntryFragment;
              };
          })
    >;
    measuringPointById?:
        | {
              __typename?: 'AirMeasuringPoint';
              id: string;
              name: string;
              permission?: Permission | null;
          }
        | {
              __typename?: 'SoundMeasuringPoint';
              id: string;
              name: string;
              permission?: Permission | null;
          }
        | {
              __typename?: 'VibrationMeasuringPoint';
              id: string;
              name: string;
              permission?: Permission | null;
          }
        | null;
    projectById?:
        | { __typename?: 'AirProject'; id: string; name: string; permission?: Permission | null }
        | { __typename?: 'SoundProject'; id: string; name: string; permission?: Permission | null }
        | {
              __typename?: 'VibrationProject';
              id: string;
              name: string;
              permission?: Permission | null;
          }
        | null;
};

export type SetAttributeTextMutationVariables = Exact<{
    entityType: AttributesEntityType;
    entityId: Scalars['ID']['input'];
    key: Scalars['String']['input'];
    textValue: Scalars['String']['input'];
}>;

export type SetAttributeTextMutation = {
    __typename?: 'Mutation';
    setAttributeText?: {
        __typename?: 'SetAttributeText';
        attributeEntry?:
            | ({ __typename?: 'ImageAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageAttributeEntryFragment: AttributeEntryFieldsImageAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'ImageListAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageListAttributeEntryFragment: AttributeEntryFieldsImageListAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'TextAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsTextAttributeEntryFragment: AttributeEntryFieldsTextAttributeEntryFragment;
                  };
              })
            | null;
    } | null;
};

export type CreateAttributeDefinitionMutationVariables = Exact<{
    entityType: AttributesEntityType;
    entityId: Scalars['ID']['input'];
    label: Scalars['String']['input'];
    valueType: AttributeValueType;
}>;

export type CreateAttributeDefinitionMutation = {
    __typename?: 'Mutation';
    createAttributeDefinition?: {
        __typename?: 'CreateAttributeDefinition';
        attributeEntry?:
            | ({ __typename?: 'ImageAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageAttributeEntryFragment: AttributeEntryFieldsImageAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'ImageListAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageListAttributeEntryFragment: AttributeEntryFieldsImageListAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'TextAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsTextAttributeEntryFragment: AttributeEntryFieldsTextAttributeEntryFragment;
                  };
              })
            | null;
    } | null;
};

export type SetAttributeAssetCaptionMutationVariables = Exact<{
    entityType: AttributesEntityType;
    entityId: Scalars['ID']['input'];
    key: Scalars['String']['input'];
    assetId: Scalars['ID']['input'];
    caption: Scalars['String']['input'];
}>;

export type SetAttributeAssetCaptionMutation = {
    __typename?: 'Mutation';
    setAttributeAssetCaption?: {
        __typename?: 'SetAttributeAssetCaption';
        attributeEntry?:
            | ({ __typename?: 'ImageAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageAttributeEntryFragment: AttributeEntryFieldsImageAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'ImageListAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageListAttributeEntryFragment: AttributeEntryFieldsImageListAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'TextAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsTextAttributeEntryFragment: AttributeEntryFieldsTextAttributeEntryFragment;
                  };
              })
            | null;
    } | null;
};

export type ReorderAttributeImagesMutationVariables = Exact<{
    entityType: AttributesEntityType;
    entityId: Scalars['ID']['input'];
    key: Scalars['String']['input'];
    assetIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type ReorderAttributeImagesMutation = {
    __typename?: 'Mutation';
    reorderAttributeImages?: {
        __typename?: 'ReorderAttributeImages';
        attributeEntry?:
            | ({ __typename?: 'ImageAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageAttributeEntryFragment: AttributeEntryFieldsImageAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'ImageListAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageListAttributeEntryFragment: AttributeEntryFieldsImageListAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'TextAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsTextAttributeEntryFragment: AttributeEntryFieldsTextAttributeEntryFragment;
                  };
              })
            | null;
    } | null;
};

export type DeleteAttributeAssetMutationVariables = Exact<{
    entityType: AttributesEntityType;
    entityId: Scalars['ID']['input'];
    key: Scalars['String']['input'];
    assetId: Scalars['ID']['input'];
}>;

export type DeleteAttributeAssetMutation = {
    __typename?: 'Mutation';
    deleteAttributeAsset?: {
        __typename?: 'DeleteAttributeAsset';
        attributeEntry?:
            | ({ __typename?: 'ImageAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageAttributeEntryFragment: AttributeEntryFieldsImageAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'ImageListAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsImageListAttributeEntryFragment: AttributeEntryFieldsImageListAttributeEntryFragment;
                  };
              })
            | ({ __typename?: 'TextAttributeEntry' } & {
                  ' $fragmentRefs'?: {
                      AttributeEntryFieldsTextAttributeEntryFragment: AttributeEntryFieldsTextAttributeEntryFragment;
                  };
              })
            | null;
    } | null;
};

export type CustomAlarmTypeFieldsFragment = {
    __typename?: 'CustomAlarmType';
    id: string;
    name: string;
    points?: Array<{
        __typename?: 'AlarmPoint';
        freq?: number | null;
        vkar?: number | null;
    } | null> | null;
} & { ' $fragmentName'?: 'CustomAlarmTypeFieldsFragment' };

export type GetCustomAlarmsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomAlarmsQuery = {
    __typename?: 'Query';
    customAlarms?: {
        __typename?: 'CustomAlarmTypeConnection';
        edges: Array<{
            __typename?: 'CustomAlarmTypeEdge';
            node?:
                | ({ __typename?: 'CustomAlarmType' } & {
                      ' $fragmentRefs'?: {
                          CustomAlarmTypeFieldsFragment: CustomAlarmTypeFieldsFragment;
                      };
                  })
                | null;
        } | null>;
    } | null;
};

export type GetCustomAlarmQueryVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type GetCustomAlarmQuery = {
    __typename?: 'Query';
    customAlarm?:
        | ({ __typename?: 'CustomAlarmType' } & {
              ' $fragmentRefs'?: { CustomAlarmTypeFieldsFragment: CustomAlarmTypeFieldsFragment };
          })
        | null;
};

export type CustomAlarmCreateMutationVariables = Exact<{
    input: CustomAlarmCreateMutationInput;
}>;

export type CustomAlarmCreateMutation = {
    __typename?: 'Mutation';
    customAlarmCreate?: {
        __typename?: 'CustomAlarmCreateMutationPayload';
        customAlarm?:
            | ({ __typename?: 'CustomAlarmType' } & {
                  ' $fragmentRefs'?: {
                      CustomAlarmTypeFieldsFragment: CustomAlarmTypeFieldsFragment;
                  };
              })
            | null;
        errors?: Array<{
            __typename?: 'MutationErrorType';
            field?: string | null;
            message?: string | null;
        }> | null;
    } | null;
};

export type CustomAlarmUpdateMutationVariables = Exact<{
    input: CustomAlarmUpdateMutationInput;
}>;

export type CustomAlarmUpdateMutation = {
    __typename?: 'Mutation';
    customAlarmUpdate?: {
        __typename?: 'CustomAlarmUpdateMutationPayload';
        customAlarm?:
            | ({ __typename?: 'CustomAlarmType' } & {
                  ' $fragmentRefs'?: {
                      CustomAlarmTypeFieldsFragment: CustomAlarmTypeFieldsFragment;
                  };
              })
            | null;
        errors?: Array<{
            __typename?: 'MutationErrorType';
            field?: string | null;
            message?: string | null;
        }> | null;
    } | null;
};

export type CustomAlarmDeleteMutationVariables = Exact<{
    input: CustomAlarmDeleteMutationInput;
}>;

export type CustomAlarmDeleteMutation = {
    __typename?: 'Mutation';
    customAlarmDelete?: {
        __typename?: 'CustomAlarmDeleteMutationPayload';
        customAlarm?: { __typename?: 'CustomAlarmType'; id: string } | null;
        errors?: Array<{
            __typename?: 'MutationErrorType';
            field?: string | null;
            message?: string | null;
        }> | null;
    } | null;
};

export type GraphReportsTypeFieldsFragment = {
    __typename?: 'GraphReportType';
    id: string;
    url?: string | null;
    name: string;
    lastDownloaded?: string | null;
    status?: ReportStatus | null;
    size?: number | null;
    category?: DownloadCategory | null;
} & { ' $fragmentName'?: 'GraphReportsTypeFieldsFragment' };

export type DownloadsGraphReportsQueryVariables = Exact<{
    orderBy?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    after?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<
        Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>
    >;
}>;

export type DownloadsGraphReportsQuery = {
    __typename?: 'Query';
    graphReports?: {
        __typename?: 'GraphReportTypeConnection';
        readyReportsCount?: number | null;
        totalCount?: number | null;
        edges: Array<{
            __typename?: 'GraphReportTypeEdge';
            node?:
                | ({ __typename?: 'GraphReportType' } & {
                      ' $fragmentRefs'?: {
                          GraphReportsTypeFieldsFragment: GraphReportsTypeFieldsFragment;
                      };
                  })
                | null;
        } | null>;
        pageInfo: {
            __typename?: 'PageInfo';
            startCursor?: string | null;
            endCursor?: string | null;
        };
    } | null;
};

export type DownloadsUpdateGraphReportLastDownloadedMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type DownloadsUpdateGraphReportLastDownloadedMutation = {
    __typename?: 'Mutation';
    updateGraphReportLastDownloaded?: {
        __typename?: 'UpdateGraphReportLastDownloaded';
        graphReport?:
            | ({ __typename?: 'GraphReportType' } & {
                  ' $fragmentRefs'?: {
                      GraphReportsTypeFieldsFragment: GraphReportsTypeFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type GetMapMarkersQueryVariables = Exact<{
    scope: MapScope;
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    limit: Scalars['Int']['input'];
    offset?: InputMaybe<Scalars['Int']['input']>;
    useDeviceGps?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetMapMarkersQuery = {
    __typename?: 'Query';
    mapMarkers?: {
        __typename?: 'MapMarkerPageType';
        hasMore: boolean;
        markers: Array<{
            __typename?: 'MapMarkerType';
            measuringPointId: number;
            name: string;
            ownerUserId: number;
            latitude: number;
            longitude: number;
        }>;
    } | null;
};

export type RegisterNyDepDeviceMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type RegisterNyDepDeviceMutation = {
    __typename?: 'Mutation';
    registerNyDepDevice?: {
        __typename?: 'RegisterNyDepDevice';
        status: NyDepRegistrationStatus;
        errorCode?: NyDepRegistrationErrorCode | null;
    } | null;
};

export type GetNyDepIntegrationQueryVariables = Exact<{
    measuringPointId: Scalars['ID']['input'];
}>;

export type GetNyDepIntegrationQuery = {
    __typename?: 'Query';
    nyDepIntegration?: {
        __typename?: 'NyDepIntegration';
        registrationStatus: NyDepRegistrationStatus;
        registrationErrorCode?: NyDepRegistrationErrorCode | null;
    } | null;
};

export type CanActivateSubscriptionQueryVariables = Exact<{
    deviceName: Scalars['String']['input'];
}>;

export type CanActivateSubscriptionQuery = {
    __typename?: 'Query';
    canActivateSubscription?: boolean | null;
};

export type ActivateSubscriptionMutationVariables = Exact<{
    deviceName: Scalars['String']['input'];
}>;

export type ActivateSubscriptionMutation = {
    __typename?: 'Mutation';
    activateSubscription?: { __typename?: 'ActivateSubscription'; success?: boolean | null } | null;
};

export type SwarmFeaturesFieldsFragment = {
    __typename?: 'SwarmFeatures';
    deviceName?: string | null;
    swarmType?: SwarmType | null;
    validSubscription?: boolean | null;
    canActivateSubscription?: boolean | null;
    unavailableFeatures?: Array<{
        __typename?: 'UnavailableFeature';
        field?: string | null;
        option?: string | null;
        showBanner?: boolean | null;
    } | null> | null;
} & { ' $fragmentName'?: 'SwarmFeaturesFieldsFragment' };

export type FeatureCheckSwarmQueryVariables = Exact<{
    deviceName: Scalars['String']['input'];
}>;

export type FeatureCheckSwarmQuery = {
    __typename?: 'Query';
    featureCheckSwarm?: Array<
        | ({ __typename?: 'SwarmFeatures' } & {
              ' $fragmentRefs'?: { SwarmFeaturesFieldsFragment: SwarmFeaturesFieldsFragment };
          })
        | null
    > | null;
};

export type FeatureCheckProjectQueryVariables = Exact<{
    projectId: Scalars['ID']['input'];
}>;

export type FeatureCheckProjectQuery = {
    __typename?: 'Query';
    featureCheckProject?: Array<
        | ({ __typename?: 'SwarmFeatures' } & {
              ' $fragmentRefs'?: { SwarmFeaturesFieldsFragment: SwarmFeaturesFieldsFragment };
          })
        | null
    > | null;
};

export type NotificationTypeFieldsFragment = {
    __typename?: 'NotificationType';
    id: string;
    swarmType: SwarmType;
    createdAt: string;
    level: NotificationLevel;
    data: string;
    isLong: boolean;
    isLegacy: boolean;
} & { ' $fragmentName'?: 'NotificationTypeFieldsFragment' };

export type NotificationsQueryVariables = Exact<{
    orderBy?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    after?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    levels?: InputMaybe<Array<InputMaybe<NotificationLevel>> | InputMaybe<NotificationLevel>>;
    search?: InputMaybe<Scalars['String']['input']>;
    createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
    createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
    mpPk?: InputMaybe<Scalars['Int']['input']>;
}>;

export type NotificationsQuery = {
    __typename?: 'Query';
    notifications?: {
        __typename?: 'NotificationTypeConnection';
        totalCount?: number | null;
        edges: Array<{
            __typename?: 'NotificationTypeEdge';
            node?:
                | ({ __typename?: 'NotificationType' } & {
                      ' $fragmentRefs'?: {
                          NotificationTypeFieldsFragment: NotificationTypeFieldsFragment;
                      };
                  })
                | null;
        } | null>;
        pageInfo: {
            __typename?: 'PageInfo';
            startCursor?: string | null;
            endCursor?: string | null;
        };
    } | null;
};

type MeasuringPointFieldsAirMeasuringPointFragment = {
    __typename?: 'AirMeasuringPoint';
    id: string;
    name: string;
    swarmType: SwarmType;
    archived?: boolean | null;
    status: MeasuringPointStatus;
    directShare: boolean;
} & { ' $fragmentName'?: 'MeasuringPointFieldsAirMeasuringPointFragment' };

type MeasuringPointFieldsSoundMeasuringPointFragment = {
    __typename?: 'SoundMeasuringPoint';
    id: string;
    name: string;
    swarmType: SwarmType;
    archived?: boolean | null;
    status: MeasuringPointStatus;
    directShare: boolean;
} & { ' $fragmentName'?: 'MeasuringPointFieldsSoundMeasuringPointFragment' };

type MeasuringPointFieldsVibrationMeasuringPointFragment = {
    __typename?: 'VibrationMeasuringPoint';
    id: string;
    name: string;
    swarmType: SwarmType;
    archived?: boolean | null;
    status: MeasuringPointStatus;
    directShare: boolean;
} & { ' $fragmentName'?: 'MeasuringPointFieldsVibrationMeasuringPointFragment' };

export type MeasuringPointFieldsFragment =
    | MeasuringPointFieldsAirMeasuringPointFragment
    | MeasuringPointFieldsSoundMeasuringPointFragment
    | MeasuringPointFieldsVibrationMeasuringPointFragment;

export type AirMeasuringPointFieldsFragment = ({
    __typename?: 'AirMeasuringPoint';
    project?: string | null;
    city?: string | null;
    deviceName?: string | null;
    permission?: Permission | null;
    overriddenFields?: Array<string | null> | null;
    sensor?: {
        __typename?: 'Sensor';
        online?: boolean | null;
        lastContact?: string | null;
        batteryCharge?: number | null;
        batteryChargeLastUpdate?: string | null;
        hasValidSubscription?: boolean | null;
        hasDataUsageInfo?: boolean | null;
        smsUsed?: number | null;
        smsLimit?: number | null;
        hasPendingFirmwareUpgrade?: boolean | null;
        firmwareUpgradePercentage?: number | null;
        isRotating?: boolean | null;
        isRestarting?: boolean | null;
        name: string;
        dataQuota?: {
            __typename?: 'SensorQuotaType';
            percent: number;
            isWarning: boolean;
            isLimit: boolean;
        } | null;
        smsQuota?: {
            __typename?: 'SensorQuotaType';
            percent: number;
            isWarning: boolean;
            isLimit: boolean;
        } | null;
    } | null;
} & {
    ' $fragmentRefs'?: {
        MeasuringPointFieldsAirMeasuringPointFragment: MeasuringPointFieldsAirMeasuringPointFragment;
    };
}) & { ' $fragmentName'?: 'AirMeasuringPointFieldsFragment' };

export type VibrationMeasuringPointFieldsFragment = ({
    __typename?: 'VibrationMeasuringPoint';
    project?: string | null;
    city?: string | null;
    deviceName?: string | null;
    permission?: Permission | null;
    overriddenFields?: Array<string | null> | null;
    sensor?: {
        __typename?: 'Sensor';
        online?: boolean | null;
        lastContact?: string | null;
        batteryCharge?: number | null;
        batteryChargeLastUpdate?: string | null;
        hasValidSubscription?: boolean | null;
        hasDataUsageInfo?: boolean | null;
        smsUsed?: number | null;
        smsLimit?: number | null;
        hasPendingFirmwareUpgrade?: boolean | null;
        firmwareUpgradePercentage?: number | null;
        isRotating?: boolean | null;
        isRestarting?: boolean | null;
        name: string;
        dataQuota?: {
            __typename?: 'SensorQuotaType';
            percent: number;
            isWarning: boolean;
            isLimit: boolean;
        } | null;
        smsQuota?: {
            __typename?: 'SensorQuotaType';
            percent: number;
            isWarning: boolean;
            isLimit: boolean;
        } | null;
    } | null;
} & {
    ' $fragmentRefs'?: {
        MeasuringPointFieldsVibrationMeasuringPointFragment: MeasuringPointFieldsVibrationMeasuringPointFragment;
    };
}) & { ' $fragmentName'?: 'VibrationMeasuringPointFieldsFragment' };

export type SoundMeasuringPointFieldsFragment = ({
    __typename?: 'SoundMeasuringPoint';
    project?: string | null;
    city?: string | null;
    deviceName?: string | null;
    permission?: Permission | null;
    overriddenFields?: Array<string | null> | null;
    sensor?: {
        __typename?: 'Sensor';
        online?: boolean | null;
        lastContact?: string | null;
        batteryCharge?: number | null;
        batteryChargeLastUpdate?: string | null;
        hasValidSubscription?: boolean | null;
        hasDataUsageInfo?: boolean | null;
        smsUsed?: number | null;
        smsLimit?: number | null;
        hasPendingFirmwareUpgrade?: boolean | null;
        firmwareUpgradePercentage?: number | null;
        isRotating?: boolean | null;
        isRestarting?: boolean | null;
        name: string;
        dataQuota?: {
            __typename?: 'SensorQuotaType';
            percent: number;
            isWarning: boolean;
            isLimit: boolean;
        } | null;
        smsQuota?: {
            __typename?: 'SensorQuotaType';
            percent: number;
            isWarning: boolean;
            isLimit: boolean;
        } | null;
    } | null;
} & {
    ' $fragmentRefs'?: {
        MeasuringPointFieldsSoundMeasuringPointFragment: MeasuringPointFieldsSoundMeasuringPointFragment;
    };
}) & { ' $fragmentName'?: 'SoundMeasuringPointFieldsFragment' };

export type GetProjectCatalogQueryVariables = Exact<{
    archived: Scalars['Boolean']['input'];
    search?: InputMaybe<Scalars['String']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    first: Scalars['Int']['input'];
    after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetProjectCatalogQuery = {
    __typename?: 'Query';
    projectCatalog?: {
        __typename?: 'ProjectCatalogTypeConnection';
        totalCount?: number | null;
        maxStarredProjects: number;
        starredCount: number;
        hasAnyData: boolean;
        summaries?: Array<{
            __typename?: 'ProjectSummaryType';
            projectId: string;
            online: number;
            offline: number;
            inactive: number;
            dataWarnings: {
                __typename?: 'DataWarningGroupType';
                count: number;
                devices: Array<{
                    __typename?: 'DataWarningDeviceType';
                    measuringPointId: string;
                    deviceName: string;
                    usagePercentage: number;
                    isLimit: boolean;
                }>;
            };
            recentExceedances: {
                __typename?: 'RecentExceedanceGroupType';
                count: number;
                events: Array<{
                    __typename?: 'RecentExceedanceEventType';
                    id: string;
                    measuringPointId: string;
                    deviceName: string;
                    occurredAt: string;
                }>;
            };
        }>;
        edges: Array<{
            __typename?: 'ProjectCatalogTypeEdge';
            node?: {
                __typename?: 'ProjectCatalogType';
                id: string;
                pk: string;
                name: string;
                city: string;
                swarmType: SwarmType;
                archived: boolean;
                permission: Permission;
                measuringPointCount: number;
                isStarred: boolean;
            } | null;
        } | null>;
    } | null;
};

export type GetStandaloneMeasuringPointsQueryVariables = Exact<{
    archived: Scalars['Boolean']['input'];
    search?: InputMaybe<Scalars['String']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    first: Scalars['Int']['input'];
    after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetStandaloneMeasuringPointsQuery = {
    __typename?: 'Query';
    standaloneMeasuringPoints?: {
        __typename?: 'StandaloneMeasuringPointsType';
        totalCount: number;
        nodes: Array<
            | ({ __typename?: 'AirMeasuringPoint' } & {
                  ' $fragmentRefs'?: {
                      AirMeasuringPointFieldsFragment: AirMeasuringPointFieldsFragment;
                  };
              })
            | ({ __typename?: 'SoundMeasuringPoint' } & {
                  ' $fragmentRefs'?: {
                      SoundMeasuringPointFieldsFragment: SoundMeasuringPointFieldsFragment;
                  };
              })
            | ({ __typename?: 'VibrationMeasuringPoint' } & {
                  ' $fragmentRefs'?: {
                      VibrationMeasuringPointFieldsFragment: VibrationMeasuringPointFieldsFragment;
                  };
              })
            | null
        >;
    } | null;
};

export type GetOverviewProjectMeasuringPointsQueryVariables = Exact<{
    archived: Scalars['Boolean']['input'];
    projectIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetOverviewProjectMeasuringPointsQuery = {
    __typename?: 'Query';
    measuringPoints?: Array<
        | ({ __typename?: 'AirMeasuringPoint' } & {
              ' $fragmentRefs'?: {
                  AirMeasuringPointFieldsFragment: AirMeasuringPointFieldsFragment;
              };
          })
        | ({ __typename?: 'SoundMeasuringPoint' } & {
              ' $fragmentRefs'?: {
                  SoundMeasuringPointFieldsFragment: SoundMeasuringPointFieldsFragment;
              };
          })
        | ({ __typename?: 'VibrationMeasuringPoint' } & {
              ' $fragmentRefs'?: {
                  VibrationMeasuringPointFieldsFragment: VibrationMeasuringPointFieldsFragment;
              };
          })
        | null
    > | null;
};

export type GetPastSensorsQueryVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type GetPastSensorsQuery = {
    __typename?: 'Query';
    measuringPointById?:
        | {
              __typename?: 'AirMeasuringPoint';
              pastSensors?: Array<{
                  __typename?: 'PastSensorType';
                  sensorPk: number;
                  simpleName: string;
                  calibrationReportUrl: string;
              } | null> | null;
          }
        | {
              __typename?: 'SoundMeasuringPoint';
              pastSensors?: Array<{
                  __typename?: 'PastSensorType';
                  sensorPk: number;
                  simpleName: string;
                  calibrationReportUrl: string;
              } | null> | null;
          }
        | {
              __typename?: 'VibrationMeasuringPoint';
              pastSensors?: Array<{
                  __typename?: 'PastSensorType';
                  sensorPk: number;
                  simpleName: string;
                  calibrationReportUrl: string;
              } | null> | null;
          }
        | null;
};

export type SetMeasuringPointArchivedMutationVariables = Exact<{
    id: Scalars['ID']['input'];
    archived: Scalars['Boolean']['input'];
}>;

export type SetMeasuringPointArchivedMutation = {
    __typename?: 'Mutation';
    setMeasuringPointArchived?: {
        __typename?: 'SetMeasuringPointArchived';
        success?: boolean | null;
    } | null;
};

export type SoftDeleteMeasuringPointMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type SoftDeleteMeasuringPointMutation = {
    __typename?: 'Mutation';
    softDeleteMeasuringPoint?: {
        __typename?: 'SoftDeleteMeasuringPoint';
        success?: boolean | null;
    } | null;
};

export type RequestMeasuringPointSensorActionMutationVariables = Exact<{
    id: Scalars['ID']['input'];
    action: MeasuringPointSensorAction;
}>;

export type RequestMeasuringPointSensorActionMutation = {
    __typename?: 'Mutation';
    requestMeasuringPointSensorAction?: {
        __typename?: 'RequestMeasuringPointSensorAction';
        success?: boolean | null;
    } | null;
};

export type OverviewDetachSensorFromMeasuringPointMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type OverviewDetachSensorFromMeasuringPointMutation = {
    __typename?: 'Mutation';
    detachSensorFromMeasuringPoint?: {
        __typename?: 'DetachSensorFromMeasuringPoint';
        measuringPoint?:
            | ({ __typename?: 'AirMeasuringPoint' } & {
                  ' $fragmentRefs'?: {
                      AirMeasuringPointFieldsFragment: AirMeasuringPointFieldsFragment;
                  };
              })
            | ({ __typename?: 'SoundMeasuringPoint' } & {
                  ' $fragmentRefs'?: {
                      SoundMeasuringPointFieldsFragment: SoundMeasuringPointFieldsFragment;
                  };
              })
            | ({ __typename?: 'VibrationMeasuringPoint' } & {
                  ' $fragmentRefs'?: {
                      VibrationMeasuringPointFieldsFragment: VibrationMeasuringPointFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type SetProjectArchivedMutationVariables = Exact<{
    id: Scalars['ID']['input'];
    archived: Scalars['Boolean']['input'];
}>;

export type SetProjectArchivedMutation = {
    __typename?: 'Mutation';
    setProjectArchived?: { __typename?: 'SetProjectArchived'; success?: boolean | null } | null;
};

export type SoftDeleteProjectMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type SoftDeleteProjectMutation = {
    __typename?: 'Mutation';
    softDeleteProject?: { __typename?: 'SoftDeleteProject'; success?: boolean | null } | null;
};

export type ToggleProjectStarMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type ToggleProjectStarMutation = {
    __typename?: 'Mutation';
    toggleProjectStar?: {
        __typename?: 'ToggleProjectStar';
        success?: boolean | null;
        isStarred: boolean;
    } | null;
};

export type UndoMyMeasuringPointShareMutationVariables = Exact<{
    measuringPointId: Scalars['Int']['input'];
}>;

export type UndoMyMeasuringPointShareMutation = {
    __typename?: 'Mutation';
    undoMyMeasuringPointShare?: {
        __typename?: 'UndoMyMeasuringPointShare';
        success?: boolean | null;
    } | null;
};

export type UndoMyProjectShareMutationVariables = Exact<{
    projectId: Scalars['Int']['input'];
}>;

export type UndoMyProjectShareMutation = {
    __typename?: 'Mutation';
    undoMyProjectShare?: { __typename?: 'UndoMyProjectShare'; success?: boolean | null } | null;
};

export type PartialConfigSummaryFragment = {
    __typename?: 'PartialConfigType';
    id: string;
    name: string;
    swarmType: SwarmType;
    partialConfigType: PartialConfigCategory;
    modifiedAt: string;
    createdAt: string;
} & { ' $fragmentName'?: 'PartialConfigSummaryFragment' };

export type PartialConfigDetailQueryVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type PartialConfigDetailQuery = {
    __typename?: 'Query';
    partialConfig?:
        | ({ __typename?: 'PartialConfigType'; config: string } & {
              ' $fragmentRefs'?: { PartialConfigSummaryFragment: PartialConfigSummaryFragment };
          })
        | null;
};

export type PartialConfigOverviewQueryVariables = Exact<{
    first: Scalars['Int']['input'];
    after?: InputMaybe<Scalars['String']['input']>;
    swarmType?: InputMaybe<SwarmType>;
    partialConfigType?: InputMaybe<PartialConfigCategory>;
    search?: InputMaybe<Scalars['String']['input']>;
}>;

export type PartialConfigOverviewQuery = {
    __typename?: 'Query';
    partialConfigs?: {
        __typename?: 'PartialConfigConnection';
        totalCount?: number | null;
        edges: Array<{
            __typename?: 'PartialConfigEdge';
            cursor: string;
            node?:
                | ({ __typename?: 'PartialConfigType' } & {
                      ' $fragmentRefs'?: {
                          PartialConfigSummaryFragment: PartialConfigSummaryFragment;
                      };
                  })
                | null;
        } | null>;
        pageInfo: { __typename?: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
    } | null;
};

export type PurchaseOrderRequestQueryVariables = Exact<{
    token?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type PurchaseOrderRequestQuery = {
    __typename?: 'Query';
    purchaseOrderRequest?: {
        __typename?: 'PurchaseOrderRequestType';
        poNumber?: string | null;
        isExpired: boolean;
        invoiceReference?: string | null;
        subscriptionNames: Array<string>;
    } | null;
};

export type SubmitPurchaseOrderNumberMutationVariables = Exact<{
    token?: InputMaybe<Scalars['UUID']['input']>;
    poNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type SubmitPurchaseOrderNumberMutation = {
    __typename?: 'Mutation';
    submitPurchaseOrderNumber?: {
        __typename?: 'SubmitPurchaseOrderNumber';
        ok?: boolean | null;
        request?: {
            __typename?: 'PurchaseOrderRequestType';
            poNumber?: string | null;
            isExpired: boolean;
            invoiceReference?: string | null;
            subscriptionNames: Array<string>;
        } | null;
    } | null;
};

export type AlarmExceedancesRuntimeDataQueryVariables = Exact<{
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AlarmExceedancesRuntimeDataQuery = {
    __typename?: 'Query';
    alarmExceedances?: {
        __typename?: 'AlarmExceedances';
        isFlatLine: boolean;
        limitReached: boolean;
        limitReachedValue?: number | null;
        alarms: Array<{
            __typename?: 'AlarmSummaryEntry';
            name: string;
            triggerPct: number;
            triggerMm: number;
            counts: number;
        } | null>;
        entries: Array<{
            __typename?: 'AlarmExceedanceEntry';
            timestamp: any;
            x?: {
                __typename?: 'AlarmExceedanceAxis';
                fdom?: number | null;
                vtop?: number | null;
            } | null;
            y?: {
                __typename?: 'AlarmExceedanceAxis';
                fdom?: number | null;
                vtop?: number | null;
            } | null;
            z?: {
                __typename?: 'AlarmExceedanceAxis';
                fdom?: number | null;
                vtop?: number | null;
            } | null;
            vector?: {
                __typename?: 'AlarmExceedanceAxis';
                fdom?: number | null;
                vtop?: number | null;
            } | null;
        } | null>;
    } | null;
};

export type ReportBuilderAttributeRuntimeDataQueryVariables = Exact<{
    entityType: AttributesEntityType;
    entityId: Scalars['ID']['input'];
    keys?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
    >;
    ids?: InputMaybe<
        Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>
    >;
}>;

export type ReportBuilderAttributeRuntimeDataQuery = {
    __typename?: 'Query';
    attributesByEntity: Array<
        | {
              __typename: 'ImageAttributeEntry';
              definitionId: string;
              key: string;
              label: string;
              isSystem: boolean;
              valueType: AttributeValueType;
              image?: { __typename?: 'AttributeAsset'; url: string; caption: string } | null;
          }
        | {
              __typename: 'ImageListAttributeEntry';
              definitionId: string;
              key: string;
              label: string;
              isSystem: boolean;
              valueType: AttributeValueType;
              imageList: Array<{
                  __typename?: 'AttributeAsset';
                  url: string;
                  caption: string;
                  sortOrder?: number | null;
              }>;
          }
        | {
              __typename: 'TextAttributeEntry';
              textValue: string;
              definitionId: string;
              key: string;
              label: string;
              isSystem: boolean;
              valueType: AttributeValueType;
          }
    >;
};

export type ReportBuilderLastGraphStateQueryVariables = Exact<{ [key: string]: never }>;

export type ReportBuilderLastGraphStateQuery = {
    __typename?: 'Query';
    lastGraphState?: {
        __typename?: 'LastGraphStateType';
        measuringPointIds: Array<string>;
        startTime?: any | null;
        endTime?: any | null;
    } | null;
};

export type MeasuringPointLeqAlarmExceedancesQueryVariables = Exact<{
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MeasuringPointLeqAlarmExceedancesQuery = {
    __typename?: 'Query';
    leqAlarmExceedances?: {
        __typename?: 'LeqAlarmExceedances';
        limitReachedValue?: number | null;
        entries: Array<{
            __typename?: 'LeqAlarmRow';
            startTime?: any | null;
            endTime?: any | null;
            name?: string | null;
            alarmInterval?: number | null;
            alarmLevel?: number | null;
            value?: number | null;
        } | null>;
        alarms: Array<{
            __typename?: 'LeqAlarmSummaryRow';
            name: string;
            alarmInterval: number;
            alarmLevel: number;
            counts: number;
        } | null>;
    } | null;
};

export type MeasuringPointLmaxAlarmExceedancesQueryVariables = Exact<{
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
    limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MeasuringPointLmaxAlarmExceedancesQuery = {
    __typename?: 'Query';
    lmaxAlarmExceedances?: {
        __typename?: 'LmaxAlarmExceedances';
        limitReachedValue?: number | null;
        entries: Array<{
            __typename?: 'LmaxAlarmRow';
            startTime: any;
            endTime: any;
            name: string;
            alarmLevel: number;
            value: number;
        } | null>;
        alarms: Array<{
            __typename?: 'LmaxAlarmSummaryRow';
            name: string;
            alarmLevel: number;
            counts: number;
        } | null>;
    } | null;
};

export type MeasuringPointLxnValuesQueryVariables = Exact<{
    measuringPointId: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
    percentiles?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;

export type MeasuringPointLxnValuesQuery = {
    __typename?: 'Query';
    lxnValues?: {
        __typename?: 'LxnValues';
        values: Array<{
            __typename?: 'LxnValueRow';
            timestamp: any;
            l10?: number | null;
            l50?: number | null;
            l90?: number | null;
        }>;
    } | null;
};

export type MeasurementSettingsRuntimeDataQueryVariables = Exact<{
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
}>;

export type MeasurementSettingsRuntimeDataQuery = {
    __typename?: 'Query';
    measurementSettings: Array<{
        __typename?: 'MeasurementSettingEntry';
        name: string;
        value: string;
    } | null>;
};

export type ReportBuilderProfileLogoRuntimeDataQueryVariables = Exact<{
    entityType: ReportTemplateEntityType;
    entityId: Scalars['ID']['input'];
}>;

export type ReportBuilderProfileLogoRuntimeDataQuery = {
    __typename?: 'Query';
    reportProfileLogo?: { __typename?: 'ReportProfileLogo'; url: string; caption: string } | null;
};

export type ReportTemplateTypeFieldsFragment = {
    __typename?: 'ReportTemplateType';
    id: string;
    name: string;
    entityType: ReportTemplateEntityType;
    pageSize: ReportTemplatePageSize;
    pageOrientation: ReportTemplatePageOrientation;
    createdAt: string;
    modifiedAt: string;
    structure: string;
    permission: Permission;
    isSystem: boolean;
    pageMargin: {
        __typename?: 'ReportTemplatePageMargin';
        value: number;
        unit: ReportTemplatePageMarginUnit;
    };
} & { ' $fragmentName'?: 'ReportTemplateTypeFieldsFragment' };

export type ReportTemplatesQueryVariables = Exact<{
    orderBy?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    after?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    ids?: InputMaybe<
        Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>
    >;
}>;

export type ReportTemplatesQuery = {
    __typename?: 'Query';
    reportTemplates?: {
        __typename?: 'ReportTemplateTypeConnection';
        totalCount?: number | null;
        edges: Array<{
            __typename?: 'ReportTemplateTypeEdge';
            node?:
                | ({ __typename?: 'ReportTemplateType' } & {
                      ' $fragmentRefs'?: {
                          ReportTemplateTypeFieldsFragment: ReportTemplateTypeFieldsFragment;
                      };
                  })
                | null;
        } | null>;
        pageInfo: {
            __typename?: 'PageInfo';
            startCursor?: string | null;
            endCursor?: string | null;
        };
    } | null;
};

export type CreateReportTemplateMutationVariables = Exact<{
    entityType: ReportTemplateEntityType;
    name: Scalars['String']['input'];
}>;

export type CreateReportTemplateMutation = {
    __typename?: 'Mutation';
    createReportTemplate?: {
        __typename?: 'CreateReportTemplate';
        reportTemplate?:
            | ({ __typename?: 'ReportTemplateType' } & {
                  ' $fragmentRefs'?: {
                      ReportTemplateTypeFieldsFragment: ReportTemplateTypeFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type DuplicateReportTemplateMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type DuplicateReportTemplateMutation = {
    __typename?: 'Mutation';
    duplicateReportTemplate?: {
        __typename?: 'DuplicateReportTemplate';
        reportTemplate?:
            | ({ __typename?: 'ReportTemplateType' } & {
                  ' $fragmentRefs'?: {
                      ReportTemplateTypeFieldsFragment: ReportTemplateTypeFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type UpdateReportTemplateMutationVariables = Exact<{
    id: Scalars['ID']['input'];
    name: Scalars['String']['input'];
    structure: Scalars['JSONString']['input'];
    pageSize: ReportTemplatePageSize;
    pageOrientation: ReportTemplatePageOrientation;
    pageMargin: ReportTemplatePageMarginInput;
}>;

export type UpdateReportTemplateMutation = {
    __typename?: 'Mutation';
    updateReportTemplate?: {
        __typename?: 'UpdateReportTemplate';
        reportTemplate?:
            | ({ __typename?: 'ReportTemplateType' } & {
                  ' $fragmentRefs'?: {
                      ReportTemplateTypeFieldsFragment: ReportTemplateTypeFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type DeleteReportTemplateMutationVariables = Exact<{
    id: Scalars['ID']['input'];
    force?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteReportTemplateMutation = {
    __typename?: 'Mutation';
    deleteReportTemplate?: {
        __typename?: 'DeleteReportTemplate';
        reportTemplate?: { __typename?: 'ReportTemplateType'; id: string } | null;
        inUse?: {
            __typename?: 'ReportTemplateInUse';
            remainingCount: number;
            hiddenCount: number;
            canForce: boolean;
            usages: Array<{
                __typename?: 'ReportTemplateUsage';
                name: string;
                entityType: ReportTemplateEntityType;
                interval: ReportInterval;
            }>;
        } | null;
    } | null;
};

export type CustomReportTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type CustomReportTemplatesQuery = {
    __typename?: 'Query';
    reportTemplates?: {
        __typename?: 'ReportTemplateTypeConnection';
        edges: Array<{
            __typename?: 'ReportTemplateTypeEdge';
            node?: {
                __typename?: 'ReportTemplateType';
                id: string;
                name: string;
                entityType: ReportTemplateEntityType;
            } | null;
        } | null>;
    } | null;
};

export type SoundClipTypeFieldsFragment = {
    __typename?: 'SoundClipType';
    id: string;
    startTime: any;
    endTime: any;
    downloadUrl?: string | null;
    streamUrl?: string | null;
    triggerValue?: number | null;
    triggerSource?: SoundClipAlarmSource | null;
} & { ' $fragmentName'?: 'SoundClipTypeFieldsFragment' };

export type SoundClipsQueryVariables = Exact<{
    measuringPoint: Scalars['ID']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
    orderBy?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    after?: InputMaybe<Scalars['String']['input']>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SoundClipsQuery = {
    __typename?: 'Query';
    soundClips?: {
        __typename?: 'SoundClipTypeConnection';
        totalCount?: number | null;
        edges: Array<{
            __typename?: 'SoundClipTypeEdge';
            node?:
                | ({ __typename?: 'SoundClipType' } & {
                      ' $fragmentRefs'?: {
                          SoundClipTypeFieldsFragment: SoundClipTypeFieldsFragment;
                      };
                  })
                | null;
        } | null>;
        pageInfo: {
            __typename?: 'PageInfo';
            startCursor?: string | null;
            endCursor?: string | null;
        };
    } | null;
};

export type GetCustomAlarmIdsAndNamesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomAlarmIdsAndNamesQuery = {
    __typename?: 'Query';
    customAlarms?: {
        __typename?: 'CustomAlarmTypeConnection';
        edges: Array<{
            __typename?: 'CustomAlarmTypeEdge';
            node?: { __typename?: 'CustomAlarmType'; pk?: string | null; name: string } | null;
        } | null>;
    } | null;
};

export type TopBannerConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type TopBannerConfigsQuery = {
    __typename?: 'Query';
    topBannerConfigs: Array<{
        __typename?: 'TopBannerConfigType';
        id: string;
        campaignKey: string;
        cookieTtlDays: number;
        content: {
            __typename?: 'TopBannerContentType';
            prefixText: string;
            items: Array<{
                __typename?: 'TopBannerContentItemType';
                text: string;
                url?: string | null;
            }>;
            cta?: { __typename?: 'TopBannerContentCtaType'; text: string; url: string } | null;
        };
    }>;
};

export type AllMeasurementsBoundsQueryVariables = Exact<{
    measuringPointId: Scalars['Int']['input'];
}>;

export type AllMeasurementsBoundsQuery = {
    __typename?: 'Query';
    allMeasurementsBounds?: { __typename?: 'TimeSpan'; from?: any | null; to?: any | null } | null;
};

export type MeasuringPointCommentFieldsFragment = {
    __typename?: 'MeasuringPointCommentType';
    id: string;
    text: string;
    startTime?: any | null;
    endTime?: any | null;
    createdAt: string;
    editedAt?: string | null;
    measuringPointId?: string | null;
    parentId?: string | null;
    dataType?: DataType | null;
    user?: { __typename?: 'UserType'; id: string; username: string } | null;
} & { ' $fragmentName'?: 'MeasuringPointCommentFieldsFragment' };

export type MeasuringPointCommentsQueryVariables = Exact<{
    measuringPointId: Scalars['ID']['input'];
    withReplies: Scalars['Boolean']['input'];
}>;

export type MeasuringPointCommentsQuery = {
    __typename?: 'Query';
    measuringPointComments?: Array<
        | ({
              __typename?: 'MeasuringPointCommentType';
              replies?: Array<
                  { __typename?: 'MeasuringPointCommentType' } & {
                      ' $fragmentRefs'?: {
                          MeasuringPointCommentFieldsFragment: MeasuringPointCommentFieldsFragment;
                      };
                  }
              >;
          } & {
              ' $fragmentRefs'?: {
                  MeasuringPointCommentFieldsFragment: MeasuringPointCommentFieldsFragment;
              };
          })
        | null
    > | null;
};

export type MeasuringPointCommentQueryVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type MeasuringPointCommentQuery = {
    __typename?: 'Query';
    measuringPointComment?:
        | ({
              __typename?: 'MeasuringPointCommentType';
              replies: Array<
                  { __typename?: 'MeasuringPointCommentType' } & {
                      ' $fragmentRefs'?: {
                          MeasuringPointCommentFieldsFragment: MeasuringPointCommentFieldsFragment;
                      };
                  }
              >;
          } & {
              ' $fragmentRefs'?: {
                  MeasuringPointCommentFieldsFragment: MeasuringPointCommentFieldsFragment;
              };
          })
        | null;
};

export type CreateMeasuringPointCommentMutationVariables = Exact<{
    measuringPointId: Scalars['ID']['input'];
    text: Scalars['String']['input'];
    dataType: DataType;
    startTime: Scalars['BigInteger']['input'];
    endTime?: InputMaybe<Scalars['BigInteger']['input']>;
    parentId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateMeasuringPointCommentMutation = {
    __typename?: 'Mutation';
    createMeasuringPointComment?: {
        __typename?: 'CreateMeasuringPointComment';
        measuringPointComment?:
            | ({ __typename?: 'MeasuringPointCommentType' } & {
                  ' $fragmentRefs'?: {
                      MeasuringPointCommentFieldsFragment: MeasuringPointCommentFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type UpdateMeasuringPointCommentMutationVariables = Exact<{
    id: Scalars['ID']['input'];
    text: Scalars['String']['input'];
}>;

export type UpdateMeasuringPointCommentMutation = {
    __typename?: 'Mutation';
    updateMeasuringPointComment?: {
        __typename?: 'UpdateMeasuringPointComment';
        measuringPointComment?:
            | ({ __typename?: 'MeasuringPointCommentType' } & {
                  ' $fragmentRefs'?: {
                      MeasuringPointCommentFieldsFragment: MeasuringPointCommentFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type DeleteMeasuringPointCommentMutationVariables = Exact<{
    id: Scalars['ID']['input'];
}>;

export type DeleteMeasuringPointCommentMutation = {
    __typename?: 'Mutation';
    deleteMeasuringPointComment?: {
        __typename?: 'DeleteMeasuringPointComment';
        measuringPointComment?:
            | ({ __typename?: 'MeasuringPointCommentType' } & {
                  ' $fragmentRefs'?: {
                      MeasuringPointCommentFieldsFragment: MeasuringPointCommentFieldsFragment;
                  };
              })
            | null;
    } | null;
};

export type SoundAnalysisQueryVariables = Exact<{
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
}>;

export type SoundAnalysisQuery = {
    __typename?: 'Query';
    soundAnalysis?: {
        __typename?: 'SoundAnalysis';
        startTime?: any | null;
        endTime?: any | null;
        lXEq?: number | null;
        lXtMin?: number | null;
        lXtMax?: number | null;
        lXPeak?: number | null;
        lXn?: Array<{
            __typename?: 'LXNValue';
            value?: number | null;
            timePercent?: number | null;
        } | null> | null;
    } | null;
};

export type GetHubSpotIdentificationTokenQueryVariables = Exact<{ [key: string]: never }>;

export type GetHubSpotIdentificationTokenQuery = {
    __typename?: 'Query';
    hubspotIdentificationToken?: string | null;
};

export type StoreGraphStateMutationVariables = Exact<{
    measuringPointId: Scalars['Int']['input'];
    startTime: Scalars['BigInteger']['input'];
    endTime: Scalars['BigInteger']['input'];
}>;

export type StoreGraphStateMutation = {
    __typename?: 'Mutation';
    storeGraphState?: { __typename?: 'StoreGraphState'; ok?: boolean | null } | null;
};

export type WalkthroughFieldsFragment = {
    __typename?: 'Walkthrough';
    name?: string | null;
    status?: WalkthroughStatus | null;
    step?: string | null;
} & { ' $fragmentName'?: 'WalkthroughFieldsFragment' };

export type WalkthroughsQueryVariables = Exact<{ [key: string]: never }>;

export type WalkthroughsQuery = {
    __typename?: 'Query';
    walkthroughs?: Array<
        | ({ __typename?: 'Walkthrough' } & {
              ' $fragmentRefs'?: { WalkthroughFieldsFragment: WalkthroughFieldsFragment };
          })
        | null
    > | null;
};

export type UpdateWalkthroughStateMutationVariables = Exact<{
    name: Scalars['String']['input'];
    status?: InputMaybe<WalkthroughStatus>;
    step?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateWalkthroughStateMutation = {
    __typename?: 'Mutation';
    updateWalkthroughState?:
        | ({ __typename?: 'Walkthrough' } & {
              ' $fragmentRefs'?: { WalkthroughFieldsFragment: WalkthroughFieldsFragment };
          })
        | null;
};

export const GraphReportTypeFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GraphReportTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GraphReportType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GraphReportTypeFieldsFragment, unknown>;
export const ContactFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ContactFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ContactFieldsFragment, unknown>;
export const AttributeAssetFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AttributeAssetFieldsFragment, unknown>;
export const AttributeEntryFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeEntryFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeEntryInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageList' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AttributeEntryFieldsFragment, unknown>;
export const CustomAlarmTypeFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CustomAlarmTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomAlarmType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'points' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'freq' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'vkar' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CustomAlarmTypeFieldsFragment, unknown>;
export const GraphReportsTypeFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GraphReportsTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GraphReportType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastDownloaded' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GraphReportsTypeFieldsFragment, unknown>;
export const SwarmFeaturesFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SwarmFeaturesFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SwarmFeatures' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'validSubscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canActivateSubscription' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unavailableFeatures' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'option' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'showBanner' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SwarmFeaturesFieldsFragment, unknown>;
export const NotificationTypeFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'NotificationTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'NotificationType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLegacy' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<NotificationTypeFieldsFragment, unknown>;
export const MeasuringPointFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'directShare' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MeasuringPointFieldsFragment, unknown>;
export const AirMeasuringPointFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AirMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AirMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'directShare' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AirMeasuringPointFieldsFragment, unknown>;
export const VibrationMeasuringPointFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'VibrationMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'directShare' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<VibrationMeasuringPointFieldsFragment, unknown>;
export const SoundMeasuringPointFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SoundMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SoundMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'directShare' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SoundMeasuringPointFieldsFragment, unknown>;
export const PartialConfigSummaryFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PartialConfigSummary' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PartialConfigType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partialConfigType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PartialConfigSummaryFragment, unknown>;
export const ReportTemplateTypeFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReportTemplateTypeFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ReportTemplateType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageOrientation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageMargin' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'structure' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ReportTemplateTypeFieldsFragment, unknown>;
export const SoundClipTypeFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SoundClipTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SoundClipType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'streamUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'triggerValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'triggerSource' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SoundClipTypeFieldsFragment, unknown>;
export const MeasuringPointCommentFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointCommentType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'measuringPointId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MeasuringPointCommentFieldsFragment, unknown>;
export const WalkthroughFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WalkthroughFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Walkthrough' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<WalkthroughFieldsFragment, unknown>;
export const CreateGraphReportDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'createGraphReport' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileType' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'FileType' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ReportTemplateEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parameters' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ParametersInput' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'sendEmailNotification' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createGraphReport' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fileType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'fileType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parameters' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'parameters' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'sendEmailNotification' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'sendEmailNotification' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'graphReport' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'GraphReportTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GraphReportTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GraphReportType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateGraphReportMutation, CreateGraphReportMutationVariables>;
export const ReportTemplatesLegacyDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'reportTemplatesLegacy' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportTemplatesLegacy' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ReportTemplatesLegacyQuery, ReportTemplatesLegacyQueryVariables>;
export const GetMeasuringPointsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getMeasuringPoints' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'swarmType' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'SwarmType' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'measuringPoints' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: { kind: 'BooleanValue', value: false },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'swarmType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'swarmType' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AirMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'project' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'deviceName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timezone' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'project' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'deviceName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timezone' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'SoundMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'project' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'deviceName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timezone' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projects' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: { kind: 'BooleanValue', value: false },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'swarmType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'swarmType' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AirProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timezone' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'SoundProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timezone' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'VibrationProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timezone' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMeasuringPointsQuery, GetMeasuringPointsQueryVariables>;
export const GraphReportsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'graphReports' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'graphReports' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'ids' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'readyReportsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'GraphReportTypeFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GraphReportTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GraphReportType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GraphReportsQuery, GraphReportsQueryVariables>;
export const UpdateGraphReportLastDownloadedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateGraphReportLastDownloaded' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateGraphReportLastDownloaded' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'graphReport' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'GraphReportTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GraphReportTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GraphReportType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    UpdateGraphReportLastDownloadedMutation,
    UpdateGraphReportLastDownloadedMutationVariables
>;
export const ContactsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Contacts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderBy' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'search' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'search' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'ContactFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'startCursor' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endCursor' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ContactFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ContactsQuery, ContactsQueryVariables>;
export const CreateContactDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateContact' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CreateContactInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createContact' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contact' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ContactFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'field' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'message' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ContactFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateContact' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'UpdateContactInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateContact' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contact' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ContactFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'field' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'message' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ContactFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteContact' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'DeleteContactInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteContact' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contact' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ContactFields' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'field' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'message' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ContactFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteContactMutation, DeleteContactMutationVariables>;
export const AttributesPageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AttributesPage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributesEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'keys' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'includeMeasuringPoint' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeProject' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributesByEntity' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'keys' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'keys' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'AttributeEntryFields' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'measuringPointById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                        ],
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: {
                                            kind: 'Variable',
                                            name: { kind: 'Name', value: 'includeMeasuringPoint' },
                                        },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'MeasuringPointInterface' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AirMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'SoundMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projectById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                        ],
                        directives: [
                            {
                                kind: 'Directive',
                                name: { kind: 'Name', value: 'include' },
                                arguments: [
                                    {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'if' },
                                        value: {
                                            kind: 'Variable',
                                            name: { kind: 'Name', value: 'includeProject' },
                                        },
                                    },
                                ],
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'ProjectInterface' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AirProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'SoundProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'VibrationProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permission' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeEntryFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeEntryInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageList' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AttributesPageQuery, AttributesPageQueryVariables>;
export const SetAttributeTextDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SetAttributeText' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributesEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'textValue' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setAttributeText' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'key' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'textValue' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'textValue' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributeEntry' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeEntryFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeEntryFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeEntryInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageList' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SetAttributeTextMutation, SetAttributeTextMutationVariables>;
export const CreateAttributeDefinitionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateAttributeDefinition' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributesEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'valueType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributeValueType' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createAttributeDefinition' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'label' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'valueType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'valueType' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributeEntry' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeEntryFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeEntryFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeEntryInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageList' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CreateAttributeDefinitionMutation,
    CreateAttributeDefinitionMutationVariables
>;
export const SetAttributeAssetCaptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SetAttributeAssetCaption' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributesEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'caption' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setAttributeAssetCaption' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'key' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'assetId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'assetId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'caption' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'caption' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributeEntry' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeEntryFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeEntryFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeEntryInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageList' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    SetAttributeAssetCaptionMutation,
    SetAttributeAssetCaptionMutationVariables
>;
export const ReorderAttributeImagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ReorderAttributeImages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributesEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reorderAttributeImages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'key' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'assetIds' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'assetIds' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributeEntry' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeEntryFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeEntryFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeEntryInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageList' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ReorderAttributeImagesMutation,
    ReorderAttributeImagesMutationVariables
>;
export const DeleteAttributeAssetDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteAttributeAsset' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributesEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteAttributeAsset' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'key' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'assetId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'assetId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributeEntry' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeEntryFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeAssetFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttributeAsset' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AttributeEntryFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AttributeEntryInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'textValue' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageList' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AttributeAssetFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteAttributeAssetMutation, DeleteAttributeAssetMutationVariables>;
export const GetCustomAlarmsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetCustomAlarms' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customAlarms' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'CustomAlarmTypeFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CustomAlarmTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomAlarmType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'points' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'freq' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'vkar' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetCustomAlarmsQuery, GetCustomAlarmsQueryVariables>;
export const GetCustomAlarmDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetCustomAlarm' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customAlarm' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CustomAlarmTypeFields' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CustomAlarmTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomAlarmType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'points' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'freq' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'vkar' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetCustomAlarmQuery, GetCustomAlarmQueryVariables>;
export const CustomAlarmCreateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'customAlarmCreate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CustomAlarmCreateMutationInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customAlarmCreate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customAlarm' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'CustomAlarmTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'field' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'message' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CustomAlarmTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomAlarmType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'points' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'freq' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'vkar' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CustomAlarmCreateMutation, CustomAlarmCreateMutationVariables>;
export const CustomAlarmUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'customAlarmUpdate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CustomAlarmUpdateMutationInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customAlarmUpdate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customAlarm' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'CustomAlarmTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'field' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'message' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CustomAlarmTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomAlarmType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'points' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'freq' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'vkar' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CustomAlarmUpdateMutation, CustomAlarmUpdateMutationVariables>;
export const CustomAlarmDeleteDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'customAlarmDelete' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CustomAlarmDeleteMutationInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customAlarmDelete' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'customAlarm' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'field' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'message' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CustomAlarmDeleteMutation, CustomAlarmDeleteMutationVariables>;
export const DownloadsGraphReportsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'downloadsGraphReports' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'graphReports' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderBy' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'before' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'before' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'last' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'ids' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'readyReportsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'GraphReportsTypeFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'startCursor' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endCursor' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GraphReportsTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GraphReportType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastDownloaded' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DownloadsGraphReportsQuery, DownloadsGraphReportsQueryVariables>;
export const DownloadsUpdateGraphReportLastDownloadedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'downloadsUpdateGraphReportLastDownloaded' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateGraphReportLastDownloaded' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'graphReport' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'GraphReportsTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GraphReportsTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GraphReportType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastDownloaded' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    DownloadsUpdateGraphReportLastDownloadedMutation,
    DownloadsUpdateGraphReportLastDownloadedMutationVariables
>;
export const GetMapMarkersDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetMapMarkers' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'scope' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'MapScope' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'useDeviceGps' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mapMarkers' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'scope' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'scope' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'archived' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'offset' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'useDeviceGps' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'useDeviceGps' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'markers' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'measuringPointId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'ownerUserId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'latitude' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'longitude' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMapMarkersQuery, GetMapMarkersQueryVariables>;
export const RegisterNyDepDeviceDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RegisterNyDepDevice' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registerNyDepDevice' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<RegisterNyDepDeviceMutation, RegisterNyDepDeviceMutationVariables>;
export const GetNyDepIntegrationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetNyDepIntegration' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nyDepIntegration' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'registrationStatus' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'registrationErrorCode' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetNyDepIntegrationQuery, GetNyDepIntegrationQueryVariables>;
export const CanActivateSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'canActivateSubscription' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'deviceName' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canActivateSubscription' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'deviceName' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'deviceName' },
                                },
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CanActivateSubscriptionQuery, CanActivateSubscriptionQueryVariables>;
export const ActivateSubscriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'activateSubscription' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'deviceName' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activateSubscription' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'deviceName' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'deviceName' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>;
export const FeatureCheckSwarmDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'featureCheckSwarm' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'deviceName' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featureCheckSwarm' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'deviceName' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'deviceName' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'SwarmFeaturesFields' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SwarmFeaturesFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SwarmFeatures' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'validSubscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canActivateSubscription' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unavailableFeatures' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'option' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'showBanner' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<FeatureCheckSwarmQuery, FeatureCheckSwarmQueryVariables>;
export const FeatureCheckProjectDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'featureCheckProject' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featureCheckProject' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'projectId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'projectId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'SwarmFeaturesFields' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SwarmFeaturesFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SwarmFeatures' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'validSubscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'canActivateSubscription' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unavailableFeatures' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'option' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'showBanner' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<FeatureCheckProjectQuery, FeatureCheckProjectQueryVariables>;
export const NotificationsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'notifications' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'levels' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'NotificationLevel' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdAt_Gte' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdAt_Lte' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'mpPk' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifications' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderBy' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'before' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'before' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'last' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'levels' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'levels' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'search' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'search' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'createdAt_Gte' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'createdAt_Gte' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'createdAt_Lte' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'createdAt_Lte' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mpPk' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'mpPk' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'NotificationTypeFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'startCursor' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endCursor' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'NotificationTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'NotificationType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLong' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLegacy' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const GetProjectCatalogDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetProjectCatalog' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projectCatalog' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'archived' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'search' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'search' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderBy' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'maxStarredProjects' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'starredCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'hasAnyData' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'summaries' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'skip' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: {
                                                        kind: 'Variable',
                                                        name: { kind: 'Name', value: 'archived' },
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'projectId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'online' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'offline' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'inactive' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'dataWarnings' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'count' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'devices',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'measuringPointId',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'deviceName',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'usagePercentage',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'isLimit',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'recentExceedances' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'count' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'events' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'measuringPointId',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'deviceName',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'occurredAt',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'pk' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'city' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'swarmType',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'archived',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'permission',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'measuringPointCount',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'isStarred',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetProjectCatalogQuery, GetProjectCatalogQueryVariables>;
export const GetStandaloneMeasuringPointsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetStandaloneMeasuringPoints' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'standaloneMeasuringPoints' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'archived' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'search' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'search' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderBy' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'AirMeasuringPoint',
                                                    },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'AirMeasuringPointFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'VibrationMeasuringPoint',
                                                    },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'VibrationMeasuringPointFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'SoundMeasuringPoint',
                                                    },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'SoundMeasuringPointFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'directShare' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AirMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AirMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'VibrationMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SoundMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SoundMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetStandaloneMeasuringPointsQuery,
    GetStandaloneMeasuringPointsQueryVariables
>;
export const GetOverviewProjectMeasuringPointsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetOverviewProjectMeasuringPoints' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'measuringPoints' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'archived' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'projectIds' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'projectIds' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AirMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'AirMeasuringPointFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'VibrationMeasuringPointFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'SoundMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'SoundMeasuringPointFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'directShare' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AirMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AirMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'VibrationMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SoundMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SoundMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetOverviewProjectMeasuringPointsQuery,
    GetOverviewProjectMeasuringPointsQueryVariables
>;
export const GetPastSensorsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetPastSensors' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'measuringPointById' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'AirMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pastSensors' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'sensorPk',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'simpleName',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'calibrationReportUrl',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pastSensors' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'sensorPk',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'simpleName',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'calibrationReportUrl',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'SoundMeasuringPoint' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pastSensors' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'sensorPk',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'simpleName',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'calibrationReportUrl',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetPastSensorsQuery, GetPastSensorsQueryVariables>;
export const SetMeasuringPointArchivedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SetMeasuringPointArchived' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setMeasuringPointArchived' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'archived' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    SetMeasuringPointArchivedMutation,
    SetMeasuringPointArchivedMutationVariables
>;
export const SoftDeleteMeasuringPointDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SoftDeleteMeasuringPoint' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'softDeleteMeasuringPoint' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    SoftDeleteMeasuringPointMutation,
    SoftDeleteMeasuringPointMutationVariables
>;
export const RequestMeasuringPointSensorActionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'RequestMeasuringPointSensorAction' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'action' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'MeasuringPointSensorAction' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestMeasuringPointSensorAction' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'action' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'action' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    RequestMeasuringPointSensorActionMutation,
    RequestMeasuringPointSensorActionMutationVariables
>;
export const OverviewDetachSensorFromMeasuringPointDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'OverviewDetachSensorFromMeasuringPoint' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'detachSensorFromMeasuringPoint' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'measuringPoint' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'AirMeasuringPoint',
                                                    },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'AirMeasuringPointFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'VibrationMeasuringPoint',
                                                    },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'VibrationMeasuringPointFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'SoundMeasuringPoint',
                                                    },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'SoundMeasuringPointFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointInterface' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'directShare' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AirMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'AirMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'VibrationMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'VibrationMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SoundMeasuringPointFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SoundMeasuringPoint' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MeasuringPointFields' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'project' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deviceName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'overriddenFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sensor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'online' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastContact' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'batteryCharge' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'batteryChargeLastUpdate' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasValidSubscription' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasDataUsageInfo' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dataQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsUsed' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'smsLimit' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'smsQuota' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'percent' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isWarning' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isLimit' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hasPendingFirmwareUpgrade' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firmwareUpgradePercentage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRotating' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRestarting' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    OverviewDetachSensorFromMeasuringPointMutation,
    OverviewDetachSensorFromMeasuringPointMutationVariables
>;
export const SetProjectArchivedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SetProjectArchived' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'archived' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setProjectArchived' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'archived' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'archived' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SetProjectArchivedMutation, SetProjectArchivedMutationVariables>;
export const SoftDeleteProjectDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SoftDeleteProject' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'softDeleteProject' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SoftDeleteProjectMutation, SoftDeleteProjectMutationVariables>;
export const ToggleProjectStarDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'ToggleProjectStar' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'toggleProjectStar' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isStarred' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ToggleProjectStarMutation, ToggleProjectStarMutationVariables>;
export const UndoMyMeasuringPointShareDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UndoMyMeasuringPointShare' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'undoMyMeasuringPointShare' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    UndoMyMeasuringPointShareMutation,
    UndoMyMeasuringPointShareMutationVariables
>;
export const UndoMyProjectShareDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UndoMyProjectShare' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'undoMyProjectShare' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'projectId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'projectId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UndoMyProjectShareMutation, UndoMyProjectShareMutationVariables>;
export const PartialConfigDetailDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PartialConfigDetail' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'partialConfig' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PartialConfigSummary' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'config' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PartialConfigSummary' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PartialConfigType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partialConfigType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PartialConfigDetailQuery, PartialConfigDetailQueryVariables>;
export const PartialConfigOverviewDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PartialConfigOverview' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'swarmType' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'SwarmType' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'partialConfigType' },
                    },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'PartialConfigCategory' },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'partialConfigs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'swarmType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'swarmType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'partialConfigType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'partialConfigType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'search' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'search' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'cursor' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'PartialConfigSummary',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endCursor' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'hasNextPage' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PartialConfigSummary' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PartialConfigType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'swarmType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'partialConfigType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PartialConfigOverviewQuery, PartialConfigOverviewQueryVariables>;
export const PurchaseOrderRequestDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'purchaseOrderRequest' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'purchaseOrderRequest' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'token' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'poNumber' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isExpired' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'invoiceReference' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subscriptionNames' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<PurchaseOrderRequestQuery, PurchaseOrderRequestQueryVariables>;
export const SubmitPurchaseOrderNumberDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'submitPurchaseOrderNumber' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'poNumber' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submitPurchaseOrderNumber' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'token' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'poNumber' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'poNumber' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'ok' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'request' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'poNumber' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isExpired' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'invoiceReference' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'subscriptionNames' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    SubmitPurchaseOrderNumberMutation,
    SubmitPurchaseOrderNumberMutationVariables
>;
export const AlarmExceedancesRuntimeDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AlarmExceedancesRuntimeData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alarmExceedances' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'alarms' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'triggerPct' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'triggerMm' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'counts' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'isFlatLine' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timestamp' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'x' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'fdom' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'vtop' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'y' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'fdom' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'vtop' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'z' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'fdom' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'vtop' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'vector' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'fdom' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'vtop' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'limitReached' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limitReachedValue' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    AlarmExceedancesRuntimeDataQuery,
    AlarmExceedancesRuntimeDataQueryVariables
>;
export const ReportBuilderAttributeRuntimeDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ReportBuilderAttributeRuntimeData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AttributesEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'keys' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributesByEntity' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'keys' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'keys' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'ids' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'definitionId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'TextAttributeEntry' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'textValue' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'ImageAttributeEntry' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'url' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'caption',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'ImageListAttributeEntry' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'imageList' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'url' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'caption',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'sortOrder',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ReportBuilderAttributeRuntimeDataQuery,
    ReportBuilderAttributeRuntimeDataQueryVariables
>;
export const ReportBuilderLastGraphStateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'reportBuilderLastGraphState' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastGraphState' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'measuringPointIds' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ReportBuilderLastGraphStateQuery,
    ReportBuilderLastGraphStateQueryVariables
>;
export const MeasuringPointLeqAlarmExceedancesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MeasuringPointLeqAlarmExceedances' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leqAlarmExceedances' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'startTime' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endTime' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'alarmInterval' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'alarmLevel' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'alarms' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'alarmInterval' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'alarmLevel' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'counts' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limitReachedValue' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MeasuringPointLeqAlarmExceedancesQuery,
    MeasuringPointLeqAlarmExceedancesQueryVariables
>;
export const MeasuringPointLmaxAlarmExceedancesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MeasuringPointLmaxAlarmExceedances' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lmaxAlarmExceedances' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entries' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'startTime' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endTime' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'alarmLevel' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'alarms' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'alarmLevel' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'counts' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'limitReachedValue' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MeasuringPointLmaxAlarmExceedancesQuery,
    MeasuringPointLmaxAlarmExceedancesQueryVariables
>;
export const MeasuringPointLxnValuesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MeasuringPointLxnValues' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'percentiles' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lxnValues' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'percentiles' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'percentiles' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timestamp' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'l10' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'l50' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'l90' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MeasuringPointLxnValuesQuery, MeasuringPointLxnValuesQueryVariables>;
export const MeasurementSettingsRuntimeDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MeasurementSettingsRuntimeData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'measurementSettings' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    MeasurementSettingsRuntimeDataQuery,
    MeasurementSettingsRuntimeDataQueryVariables
>;
export const ReportBuilderProfileLogoRuntimeDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ReportBuilderProfileLogoRuntimeData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ReportTemplateEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportProfileLogo' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    ReportBuilderProfileLogoRuntimeDataQuery,
    ReportBuilderProfileLogoRuntimeDataQueryVariables
>;
export const ReportTemplatesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ReportTemplates' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportTemplates' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderBy' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'before' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'before' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'last' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'ids' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'ReportTemplateTypeFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'startCursor' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endCursor' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReportTemplateTypeFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ReportTemplateType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageOrientation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageMargin' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'structure' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ReportTemplatesQuery, ReportTemplatesQueryVariables>;
export const CreateReportTemplateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateReportTemplate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ReportTemplateEntityType' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createReportTemplate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'entityType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'entityType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reportTemplate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ReportTemplateTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReportTemplateTypeFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ReportTemplateType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageOrientation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageMargin' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'structure' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>;
export const DuplicateReportTemplateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DuplicateReportTemplate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'duplicateReportTemplate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reportTemplate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ReportTemplateTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReportTemplateTypeFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ReportTemplateType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageOrientation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageMargin' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'structure' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    DuplicateReportTemplateMutation,
    DuplicateReportTemplateMutationVariables
>;
export const UpdateReportTemplateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateReportTemplate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'structure' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSONString' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ReportTemplatePageSize' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'pageOrientation' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ReportTemplatePageOrientation' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageMargin' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ReportTemplatePageMarginInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateReportTemplate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'structure' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'structure' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pageSize' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pageSize' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pageOrientation' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pageOrientation' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pageMargin' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pageMargin' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reportTemplate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'ReportTemplateTypeFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ReportTemplateTypeFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ReportTemplateType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'pageOrientation' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageMargin' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'structure' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'permission' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isSystem' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>;
export const DeleteReportTemplateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteReportTemplate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'force' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteReportTemplate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'force' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'force' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reportTemplate' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'inUse' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'usages' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'entityType',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'interval',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'remainingCount' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'hiddenCount' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'canForce' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteReportTemplateMutation, DeleteReportTemplateMutationVariables>;
export const CustomReportTemplatesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'CustomReportTemplates' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportTemplates' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'IntValue', value: '100' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'entityType',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<CustomReportTemplatesQuery, CustomReportTemplatesQueryVariables>;
export const SoundClipsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'soundClips' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'measuringPoint' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'soundClips' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPoint' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPoint' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'orderBy' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'before' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'before' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'last' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'SoundClipTypeFields',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'startCursor' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'endCursor' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SoundClipTypeFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SoundClipType' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'streamUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'triggerValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'triggerSource' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SoundClipsQuery, SoundClipsQueryVariables>;
export const GetCustomAlarmIdsAndNamesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetCustomAlarmIdsAndNames' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customAlarms' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'pk' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetCustomAlarmIdsAndNamesQuery,
    GetCustomAlarmIdsAndNamesQueryVariables
>;
export const TopBannerConfigsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'TopBannerConfigs' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topBannerConfigs' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'content' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'prefixText' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'items' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'text' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'url' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'cta' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'text' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'url' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'campaignKey' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'cookieTtlDays' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<TopBannerConfigsQuery, TopBannerConfigsQueryVariables>;
export const AllMeasurementsBoundsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'AllMeasurementsBounds' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allMeasurementsBounds' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<AllMeasurementsBoundsQuery, AllMeasurementsBoundsQueryVariables>;
export const MeasuringPointCommentsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'measuringPointComments' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'withReplies' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'measuringPointComments' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'replies' },
                                    directives: [
                                        {
                                            kind: 'Directive',
                                            name: { kind: 'Name', value: 'include' },
                                            arguments: [
                                                {
                                                    kind: 'Argument',
                                                    name: { kind: 'Name', value: 'if' },
                                                    value: {
                                                        kind: 'Variable',
                                                        name: {
                                                            kind: 'Name',
                                                            value: 'withReplies',
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'MeasuringPointCommentFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointCommentType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'measuringPointId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MeasuringPointCommentsQuery, MeasuringPointCommentsQueryVariables>;
export const MeasuringPointCommentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'measuringPointComment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'measuringPointComment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'replies' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'MeasuringPointCommentFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointCommentType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'measuringPointId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MeasuringPointCommentQuery, MeasuringPointCommentQueryVariables>;
export const CreateMeasuringPointCommentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateMeasuringPointComment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'dataType' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'DataType' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'parentId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createMeasuringPointComment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'text' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'dataType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'dataType' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'parentId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'parentId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'measuringPointComment' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'MeasuringPointCommentFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointCommentType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'measuringPointId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    CreateMeasuringPointCommentMutation,
    CreateMeasuringPointCommentMutationVariables
>;
export const UpdateMeasuringPointCommentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'UpdateMeasuringPointComment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateMeasuringPointComment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'text' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'measuringPointComment' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'MeasuringPointCommentFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointCommentType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'measuringPointId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    UpdateMeasuringPointCommentMutation,
    UpdateMeasuringPointCommentMutationVariables
>;
export const DeleteMeasuringPointCommentDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DeleteMeasuringPointComment' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteMeasuringPointComment' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'measuringPointComment' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'MeasuringPointCommentFields',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MeasuringPointCommentFields' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MeasuringPointCommentType' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'editedAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'measuringPointId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataType' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    DeleteMeasuringPointCommentMutation,
    DeleteMeasuringPointCommentMutationVariables
>;
export const SoundAnalysisDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'soundAnalysis' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'soundAnalysis' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lXEq' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lXtMin' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lXtMax' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lXPeak' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lXn' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'timePercent' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SoundAnalysisQuery, SoundAnalysisQueryVariables>;
export const GetHubSpotIdentificationTokenDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getHubSpotIdentificationToken' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'hubspotIdentificationToken' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    GetHubSpotIdentificationTokenQuery,
    GetHubSpotIdentificationTokenQueryVariables
>;
export const StoreGraphStateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'storeGraphState' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'measuringPointId' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInteger' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'storeGraphState' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'measuringPointId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'measuringPointId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'startTime' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'endTime' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'endTime' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ok' } }],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<StoreGraphStateMutation, StoreGraphStateMutationVariables>;
export const WalkthroughsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'walkthroughs' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'walkthroughs' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'WalkthroughFields' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WalkthroughFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Walkthrough' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<WalkthroughsQuery, WalkthroughsQueryVariables>;
export const UpdateWalkthroughStateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateWalkthroughState' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'WalkthroughStatus' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'step' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateWalkthroughState' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'name' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'status' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'status' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'step' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'step' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'WalkthroughFields' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WalkthroughFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Walkthrough' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'step' } },
                ],
            },
        },
    ],
} as unknown as DocumentNode<
    UpdateWalkthroughStateMutation,
    UpdateWalkthroughStateMutationVariables
>;
